// Epuyén Renace - Complete Internationalization (i18n)
// Languages: Spanish (es), English (en), Arabic (ar), Japanese (ja)

const translations = {
  es: {
    // Navigation
    nav: {
      home: "Inicio",
      map: "Mapa",
      adopt: "Adoptar",
      myForest: "Mi Bosque",
      transparency: "Transparencia",
      admin: "Admin",
      login: "Iniciar Sesión",
      logout: "Cerrar Sesión",
      more: "Más",
      community: "Comunidad",
      education: "Educación",
      governance: "Transparencia",
      vision: "Nuestra Visión"
    },
    vision: {
      badge: "Nuestra Visión",
      title: "Nuestra Visión",
      opening: "Nuestra visión es demostrar al mundo que es posible reconstruir un lugar que ha sido destruido ecológicamente — a través de transparencia, estructura y acción colectiva.",
      whatWeAre: {
        title: "Qué es Epuyén Renace",
        description: "Epuyén Renace existe para crear un modelo de regeneración post-incendio: un sistema donde la recuperación de tierras, la restauración ecológica y el desarrollo comunitario son impulsados por datos verificables en lugar de confianza ciega."
      },
      transparency: {
        title: "Transparencia Blockchain",
        description: "Al usar tecnología blockchain como capa de transparencia, cada contribución, cada gasto y cada acción puede ser rastreada públicamente. No para especular — sino para restaurar la confianza en cómo se financian y ejecutan los esfuerzos de recuperación."
      },
      belief: {
        title: "Lo Que Creemos",
        description: "Creemos que cuando la transparencia reemplaza la corrupción y la estructura reemplaza la improvisación, las comunidades pueden levantarse de nuevo — incluso después de una pérdida ambiental total."
      },
      goal: {
        title: "Nuestra Meta",
        description: "Nuestro objetivo no es solo restaurar Epuyén, sino demostrar que un nuevo modelo económico para la recuperación ecológica es posible — uno que puede replicarse en regiones afectadas por incendios en todo el mundo."
      },
      closing: {
        line1: "De las cenizas, un sistema puede reconstruirse.",
        line2: "De la destrucción, un futuro puede diseñarse."
      }
    },
    // Landing Page
    landing: {
      heroTitle: "Renace con Epuyén",
      heroSubtitle: "Adopta un árbol. Restaura la Patagonia.",
      heroCta: "Adoptar un Árbol",
      heroExplore: "Explorar el Mapa",
      viewRoadmap: "Ver la Hoja de Ruta",
      missionTitle: "Nuestra Misión",
      missionText: "Restaurar los bosques nativos de la Patagonia Argentina mediante la reforestación comunitaria y la tecnología de transparencia radical.",
      restoringPatagonia: "Restaurando la",
      patagonia: "Patagonia",
      howItWorksTitle: "¿Cómo Funciona?",
      simpleProcess: "Proceso Simple",
      step1Title: "Explora el Mapa",
      step1Text: "Navega por nuestro mapa interactivo y selecciona un árbol disponible para adoptar.",
      step2Title: "Adopta tu Árbol",
      step2Text: "Realiza tu donación y recibe un token único con las coordenadas GPS de tu árbol.",
      step3Title: "Sigue su Crecimiento",
      step3Text: "Recibe actualizaciones con fotos y seguimiento del progreso de tu árbol.",
      impactTitle: "Nuestro Impacto",
      treesPlanted: "Árboles Plantados",
      treesAdopted: "Árboles Adoptados",
      donorsCount: "Donantes",
      co2Offset: "Tons CO₂ Compensadas",
      transparencyTitle: "Transparencia Total",
      transparencyText: "Cada donación y gasto es públicamente verificable. Sin secretos, solo resultados.",
      viewTransparency: "Ver Registro Público",
      footerTagline: "Restaurando la Patagonia, un árbol a la vez.",
      // What Happened Section
      whatHappened: {
        title: "¿Qué Pasó en Epuyén?",
        year: "En 2025 y 2026, Epuyén fue golpeada por los peores incendios forestales de su historia.",
        hectares: "Más de 9,000 hectáreas de bosque nativo andino fueron destruidas.",
        ecosystems: "Ecosistemas enteros ardieron.",
        homes: "Hogares fueron perdidos.",
        wildlife: "La fauna desapareció.",
        landExposed: "La tierra quedó expuesta, seca y vulnerable.",
        balanceBroken: "Los incendios no solo consumieron árboles — rompieron el equilibrio natural que protege el agua, el suelo y el clima. Sin cobertura forestal, las lluvias disminuyen, la erosión aumenta, y el riesgo de futuros incendios se vuelve aún mayor.",
        minimalEfforts: "A pesar de la magnitud del desastre, los esfuerzos de recuperación fueron mínimos. No hubo un plan integral de restauración ecológica, ni estrategia de prevención a largo plazo, ni programa de reconstrucción estructural.",
        peopleStayed: "La gente de Epuyén se quedó. Se quedó para cuidar, resistir y volver a empezar.",
        todayScars: "Hoy, la tierra aún lleva las cicatrices — pero también la posibilidad de regeneración.",
        epuyenCreated: "Epuyén Renace fue creado para transformar la tragedia en estructura: restaurar los bosques nativos, reducir el riesgo de incendios, reconstruir el equilibrio ecológico y asegurar que esto nunca vuelva a suceder.",
        fromAshes: "De las cenizas no surge el azar: el futuro se construye con intención, verdad y comunidad."
      },
      coreChallenges: {
        title: "Los Desafíos Principales",
        mainChallenge: "El principal desafío en Epuyén es el despinado — la remoción a gran escala de especies de pinos invasores que han invadido el paisaje.",
        effectiveMethod: "A través de experiencia de campo y pruebas, hemos identificado el método más efectivo: triturar el pino en el lugar, permitiendo que el material orgánico regenere el suelo en lugar de removerlo o quemarlo.",
        processRestores: "Este proceso restaura la humedad, mejora la estructura del suelo y crea condiciones inmediatas para la recuperación del bosque nativo.",
        parallelReplanting: "Al mismo tiempo, la replantación comienza en paralelo. La remoción y la regeneración deben ocurrir juntas — no años después — para prevenir la erosión y la recolonización por especies invasoras.",
        secondMission: "Nuestra segunda misión principal es la prevención de incendios y la reducción del riesgo futuro.",
        moreThanPlanting: "Esto requiere más que plantar árboles. Exige capacidad operativa permanente, incluyendo la adquisición de equipos especializados capaces de trabajar en terrenos difíciles y responder rápidamente a amenazas de incendio.",
        foundationInvest: "Para lograr esto, la fundación debe invertir en:",
        investList: {
          machinery: "Maquinaria forestal y de trituración",
          equipment: "Equipos accesibles para terrenos difíciles",
          tools: "Herramientas para reducción de carga de combustible y mantenimiento",
          infrastructure: "Infraestructura de prevención a largo plazo"
        },
        withoutEquipment: "Sin este equipo, la regeneración permanece frágil y el ciclo de destrucción se repite.",
        breakCycle: "Epuyén Renace existe para romper ese ciclo — restaurando la tierra, reduciendo el riesgo de incendios y construyendo un sistema permanente de prevención para el futuro."
      },
      donationCategories: {
        title: "Categorías de Donación",
        subtitle: "Elige exactamente cómo quieres que se use tu contribución",
        cta: {
          supportMission: "Apoya Esta Misión",
          ctaDescription: "Cada donación se destina directamente a la adquisición de equipos y a completar estas fases. Todos los gastos se documentan públicamente con fotos, recibos y datos GPS.",
          donateToCategory: "Donar a Esta Categoría",
          viewTransparency: "Ver Registros de Transparencia"
        },
        category1: {
          icon: "🟫",
          title: "Despinado y Prevención de Incendios",
          description: "La catástrofe vivida en Epuyén no puede resolverse únicamente con respuestas de emergencia. Para evitar nuevos incendios extremos, el territorio necesita una prevención estructural, sostenida durante varios años.",
          supports: "Tu contribución apoya infraestructura permanente de prevención de incendios, empleo local y estabilidad ecológica a largo plazo.",
          items: [
            "Eliminación de pino invasor",
            "Reducción de carga de combustible",
            "Protección del bosque nativo"
          ],
          method: "Despinado mecánico con mulching + despinado manual selectivo",
          impact: "Reducción directa del riesgo de incendios mientras regenera el ecosistema",
          fiveYearPlan: {
            title: "Plan Agresivo de Prevención — 5 Años",
            subtitle: "Despinado, Mulching y Reducción del Riesgo de Incendios",
            intro: "La catástrofe vivida en Epuyén no puede resolverse únicamente con respuestas de emergencia. Para evitar nuevos incendios extremos, el territorio necesita una prevención estructural, sostenida durante varios años, utilizando métodos que reduzcan el riesgo de fuego y al mismo tiempo regeneren el ecosistema.",
            programDescription: "Este plan establece un Programa Agresivo de 5 Años, enfocado en la remoción del pino invasor mediante triturado directo sobre el suelo (mulching), combinado con trabajo manual selectivo en zonas donde aún subsiste bosque nativo.",
            objective: "Reducir drásticamente el riesgo de incendios forestales en el valle de Epuyén mediante:",
            objectiveItems: [
              "Eliminación de especies invasoras (pino)",
              "Reducción de cargas extremas de combustible",
              "Recuperación del suelo y la humedad",
              "Protección del bosque nativo remanente",
              "Creación de capacidad permanente de prevención"
            ],
            targetArea: "Aproximadamente 4.500 hectáreas de pino invasor (vivo y muerto)",
            targetAreaDetail: "Laderas, zonas post-incendio y áreas de interfaz con viviendas",
            annualTarget: "900 hectáreas/año",
            duration: "5 años consecutivos",
            durationDetail: "Operación durante los 12 meses del año",
            durationNote: "La prevención no puede ser estacional: el combustible se acumula todo el año.",
            operations: "12 meses al año",
            methodology: {
              title: "Metodología operativa",
              intro: "El plan combina dos métodos complementarios:",
              methods: [
                "Despinado mecánico con mulching",
                "Despinado manual selectivo (quirúrgico)"
              ],
              note: "Ambos son indispensables para lograr efectividad sin daño ecológico."
            },
            phases: {
              year1: {
                title: "Año 1 — Estabilización urgente",
                items: [
                  "Zonas cercanas a viviendas",
                  "Corredores de protección",
                  "Remoción de material muerto"
                ]
              },
              year2: {
                title: "Año 2 — Intervención a escala",
                items: [
                  "Grandes masas de pino",
                  "Continuidad del triturado",
                  "Inicio del monitoreo ecológico"
                ]
              },
              year3: {
                title: "Año 3 — Tratamiento profundo del territorio",
                items: [
                  "Laderas internas",
                  "Zonas de difícil acceso",
                  "Combinación con cuadrillas manuales"
                ]
              },
              year4: {
                title: "Año 4 — Control de rebrote",
                items: [
                  "Segunda pasada",
                  "Estabilización del suelo",
                  "Refuerzo de regeneración nativa"
                ]
              },
              year5: {
                title: "Año 5 — Consolidación",
                items: [
                  "Reducción final del riesgo",
                  "Monitoreo ambiental",
                  "Transición a mantenimiento permanente"
                ]
              }
            },
            twoMethods: {
              intro: "El despinado de Epuyén no puede depender solo de la maquinaria. Grandes áreas del valle contienen bosque mixto, donde el pino invasor crece entrelazado con especies nativas. En estas zonas, la maquinaria pesada no puede usarse sin destruir el bosque nativo.",
              approach: "Por esta razón, el plan de prevención combina maquinaria pesada para áreas de pino denso, remoción manual quirúrgica en bosques mixtos y empleo local a largo plazo. Este enfoque integrado permite una verdadera prevención sin daño ecológico.",
              mechanical: {
                title: "Despinado Mecánico",
                description: "Usado en masas densas de pino donde no queda bosque nativo.",
                items: [
                  "Trituradoras forestales",
                  "Excavadoras y maquinaria de apoyo",
                  "Reducción de combustible a gran escala"
                ],
                note: "Este es el método más rápido y cubre grandes superficies."
              },
              manual: {
                title: "Despinado Manual / Quirúrgico",
                description: "Usado en zonas sensibles:",
                zones: [
                  "Pino mezclado con bosque nativo",
                  "Áreas de regeneración",
                  "Zonas riparias",
                  "Áreas de amortiguamiento cerca del agua, casas y senderos"
                ],
                method: "Este trabajo lo realizan cuadrillas capacitadas con motosierras, removiendo selectivamente el pino invasor mientras preservan las especies nativas.",
                note: "Este método es más lento — pero ecológicamente esencial."
              }
            },
            employment: {
              title: "Programa de Empleo Local",
              intro: "Para llevar a cabo el despinado manual a escala, el proyecto incluye un programa de empleo de 5 años.",
              priority: "Contratación prioritaria de Epuyén y comunidades aledañas",
              equipmentItems: [
                "Equipo de seguridad (cascos, chaparreras, botas, guantes)",
                "Cadenas de repuesto, barras, mezcla de combustible",
                "Herramientas de mantenimiento"
              ],
              manualCostCategories: [
                "Salarios (50 trabajadores × 5 años)",
                "Motosierras (50 unidades)",
                "Seguridad y herramientas"
              ]
            },
            whyMulching: {
              title: "¿Por qué el mulching es la mejor opción?",
              intro: "El mulching consiste en triturar el pino directamente en el lugar, devolviendo la biomasa al suelo.",
              fundamentalDifference: "Este método es radicalmente distinto a retirar madera o quemar el terreno.",
              vsRemoving: {
                title: "Retirar la madera",
                intro: "La extracción de madera:",
                problems: [
                  "Deja el suelo expuesto al sol y al viento",
                  "Elimina materia orgánica",
                  "Destruye la vida microbiana",
                  "Incrementa la erosión",
                  "Requiere transporte pesado",
                  "Concentra residuos inflamables en otros sitios"
                ],
                conclusion: "Convierte el terreno en un desierto biológico."
              },
              vsBurning: {
                title: "Quemar el suelo",
                intro: "La quema:",
                problems: [
                  "Libera carbono de forma inmediata",
                  "Esteriliza el suelo",
                  "Elimina hongos, insectos y microorganismos",
                  "Genera suelos hidrofóbicos (repelen el agua)",
                  "Aumenta riesgo de inundaciones y deslizamientos"
                ],
                conclusion: "Los suelos quemados muchas veces no vuelven a absorber agua correctamente."
              },
              benefits: {
                title: "Beneficios del mulching",
                intro: "El mulching:",
                items: [
                  "Devuelve carbono al suelo",
                  "Protege contra la radiación solar",
                  "Conserva humedad",
                  "Alimenta microorganismos y micorrizas",
                  "Acelera la regeneración natural",
                  "Reduce la erosión",
                  "Limita el rebrote invasor",
                  "Prepara el terreno para especies nativas"
                ],
                conclusion: "Transforma combustible en vida del suelo.",
                statement: "Es el único método que reduce el riesgo de incendios mientras regenera el ecosistema al mismo tiempo."
              }
            },
            costExplanation: {
              title: "Costos asociados (5 años)",
              mechanical: {
                title: "Despinado mecánico con mulching",
                capex: {
                  title: "Inversión inicial (CAPEX)",
                  includes: "Incluye:",
                  items: [
                    "Trituradoras forestales",
                    "Excavadoras",
                    "Topadoras y cargadoras",
                    "Vehículos de apoyo"
                  ],
                  cost: "USD 3,0 – 5,8 millones",
                  note: "Esta infraestructura queda disponible a largo plazo."
                },
                opex: {
                  title: "Costos operativos (5 años)",
                  includes: "Incluye:",
                  items: [
                    "Combustible",
                    "Mantenimiento",
                    "Repuestos",
                    "Logística",
                    "Operación continua"
                  ],
                  cost: "USD 6,1 – 10,7 millones"
                }
              },
              manual: {
                title: "Despinado manual selectivo",
                intro: "Necesario donde el pino está mezclado con bosque nativo.",
                includes: "Incluye:",
                items: [
                  "50 trabajadores locales",
                  "Motosierras profesionales",
                  "Equipos de seguridad"
                ],
                calculation: "50 personas × USD 1.000 × 60 meses = USD 3.000.000",
                equipment: "Equipamiento: USD 125.000",
                total: "Total programa manual: USD 3,125 millones"
              },
              totalCost: {
                title: "Costo total del Plan Agresivo (5 años)",
                components: [
                  { category: "Maquinaria (inversión única)", cost: "USD 3,0 – 5,8 M" },
                  { category: "Operación maquinaria (5 años)", cost: "USD 6,1 – 10,7 M" },
                  { category: "Despinado manual (5 años)", cost: "USD 3,125 M" }
                ],
                total: "TOTAL DEL PROGRAMA",
                totalRange: "USD 12,2 – 19,6 millones"
              }
            },
            results: {
              title: "Resultados esperados",
              intro: "Al finalizar los cinco años, el plan permitirá:",
              items: [
                "Reducción drástica del riesgo de incendios",
                "Eliminación del combustible extremo",
                "Recuperación del suelo y la humedad",
                "Protección del bosque nativo remanente",
                "Éxito del proceso de reforestación",
                "Reducción del gasto público futuro en emergencias",
                "Generación de empleo local estable",
                "Resiliencia ecológica a largo plazo"
              ]
            },
            finalMessage: {
              line1: "Apagar incendios es reaccionar.",
              line2: "Prevenir es proteger la vida.",
              statement: "El mulching convierte la destrucción en regeneración."
            },
            capex: {
              title: "Desglose de Inversión (CAPEX)",
              total: "Inversión Total",
              categories: {
                highVolumeMulchers: "Mulchers de alto volumen (4 unidades)",
                accessPrecisionMulchers: "Mulchers de acceso/precisión (2 unidades)",
                excavators: "Excavadoras (2 unidades)",
                dozer: "Bulldozer (1 unidad)",
                loader: "Cargador (1 unidad)",
                trucks: "Camiones y transporte",
                fuelStorage: "Almacenamiento de combustible",
                workshops: "Taller y herramientas"
              },
              argentinaLanded: {
                title: "Costo Real en Argentina (Importación + Logística)",
                learnMore: "Ver detalles",
                learnLess: "Ocultar detalles",
                intro: "El precio internacional de referencia no es el costo real en Argentina. La maquinaria forestal pesada tiene un costo significativamente mayor debido a impuestos de importación, IVA, despacho aduanero, costos portuarios, transporte terrestre a Patagonia, demoras y la inflación en repuestos.",
                points: [
                  "El sobrecosto típico de importación puede agregar entre +40% y +90% dependiendo del tipo de equipamiento y la vía de importación.",
                  "Existen posibles exenciones para ONGs, pero no están garantizadas antes del registro legal. Las tratamos como beneficio potencial, no como supuesto.",
                  "El transporte terrestre a Patagonia y las demoras portuarias agregan costos significativos.",
                  "Los repuestos son caros y lentos en Argentina — incluimos un 10-15% de reserva de preparación (crítico para el tiempo de operación)."
                ],
                costBreakdown: {
                  title: "Resumen de Costos Reales",
                  baseMachinery: "Maquinaria base (precio internacional)",
                  baseRange: "~USD 3.0–5.8M",
                  importTaxes: "Importación/impuestos/logística (Argentina)",
                  importRange: "+USD 2.4–2.8M",
                  spareParts: "Repuestos/reserva de preparación (10-15%)",
                  spareRange: "+USD 0.7–1.0M",
                  totalLanded: "CAPEX real estimado en Argentina",
                  totalRange: "USD 7.5–8.2M"
                },
                disclaimer: "Todos los presupuestos reflejan costos reales en Argentina (impuestos, logística a Patagonia, preparación). Cualquier exención futura reduce el costo y aumenta las hectáreas tratadas."
              }
            },
            strategic: {
              title: "Importancia Estratégica",
              establishes: "Esta infraestructura establece:",
              items: [
                "Capacidad permanente de prevención de incendios",
                "Capacidad de intervención rápida",
                "Independencia de respuestas solo de emergencia",
                "Capacidad para mantener zonas tratadas a largo plazo"
              ],
              note: "Esta es la base de un programa de prevención real y sostenible."
            },
            conclusion: "Este enfoque no es simbólico — es estructural. El plan agresivo de despinado de 5 años solo es alcanzable con una flota forestal profesional dedicada combinada con cuadrillas manuales capacitadas. Esto transforma a Epuyén de una zona de desastre reactiva en una región con infraestructura permanente de prevención de incendios forestales.",
            soilComparison: {
              title: "Suelo de Bosque Nativo vs Suelo de Pinar",
              subtitle: "Por qué el fuego se propaga mucho más rápido en bosques de pino",
              intro: "La diferencia no es solo el árbol. La diferencia es todo el sistema del suelo debajo.",
              native: {
                title: "Suelo de Bosque Nativo",
                species: "coihue, lenga, ñire, radal",
                description: "Los bosques nativos patagónicos crean:",
                characteristics: [
                  "Alta diversidad orgánica",
                  "Capa profunda de humus",
                  "Redes fúngicas (micorrizas)",
                  "Retención constante de humedad",
                  "Estructura esponjosa",
                  "Descomposición lenta",
                  "Alta actividad microbiana"
                ],
                moisture: "25–45%",
                moistureLabel: "Humedad típica del suelo",
                moistureNote: "Incluso en verano.",
                fireBehavior: {
                  title: "Comportamiento del fuego:",
                  points: [
                    "Las llamas se mantienen bajas",
                    "El fuego se propaga lentamente",
                    "A menudo se autoextingue",
                    "Quema en parches, no continuo",
                    "Difícil que llegue a las copas"
                  ]
                },
                spreadSpeed: "0.1–0.5 metros por minuto",
                spreadNote: "A menudo se detiene de noche."
              },
              pine: {
                title: "Suelo de Plantación de Pino",
                warning: "El pino altera radicalmente el suelo.",
                characteristics: [
                  "Hojarasca ácida (pH 3.5–4.5)",
                  "Agujas saturadas de resina",
                  "Pobre diversidad microbiana",
                  "Casi sin simbiosis fúngica",
                  "Suelo mineral compactado",
                  "Hidrofóbico (repele el agua)",
                  "Secado rápido"
                ],
                moisture: "5–12%",
                moistureLabel: "Humedad típica del suelo",
                moistureNote: "Incluso cerca de lagos.",
                fireBehavior: {
                  title: "Comportamiento del fuego:",
                  points: [
                    "Se enciende fácilmente",
                    "El fuego viaja continuamente",
                    "Las llamas suben verticalmente",
                    "Calor radiante intenso",
                    "Las copas se encienden rápidamente"
                  ]
                },
                spreadSpeed: "5–20 metros por minuto",
                spreadWind: "40–60 metros por minuto",
                spreadWindLabel: "Con viento:",
                spreadComparison: "Eso es 100× más rápido."
              },
              fireLadders: {
                title: "Por qué los incendios de pino se mueven tan rápido",
                intro: "Porque el pino crea tres escaleras de fuego a la vez:",
                ladder1: {
                  title: "Agujas de resina (combustible de suelo)",
                  points: [
                    "Altamente inflamables",
                    "Temperatura de ignición ≈ 260°C",
                    "La hojarasca nativa se enciende ≈ 450–500°C",
                    "Ya casi 2× de diferencia"
                  ]
                },
                ladder2: {
                  title: "Combustible de escalera vertical",
                  points: [
                    "Ramas desde el suelo hasta la copa",
                    "El fuego sube fácilmente",
                    "Los árboles nativos se auto-podan naturalmente"
                  ]
                },
                ladder3: {
                  title: "Continuidad de copas",
                  points: [
                    "Las copas de pino son uniformes",
                    "El fuego salta de copa en copa",
                    "El bosque nativo es irregular y discontinuo"
                  ]
                }
              },
              comparisonTable: {
                title: "Comparación cuantificada",
                headers: ["Factor", "Bosque nativo", "Plantación de pino"],
                rows: [
                  ["Humedad del suelo", "25–45%", "5–12%"],
                  ["Temp. ignición hojarasca", "450–500°C", "260–300°C"],
                  ["Velocidad propagación", "0.1–0.5 m/min", "5–60 m/min"],
                  ["Probabilidad fuego de copa", "Muy baja", "Extremadamente alta"],
                  ["Auto-extinción", "Común", "Rara"],
                  ["Recuperación del suelo", "Rápida", "Muy lenta"],
                  ["Riesgo de erosión", "Bajo", "Extremo"]
                ]
              },
              intensity: {
                title: "Comparación de intensidad del fuego",
                label: "Intensidad del fuego (kW/m):",
                native: "500–2,000 kW/m",
                pine: "20,000–60,000 kW/m",
                comparison: "Eso es 10–30 veces más energía.",
                warning: "Ningún bombero puede estar cerca de eso."
              },
              waterCycle: {
                title: "Diferencia del ciclo del agua (crítico)",
                native: {
                  title: "Suelo de bosque nativo:",
                  points: ["Absorbe la lluvia", "Almacena agua", "Libera humedad lentamente", "Enfría el microclima"]
                },
                pine: {
                  title: "Suelo de pino:",
                  points: ["Repele la lluvia", "Aumenta la escorrentía", "Se seca rápidamente", "Aumenta el calor"]
                },
                conclusion: "Esto crea microclimas calientes, secos y ventosos. El fuego se alimenta de eso."
              },
              feedback: {
                title: "Por qué los incendios 'explotan' en áreas de pino",
                intro: "Porque los sistemas de pino:",
                points: [
                  "Se secan más rápido",
                  "Se encienden antes",
                  "Queman más caliente",
                  "Se propagan más rápido",
                  "Queman continuamente",
                  "Regeneran más pino después"
                ],
                conclusion: "Es un ciclo de retroalimentación."
              },
              summary: {
                title: "Resumen en palabras simples",
                native: "Bosque nativo = esponja húmeda",
                pine: "Plantación de pino = alfombra de gasolina",
                note: "Eso no es exageración — es física."
              },
              publicQuote: "Los pinos no solo se queman — rediseñan el suelo para quemarse más rápido.",
              whyWorks: {
                title: "Por qué funciona el despinado",
                intro: "Remover el pino:",
                points: [
                  "Aumenta la humedad del suelo",
                  "Restaura los hongos",
                  "Rompe la continuidad del combustible",
                  "Baja la altura de las llamas",
                  "Reduce la velocidad de propagación",
                  "Permite que las especies nativas regresen"
                ],
                conclusion: "Por eso la prevención funciona."
              }
            },
            transparency: {
              title: "Transparencia",
              intro: "Todo el trabajo será:",
              items: [
                "Georreferenciado",
                "Medido en hectáreas intervenidas",
                "Documentado visualmente",
                "Informado mensualmente",
                "Publicado en la plataforma Epuyén Renace"
              ],
              conclusion: "Cada aporte será verificable."
            },
            costExplanation: {
              title: "Explicación de Costos",
              intro: "La verdadera prevención de incendios forestales no puede lograrse mediante acciones aisladas o intervenciones a corto plazo.",
              requirement: "Para proteger Epuyén, se requiere un plan continuo de cinco años.",
              mechanical: {
                title: "1. Despinado Mecánico",
                description: "Este método se utiliza en áreas donde el pino invasor domina el paisaje.",
                capability: "Permite intervención a gran escala y reducción rápida de cargas de combustible peligrosas.",
                includes: "Lo que incluye este costo",
                items: [
                  "Mulchers forestales (trituradoras especializadas)",
                  "Excavadoras y equipo de apoyo",
                  "Combustible, mantenimiento y transporte",
                  "Operadores capacitados"
                ],
                oneTimeInvestment: "Inversión única:",
                oneTimeRange: "USD 3.0 – 5.8 millones",
                operationalCost: "Costo operacional (5 años):",
                operationalRange: "USD 6.1 – 10.7 millones",
                note: "Esta inversión crea capacidad permanente de prevención de incendios."
              },
              manual: {
                title: "2. Despinado Manual / Quirúrgico",
                description: "En muchas áreas, el pino invasor crece mezclado con bosque nativo.",
                limitation: "La maquinaria pesada no puede usarse sin destruir ecosistemas nativos.",
                whereApplied: "Dónde se aplica",
                zones: [
                  "Pino mezclado con bosque nativo",
                  "Áreas de regeneración",
                  "Zonas ribereñas",
                  "Zonas de amortiguamiento"
                ],
                workers: "50 trabajadores a tiempo completo",
                salary: "USD 1,000/mes",
                duration: "5 años",
                totalCost: "Costo total despinado manual (5 años):",
                totalAmount: "USD 3.125 millones"
              },
              totalCost: {
                title: "Costo Total — Plan de Prevención de 5 Años",
                componentHeader: "Componente",
                costHeader: "Costo",
                components: [
                  { name: "Maquinaria (inversión única)", cost: "USD 3.0 – 5.8M" },
                  { name: "Operación maquinaria (5 años)", cost: "USD 6.1 – 10.7M" },
                  { name: "Despinado manual (5 años)", cost: "USD 3.125M" }
                ],
                total: "TOTAL DEL PROGRAMA",
                totalRange: "USD 12.2 – 19.6 millones"
              },
              delivers: {
                title: "Lo que entrega este plan",
                intro: "Esta inversión no es simbólica — es estructural.",
                notEmergency: "No es una respuesta de emergencia",
                structural: "Es infraestructura permanente de prevención"
              },
              whyFiveYears: {
                title: "¿Por qué 5 años?",
                intro: "La ecología del fuego no respeta presupuestos anuales.",
                allows: "Solo un compromiso de 5 años permite:",
                items: [
                  "Tratar las 4,500 hectáreas de manera metodológica",
                  "Responder a la regeneración del pino (que vuelve a brotar)",
                  "Construir capacidad local y empleo",
                  "Crear resiliencia ecológica duradera"
                ],
                conclusion: "Plazos más cortos no pueden romper el ciclo de incendios."
              },
              transparency: {
                title: "Transparencia y Rendición de Cuentas",
                intro: "Todo el trabajo será:",
                items: [
                  "Georreferenciado",
                  "Medido en hectáreas tratadas",
                  "Documentado visualmente",
                  "Informado mensualmente"
                ],
                conclusion: "Cada contribución es verificable."
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "Sistema de Barco Bombero para Lago Epuyén",
          description: "Esta categoría establece una unidad permanente de combate de incendios basada en agua, capaz de despliegue rápido y bombeo de alto volumen.",
          supports: "Las donaciones apoyan:",
          items: [
            "embarcación especializada para combate de incendios",
            "sistema de bomba industrial de alta capacidad",
            "sistemas de mangueras y carretes",
            "propulsión eléctrica/híbrida",
            "equipo de seguridad y combate de incendios"
          ],
          objective: "El objetivo es convertir el Lago Epuyén de un elemento pasivo en un activo activo de defensa contra incendios.",
          impact: "Esta categoría protege vidas, bosques e infraestructura con capacidad de respuesta en minutos.",
          boatSystem: {
            title: "Sistema de Barco Bombero para Lago Epuyén",
            subtitle: "Unidad de Respuesta Rápida Basada en Agua",
            objective: "Establecer una unidad permanente de barco bombero capaz de despliegue rápido, bombeo de agua de alta capacidad, y apoyo a brigadas terrestres — transformando el Lago Epuyén de un elemento pasivo en un activo activo de defensa contra incendios.",
            vesselLength: "9-12 metros",
            pumpCapacity: "4,000-8,000 L/min",
            crew: "6-10 bomberos",
            propulsion: "Eléctrico/Híbrido",
            context: "El Lago Epuyén representa uno de los recursos de combate de incendios más estratégicos de todo el valle. Sin embargo, a pesar de su proximidad a áreas forestales de alto riesgo, actualmente no existe un sistema dedicado de combate de incendios basado en agua.",
            challengesTitle: "¿Por qué Respuesta Basada en Agua?",
            challengesIntro: "La geografía de Epuyén crea tres desafíos principales:",
            challenges: [
              "Laderas forestales empinadas",
              "Acceso vial limitado",
              "Fuertes vientos del valle"
            ],
            solutionStatement: "La respuesta basada en agua resuelve los tres.",
            capabilitiesTitle: "Un barco puede:",
            capabilities: [
              "Alcanzar frentes de incendio más rápido que los camiones",
              "Bombear agua ilimitada del lago",
              "Operar incluso cuando las rutas están bloqueadas",
              "Atacar incendios desde debajo de la ladera",
              "Reducir el tiempo de respuesta en 60-80%"
            ],
            operationalFunctions: [
              "Supresión activa de incendios forestales",
              "Ataque temprano durante la ignición",
              "Apoyo a brigadas terrestres",
              "Protección de estructuras cerca de la zona del lago",
              "Patrullaje e inspección rápida",
              "Entrenamiento y preparación"
            ],
            integration: [
              "Brigadas de bomberos municipales",
              "Servicios de emergencia provinciales",
              "Unidades de respuesta a incendios forestales"
            ],
            environmentalBenefits: [
              "Sin derrames de combustible en el lago",
              "Menor dependencia de helicópteros",
              "Mínimo impacto ambiental",
              "Operación silenciosa durante respuesta nocturna"
            ],
            capex: {
              title: "Inversión Total (CAPEX)",
              total: "Inversión Total"
            },
            strategic: {
              title: "Valor Estratégico",
              establishes: "Este sistema crea:",
              items: [
                "Capacidad permanente de combate de incendios basada en agua",
                "Capacidad de respuesta rápida en minutos",
                "Menores costos de supresión",
                "Reducción de probabilidad de propagación de incendios",
                "Protección de hogares, bosques y fuentes de agua"
              ],
              note: "Convierte el Lago Epuyén de un elemento pasivo en un activo activo de defensa contra incendios."
            },
            conclusion: "Un barco bombero dedicado en el Lago Epuyén representa una de las inversiones más eficientes en prevención y respuesta a incendios forestales. Transforma el lago en un sistema de defensa de primera línea — protegiendo el valle antes de que los incendios se conviertan en desastres."
          }
        },
        category3: {
          icon: "🌱",
          title: "Reforestación y Preservación Futura",
          description: "Esta categoría apoya la recuperación ecológica a largo plazo de Epuyén.",
          supports: "Las donaciones se usan para:",
          items: [
            "plantación de árboles nativos",
            "desarrollo de viveros",
            "regeneración del suelo",
            "mantenimiento a largo plazo",
            "restauración de biodiversidad",
            "monitoreo y protección de áreas regeneradas"
          ],
          impact: "Esto asegura que los bosques restaurados sobrevivan, maduren y permanezcan protegidos para las generaciones futuras."
        },
        category4: {
          icon: "♻️",
          title: "Gestión de Residuos y Contaminación",
          description: "A través de la observación en terreno y el diálogo comunitario, hemos identificado que Epuyén enfrenta un desafío significativo de residuos a cielo abierto y contaminación.",
          supports: "Actualmente enfocados en:",
          items: [
            "entender los flujos de residuos existentes",
            "identificar riesgos de contaminación",
            "mapear zonas de vertido a cielo abierto",
            "estudiar impactos ambientales y de salud",
            "revisar modelos viables de comunidades rurales similares"
          ],
          objective: "El objetivo no es imponer una solución, sino construir una que sea realista, sostenible y apropiada para la escala y geografía de Epuyén.",
          impact: "Abordar la contaminación es esencial para proteger las fuentes de agua, restaurar ecosistemas y asegurar un futuro saludable para la comunidad.",
          researchPhase: {
            title: "Gestión de Residuos y Contaminación",
            currentPhase: "Fase de Investigación y Diagnóstico",
            context: "A través de la observación en terreno y el diálogo comunitario, hemos identificado que Epuyén enfrenta un desafío significativo de residuos a cielo abierto y contaminación, incluyendo áreas de vertido informal que representan riesgos a largo plazo para el suelo, el agua y la salud pública.",
            statement: "Este problema no puede abordarse mediante improvisación o acciones aisladas.",
            focusTitle: "Áreas de Enfoque Actuales:",
            focusAreas: [
              "Entender los flujos de residuos existentes",
              "Identificar riesgos de contaminación",
              "Mapear zonas de vertido a cielo abierto",
              "Estudiar impactos ambientales y de salud",
              "Revisar modelos viables utilizados en comunidades rurales y de montaña similares"
            ],
            requirement: "La gestión de residuos requiere precisión técnica, coordinación regulatoria y planificación a largo plazo.",
            ethos: "Como parte de nuestro ethos, no se anunciará ninguna solución sin la investigación adecuada.",
            commitment: "Una vez que se complete esta fase de evaluación, Epuyén Renace publicará una propuesta de gestión de residuos clara, pública y transparente, abierta a revisión comunitaria y diálogo institucional.",
            objective: "El objetivo no es imponer una solución, sino construir una que sea realista, sostenible y apropiada para la escala y geografía de Epuyén.",
            importance: "Abordar la contaminación es esencial para proteger las fuentes de agua, restaurar ecosistemas y asegurar un futuro saludable para la comunidad."
          }
        },
        category5: {
          icon: "🏛️",
          title: "Parque Biosfera 33ha y Centro de la Fundación",
          description: "El proyecto de visión a largo plazo: 33 hectáreas de parque público biosfera con sede de la fundación, centro educativo y economía local sostenible.",
          supports: "Las donaciones apoyan:",
          items: [
            "sede de la fundación y centro de educación ambiental",
            "20 eco-casas para voluntarios y visitantes",
            "parque público con senderos y áreas de conservación",
            "domo de 420m² para eventos y conferencias",
            "spa japonés de bienestar",
            "restaurante sobre el lago",
            "muelle para el barco de bomberos y acceso público",
            "instalación de producción de alimentos locales"
          ],
          objective: "El objetivo es crear un modelo autosustentable que genere empleo local, educación y turismo regenerativo.",
          impact: "Esta categoría construye el legado permanente y la infraestructura para generaciones futuras."
        },
        transparency: {
          title: "Transparencia por Categoría",
          description: "Cada categoría de donación tiene:",
          items: [
            "un presupuesto dedicado",
            "seguimiento público del progreso",
            "gastos documentados",
            "fotos, datos GPS y reportes",
            "registros de transparencia basados en blockchain"
          ],
          verify: "Los donantes pueden elegir exactamente cómo se usa su contribución y verificar su impacto en cada etapa."
        },
        oneSystem: {
          title: "Un Sistema, Cinco Misiones",
          depining: "El despinado reduce el riesgo.",
          firefighting: "El combate de incendios protege en emergencias.",
          reforestation: "La reforestación restaura la vida.",
          contamination: "La gestión de residuos protege el agua y la salud.",
          biosphere: "El parque biosfera construye el futuro sostenible.",
          together: "Juntos, forman un modelo completo y permanente de recuperación post-incendio para Epuyén — demostrando que un lugar puede resurgir cuando hay organización, tecnología y compromiso real."
        }
      }
    },
    // Roadmap - Complete Phase Translations
    roadmap: {
      title: "Hoja de Ruta",
      subtitle: "Un sistema a largo plazo para regenerar la tierra y darle futuro a Epuyén. No es política ni caridad — es acción verificable.",
      thePlan: "El Plan",
      active: "Activo",
      upcoming: "Próximo",
      comingSoon: "Próximamente",
      rAndD: "I+D",
      vision: "Visión",
      future: "Futuro",
      goal: "Meta",
      raised: "Recaudado",
      totalGoal: "Meta Total",
      treesAdopted: "Árboles Adoptados",
      projectPhases: "Fases del Proyecto",
      progress: "Progreso",
      everyContribution: "Cada contribución nos acerca a la meta",
      phase0: {
        title: "Fundación + Transparencia Digital",
        description: "Crear Fundación Epuyén Renace, lanzar sitio web + roadmap público, configurar mapa digital con drone/LiDAR, definir zonas, KPIs, modelo de costos y sistema blockchain para rastrear donaciones y gastos.",
        tags: ["Web", "Mapa 3D", "Blockchain", "Fundación Legal"],
        status: "Configuración Inicial"
      },
      phase1: {
        title: "Sprint de Reforestación",
        description: "Plantar 10,000 árboles nativos. Cada árbol cuesta ~USD $25 y es rastreado con GPS, fotos, cronología de estado y registro público.",
        tags: ["10,000 Árboles", "GPS Tracking", "Fotos", "Registro Público"],
        treesAdopted: "árboles adoptados",
        available: "disponibles"
      },
      phase2: {
        title: "Reducción de Riesgo + Expansión",
        description: "Remover 5,000 pinos invasores, plantar 20,000 árboles nativos, y adquirir 2 chipeadoras para procesar pino en mulch y reducir carga de combustible.",
        tags: ["5,000 Pinos Removidos", "20,000 Nativos", "2 Chipeadoras"],
        proof: "Publicar pruebas: registros de remoción + lotes de plantación + recibos"
      },
      phase3: {
        title: "Innovación Anti-Incendios Patagonia",
        description: "Diseñar y construir un sistema híbrido propietario de combate de incendios: capacidad agua/bote + drones + respuesta terrestre. Meta: detección temprana + contención rápida en terreno remoto.",
        tags: ["Drones", "Vehículo Híbrido", "Detección Temprana", "I+D Abierto"],
        milestones: "Hitos claros, prototipos y reportes públicos"
      },
      phase4: {
        title: "Parque Biosfera Público 33HA",
        description: "Comprar 33 hectáreas, propiedad de Fundación Epuyén Renace. Diseñarlo como parque biosfera público con: zonas de restauración de biodiversidad, educación sobre especies invasoras, demostración de producción regenerativa de alimentos, centro de procesamiento, cafetería, restaurante frente al lago + muelles, y centro educativo.",
        tags: ["33 Hectáreas", "Centro Educativo", "Restaurante Lago", "Muelles", "Producción Local"],
        purpose: "Protección permanente + empleos + educación + economía local sostenible"
      },
      phase5: {
        title: "Plataforma SaaS Completa",
        description: "Epuyén se convierte en un gemelo digital. Mapa con relevamiento drone/LiDAR: árboles contados y registrados, 1 árbol = 1 token/certificado, mercado interactivo de adopción, dashboards de transparencia on-chain + off-chain, módulos de voluntarios/comunidad, reportes y herramientas de auditoría.",
        tags: ["Gemelo Digital", "LiDAR", "Tokens NFT", "On-Chain", "Auditoría"],
        scalable: "Modelo escalable para otros proyectos de conservación"
      },
      summary: {
        foundation: "Fundación",
        trees10k: "10K Árboles",
        expansion: "Expansión",
        fireFighting: "Anti-Incendios",
        park33ha: "Parque 33HA",
        platform: "Plataforma"
      }
    },
    // Education Page - Complete
    education: {
      title: "Aprende sobre el Bosque",
      subtitle: "Conocimiento es poder. Entender nuestro ecosistema es el primer paso para protegerlo. Aquí encontrarás todo lo que necesitas saber sobre el bosque patagónico.",
      badge: "Educación Ambiental",
      // Native Forest Section
      nativeForest: {
        title: "El Bosque Nativo Patagónico",
        subtitle: "Conoce las especies que estamos protegiendo",
        lenga: {
          title: "Lenga (Nothofagus pumilio)",
          description: "Árbol caducifolio que puede alcanzar 30 metros. Sus hojas se vuelven rojas y doradas en otoño, creando paisajes espectaculares. Es fundamental para la biodiversidad del bosque andino-patagónico."
        },
        coihue: {
          title: "Coihue (Nothofagus dombeyi)",
          description: "Especie perenne que puede vivir más de 500 años. Proporciona refugio y alimento para decenas de especies de aves y mamíferos. Su madera es valiosa pero su valor ecológico es incalculable."
        },
        cipres: {
          title: "Ciprés de la Cordillera",
          description: "Conífera nativa que puede superar los 1000 años de edad. Resistente y adaptada al clima patagónico, es un símbolo de permanencia y resiliencia."
        }
      },
      // Invasive Species Section
      invasiveSpecies: {
        title: "Especies Invasoras",
        subtitle: "El problema del pino y otras amenazas",
        pine: {
          title: "Pino Invasor",
          description: "Introducido para forestación comercial, el pino se dispersa agresivamente, desplazando al bosque nativo. Acidifica el suelo, reduce la biodiversidad y aumenta dramáticamente el riesgo de incendios.",
          impact: "Alto"
        },
        rosehip: {
          title: "Rosa Mosqueta",
          description: "Aunque produce frutos comestibles, esta especie europea se propaga rápidamente y compite con la vegetación nativa por recursos.",
          impact: "Medio"
        },
        broom: {
          title: "Retamo",
          description: "Arbusto altamente inflamable que coloniza áreas degradadas, dificultando la regeneración del bosque nativo.",
          impact: "Alto"
        }
      },
      // Fire Risk Section
      fireRisk: {
        title: "Riesgo de Incendios",
        subtitle: "Entendiendo y previniendo la amenaza",
        whyPinesDangerous: {
          title: "¿Por qué los pinos son peligrosos?",
          description: "Los pinos contienen resinas altamente inflamables. Un bosque de pinos puede arder 10 veces más rápido que un bosque nativo. Además, sus copas densas facilitan la propagación del fuego de copa, el más destructivo."
        },
        nativeForestRole: {
          title: "El rol del bosque nativo",
          description: "Los árboles nativos como la lenga tienen mayor contenido de humedad y menor cantidad de resinas. Un bosque nativo saludable actúa como cortafuego natural y se recupera mejor después de un incendio."
        },
        communityPrevention: {
          title: "Prevención comunitaria",
          description: "La remoción de pinos, la creación de cortafuegos, y los sistemas de detección temprana son fundamentales. Cada árbol nativo plantado contribuye a reducir el riesgo."
        }
      },
      // Biodiversity Section
      biodiversity: {
        title: "Biodiversidad",
        subtitle: "La vida que depende del bosque",
        fauna: {
          title: "Fauna emblemática",
          description: "El huemul (ciervo patagónico en peligro de extinción), el pudú (el ciervo más pequeño del mundo), el puma, y decenas de especies de aves dependen del bosque nativo."
        },
        lifeNetwork: {
          title: "Red de vida",
          description: "Cada árbol nativo sostiene una red de hongos, líquenes, insectos, aves y mamíferos. Esta biodiversidad no existe en plantaciones de pinos."
        },
        corridors: {
          title: "Corredores biológicos",
          description: "Al restaurar el bosque, creamos corredores que permiten a los animales moverse, encontrar pareja y mantener poblaciones saludables."
        }
      },
      // Water Cycle Section - Complete
      waterCycle: {
        mainTitle: "Cómo los Bosques Traen Lluvia y Protegen Nuestra Agua",
        howRainWorks: "Cómo Funciona la Lluvia",
        whyForests: "y Por Qué los Bosques Son Como el Sistema de Agua de la Naturaleza",
        intro1: "Imagina que la tierra es un cuerpo vivo.",
        intro2: "Los bosques no son solo árboles — son los órganos que ayudan al agua a moverse, descansar y regresar.",
        letsSeee: "Veamos cómo funciona 👇",
        whereRainComes: {
          title: "¿De dónde viene la lluvia?",
          content: "Cuando el sol calienta la Tierra:\n• Los lagos y ríos liberan agua al aire\n• Los árboles liberan agua a través de sus hojas\n\nEsta agua se convierte en vapor invisible y sube al cielo.\n\nCuando se acumula suficiente vapor, nacen las nubes.\n\nCuando las nubes se vuelven pesadas — 🌧️ cae la lluvia.\n\n**Los árboles ayudan a formar nubes.**\n\nSin árboles, se forman menos nubes."
        },
        treesBreathe: {
          title: "Los árboles respiran agua hacia el cielo",
          content: "Los árboles beben agua del suelo con sus raíces.\n\nLuego liberan parte de esa agua a través de sus hojas.\n\nEsto se llama **evapotranspiración**, pero podemos pensarlo así:\n\n*Los árboles respiran agua hacia el aire.*\n\nMillones de árboles respirando juntos crean:\n• Humedad\n• Aire más fresco\n• Más probabilidades de lluvia\n\nPor eso los bosques crean su propio clima."
        },
        whenRainFalls: {
          title: "¿Qué pasa cuando cae la lluvia?",
          content: "Cuando la lluvia cae sobre un bosque saludable:\n• Las hojas frenan la lluvia\n• Las raíces abren el suelo\n• El agua penetra suavemente bajo tierra\n\nEl suelo se convierte en una esponja.\n\nEsta agua se almacena y se libera lentamente durante meses.\n\nEsa agua alimenta:\n• Manantiales\n• Arroyos\n• Lagos\n• Animales\n• Personas\n\nPor eso los bosques son llamados **guardianes del agua**."
        },
        forestsGiveMemory: {
          title: "Los bosques dan memoria al agua",
          content: "Los bosques ayudan al agua a quedarse.\n\nNo dejan que toda la lluvia escape de una vez.\n\n**Ellos recuerdan el agua.**\n\nEsto se llama *memoria del agua*.\n\nGracias a los bosques:\n• Los lagos no se secan rápido\n• Los ríos fluyen incluso en verano\n• Los pozos no desaparecen\n\nSin bosques, el agua olvida."
        },
        whenForestsBurn: {
          title: "¿Qué pasa cuando los bosques se queman?",
          content: "Cuando un bosque se quema:\n• El suelo se vuelve duro\n• El agua no puede entrar en la tierra\n• La lluvia escapa rápidamente\n• Ocurren inundaciones\n• Luego siguen largos períodos secos\n\nDespués de los incendios a menudo vemos:\n• Demasiada agua de golpe\n• Luego no hay suficiente después\n\n**Esto es muy peligroso para los lagos.**"
        },
        canValleyHelp: {
          title: "¿Puede un valle ayudar a otro valle?",
          content: "A veces los bosques en valles cercanos ayudan a traer humedad y nubes.\n\nEsto puede ayudar un poco.\n\nPero el agua no puede viajar lejos bajo tierra a través de las montañas.\n\nEso significa:\n\n**Cada valle debe proteger su propio bosque.**\n\nPorque la lluvia puede llegar desde el cielo —\npero el agua debe ser guardada por la tierra."
        },
        whyNativeSpecial: {
          title: "Por qué los bosques nativos son especiales",
          content: "Los bosques nativos:\n• Crecieron aquí naturalmente\n• Protegen el suelo\n• Permiten que el agua entre en la tierra\n• Resisten mejor el fuego\n• Ayudan a que la vida regrese después de desastres\n\nTrabajan junto con la tierra.\n\n**Ellos pertenecen aquí.**"
        },
        forestsNotDecoration: {
          title: "Los bosques no son decoración",
          content: "Los bosques no son solo hermosos.\n\nSon:\n• **Creadores de agua**\n• **Guardianes del agua**\n• **Protectores del clima**\n• **Sustentadores de vida**\n\nSin bosques:\n• Los lagos se debilitan\n• La lluvia se vuelve irregular\n• La tierra se seca\n• El riesgo de incendio crece"
        },
        simpleTruth: {
          title: "Una Verdad Simple",
          noForest: "Sin bosque = sin futuro de agua",
          withForests: "Pero con bosques:",
          rainReturns: "La lluvia regresa",
          springsRecover: "Los manantiales se recuperan",
          lakesSurvive: "Los lagos sobreviven",
          lifeContinues: "La vida continúa",
          whenWeProtect: "Cuando protegemos los bosques, protegemos el mañana.",
          protectNow: "Proteger un Árbol Ahora"
        }
      },
      // Resources
      resources: {
        title: "Recursos Adicionales",
        subtitle: "Material para profundizar tu conocimiento",
        guide: {
          title: "Guía de Especies Nativas",
          type: "PDF",
          description: "Identificación y características de los árboles nativos de la Patagonia"
        },
        documentary: {
          title: "Documental: Bosques en Peligro",
          type: "Video",
          description: "Historia del bosque patagónico y los desafíos actuales"
        },
        interactiveMap: {
          title: "Mapa Interactivo del Proyecto",
          type: "Interactivo",
          description: "Explora las zonas de plantación y monitorea el progreso"
        }
      },
      // CTA
      cta: {
        title: "¿Listo para actuar?",
        description: "El conocimiento cobra sentido cuando se transforma en acción. Cada árbol que adoptas contribuye a restaurar este ecosistema único.",
        adoptTree: "Adoptar un Árbol",
        exploreMap: "Explorar el Mapa"
      }
    },
    // Governance Page - Complete
    governance: {
      title: "Cómo Gobernamos",
      subtitle: "Sin confianza ciega. Sin intermediarios opacos. Un sistema donde cada decisión es verificable y cada peso es rastreable.",
      badge: "Transparencia",
      // Principles
      principles: {
        title: "Principios de Transparencia",
        subtitle: "Los pilares que guían cada decisión",
        radicalTransparency: {
          title: "Transparencia Radical",
          description: "Cada peso que entra y sale es público. Todas las decisiones se documentan. Sin excepciones."
        },
        communityParticipation: {
          title: "Participación Comunitaria",
          description: "Los donantes y la comunidad local tienen voz en las decisiones importantes del proyecto."
        },
        protectedFunds: {
          title: "Fondos Protegidos",
          description: "Multi-firma requerida para movimientos de fondos. Ningún individuo puede actuar solo."
        },
        accountability: {
          title: "Rendición de Cuentas",
          description: "Auditorías regulares, reportes públicos trimestrales, y verificación independiente."
        }
      },
      // Treasury
      treasury: {
        title: "Distribución de Fondos",
        subtitle: "Cómo se asigna cada dólar donado",
        badge: "Tesorería",
        directPlanting: {
          category: "Plantación Directa",
          percentage: 60,
          description: "Plantones, mano de obra, herramientas"
        },
        maintenance: {
          category: "Mantenimiento",
          percentage: 20,
          description: "Riego, monitoreo, reemplazos"
        },
        operations: {
          category: "Operaciones",
          percentage: 15,
          description: "Tecnología, logística, comunicación"
        },
        reserve: {
          category: "Reserva",
          percentage: 5,
          description: "Emergencias y contingencias"
        },
        viewPublicRecord: "Ver Registro Público de Gastos"
      },
      // Multi-sig
      multiSig: {
        title: "Multi-Firma",
        subtitle: "Ninguna persona puede mover fondos unilateralmente",
        badge: "Seguridad",
        foundation: {
          name: "Fundación Epuyén",
          role: "Administrador Principal",
          required: true
        },
        council: {
          name: "Consejo Comunitario",
          role: "Representante Local",
          required: true
        },
        auditor: {
          name: "Auditor Externo",
          role: "Verificador Independiente",
          required: false
        },
        requirement: "Mínimo 2 de 3 firmas para aprobar cualquier movimiento de fondos. Todas las transacciones son públicas y verificables.",
        requiredLabel: "Requerido"
      },
      // Governance Roadmap
      governanceRoadmap: {
        title: "Hoja de Ruta de Gobernanza",
        subtitle: "Hacia una gobernanza cada vez más descentralizada",
        badge: "Evolución",
        currentPhase: {
          phase: "Fase Actual",
          title: "Fundación",
          status: "active",
          items: [
            "Transparencia total de fondos",
            "Reportes públicos mensuales",
            "Verificación de plantaciones con GPS y fotos",
            "Registro público de todos los gastos"
          ]
        },
        v1Phase: {
          phase: "V1 (Próximamente)",
          title: "Participación",
          status: "upcoming",
          items: [
            "Sistema de votación para donantes",
            "Propuestas comunitarias",
            "Selección de zonas de plantación",
            "Priorización de proyectos"
          ]
        },
        v2Phase: {
          phase: "V2 (Futuro)",
          title: "Descentralización",
          status: "future",
          items: [
            "Multi-firma on-chain para tesorería",
            "NFTs de gobernanza para donantes",
            "DAO comunitaria",
            "Auditorías on-chain automatizadas"
          ]
        }
      },
      // CTA
      cta: {
        title: "Participa en la Transparencia",
        description: "Como donante, tienes derecho a participar en las decisiones del proyecto. Tu voz importa en la construcción de este bosque.",
        adoptTree: "Adoptar un Árbol",
        viewTransparency: "Ver Transparencia"
      }
    },
    // Community Page - Complete
    community: {
      title: "Voces de Epuyén",
      subtitle: "Historias reales de quienes viven en el territorio. Pobladores, maestros, bomberos, artesanos — todos unidos por un mismo sueño: recuperar el bosque.",
      badge: "Nuestra Comunidad",
      featuredVoices: {
        title: "Testimonios Destacados",
        subtitle: "Las voces que dan vida a este proyecto",
        person1: {
          name: "Don Roberto Huenchuman",
          role: "Poblador Originario, 78 años",
          quote: "Mis abuelos plantaron estos bosques. Cada árbol que cae es como perder un pedazo de nuestra historia. Este proyecto me devuelve la esperanza de que mis nietos puedan ver lo que yo vi de niño.",
          location: "Epuyén Centro",
          tags: ["Historia Local", "Bosque Nativo"]
        },
        person2: {
          name: "María Elena Curruhuinca",
          role: "Maestra Rural, 52 años",
          quote: "Los chicos de la escuela ahora pueden ver en tiempo real dónde están sus árboles. Cuando plantamos uno, lo buscan en el mapa todos los días. Es educación ambiental real, no de libro.",
          location: "Escuela N°45",
          tags: ["Educación", "Juventud"]
        },
        person3: {
          name: "Juan Carlos Antipán",
          role: "Bombero Voluntario, 45 años",
          quote: "Cada verano perdemos hectáreas por los incendios. Los pinos invasores son como fósforos gigantes. Si este proyecto logra traer el sistema de drones y respuesta rápida, podemos salvar el valle.",
          location: "Cuartel de Bomberos",
          tags: ["Prevención de Incendios", "Seguridad"]
        },
        person4: {
          name: "Silvia Ñancucheo",
          role: "Productora Local",
          quote: "Tengo una chacra de frambuesas. Los pinos secan el agua y las heladas son cada vez peores. Si recuperamos el bosque nativo, vuelve el equilibrio. Esto no es solo ecología, es nuestra economía.",
          location: "Chacra Los Ñires",
          tags: ["Agricultura", "Economía Local"]
        },
        person5: {
          name: "Pedro Millaqueo",
          role: "Guardaparque Retirado",
          quote: "En 40 años vi cómo el lago bajó, cómo desaparecieron especies. El huemul ya casi no se ve. Necesitamos actuar ahora, no en 10 años. Cada árbol nativo que plantamos es una batalla ganada.",
          location: "Lago Epuyén",
          tags: ["Conservación", "Biodiversidad"]
        },
        person6: {
          name: "Ana Luz Puel",
          role: "Artesana Mapuche",
          quote: "Los árboles nativos no son solo madera. Son medicina, son tintes para mis tejidos, son el hogar de los espíritus del bosque. Cuando desaparecen, desaparece nuestra cultura.",
          location: "Comunidad Puel Pvjv",
          tags: ["Cultura Mapuche", "Artesanía"]
        }
      },
      documentary: {
        title: "Serie Documental: \"Raíces de Epuyén\"",
        description: "Estamos produciendo una serie de entrevistas en video con los pobladores más emblemáticos del valle. Sus historias, sus memorias del bosque, y su visión para el futuro.",
        comingSoon: "Próximamente",
        watchTrailer: "Notificarme del estreno",
        features: {
          episodes: "6 episodios de 15 minutos",
          languages: "Entrevistas en Mapudungun y Español",
          locations: "Filmado en locaciones icónicas del valle"
        },
        trailerText: "Trailer próximamente"
      },
      moreStories: {
        title: "Más Historias",
        subtitle: "Cada voz cuenta, cada historia importa"
      },
      instagram: {
        title: "Síguenos en Instagram",
        handle: "@epuyenrenace",
        description: "Actualizaciones diarias del proyecto, fotos del terreno y más historias de la comunidad."
      },
      shareStory: {
        title: "¿Tienes una Historia para Compartir?",
        description: "Si eres parte de la comunidad de Epuyén o has adoptado un árbol, nos encantaría conocer tu historia.",
        cta: "Compartir mi Historia"
      }
    },
    // Map
    map: {
      title: "Mapa del Proyecto",
      viewMap: "Ver Mapa",
      satellite: "Satélite",
      terrain: "Mapa",
      trees: "Árboles",
      legend: "Leyenda",
      planned: "Planificado",
      planted: "Plantado",
      adopted: "Adoptado",
      controls: "Controles",
      dragToMove: "Arrastrar: mover mapa",
      ctrlDragRotate: "Ctrl+Arrastrar: rotar",
      scrollZoom: "Scroll: zoom",
      clickMarker: "Click en marcador: detalles",
      resetView: "Vista inicial",
      loading: "Cargando mapa 3D...",
      interactiveMap: "Mapa 3D Interactivo",
      terrainSource: "Terreno: AWS Terrain Tiles",
      imagerySource: "Imágenes: ESRI World Imagery"
    },
    // Tree Details
    tree: {
      details: "Detalles del Árbol",
      species: "Especie",
      status: "Estado",
      coordinates: "Coordenadas",
      planted: "Plantado",
      adopted: "Adoptado",
      adoptedBy: "Adoptado por",
      plantingDate: "Fecha de Plantación",
      photos: "Fotos",
      adoptThisTree: "Adoptar Este Árbol",
      viewCertificate: "Ver Certificado",
      statuses: {
        planned: "Planificado",
        planted: "Plantado",
        maintained: "En Mantenimiento",
        dead: "Muerto",
        replaced: "Reemplazado"
      }
    },
    // Adoption
    adopt: {
      title: "Adopta un Árbol",
      subtitle: "Tu donación ayuda a restaurar los bosques patagónicos",
      selectPackage: "Selecciona un Paquete",
      sapling: "Plantín",
      youngTree: "Árbol Joven",
      matureTree: "Árbol Maduro",
      donorName: "Nombre del Donante",
      donorNamePlaceholder: "Tu nombre (opcional)",
      anonymous: "Anónimo",
      proceedToPayment: "Proceder al Pago",
      processing: "Procesando...",
      successTitle: "¡Gracias por tu Donación!",
      successMessage: "Tu árbol ha sido asignado. Revisa tu certificado.",
      viewMyCertificate: "Ver Mi Certificado",
      securePayment: "Pago seguro con Stripe"
    },
    // My Forest
    myForest: {
      title: "Mi Bosque",
      subtitle: "Tus Árboles Adoptados",
      noTrees: "Aún no has adoptado ningún árbol.",
      adoptNow: "Adoptar Ahora",
      totalTrees: "Total de Árboles",
      certificate: "Certificado"
    },
    // Transparency
    transparency: {
      title: "Transparencia",
      subtitle: "Cada dólar cuenta. Cada gasto es verificable.",
      summary: "Resumen",
      totalDonated: "Total Donado",
      totalSpent: "Total Gastado",
      balance: "Balance",
      donations: "Donaciones",
      expenses: "Gastos",
      recentDonations: "Donaciones Recientes",
      recentExpenses: "Gastos Recientes",
      category: "Categoría",
      amount: "Monto",
      date: "Fecha",
      receipt: "Recibo",
      viewReceipt: "Ver Recibo",
      categories: {
        seedlings: "Plantines",
        labor: "Mano de Obra",
        tools: "Herramientas",
        transport: "Transporte",
        admin: "Administración"
      }
    },
    // Admin
    admin: {
      title: "Panel de Administración",
      stats: "Estadísticas",
      trees: "Árboles",
      batches: "Lotes",
      importTrees: "Importar Árboles",
      createBatch: "Crear Lote",
      addExpense: "Agregar Gasto",
      uploadPhoto: "Subir Foto"
    },
    donate: {
      phasesAndMilestones: "Fases y Hitos",
      equipmentAndInfrastructure: "Equipamiento e Infraestructura",
      totalEquipmentCost: "Costo Total de Equipamiento",
      priority: "Prioridad",
      phase: "Fase",
      ofGoal: "de",
      active: "Activo",
      pending: "Pendiente",
      future: "Futuro",
      complete: "Completado"
    },
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      view: "Ver",
      close: "Cerrar",
      back: "Volver",
      next: "Siguiente",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todos",
      available: "Disponible",
      unavailable: "No Disponible",
      viewMore: "Ver Más",
      learnMore: "Saber Más",
      targetArea: "Área Objetivo",
      annualTarget: "Objetivo Anual",
      duration: "Duración",
      operations: "Operaciones",
      vesselLength: "Longitud del Barco",
      pumpCapacity: "Capacidad de Bomba",
      crew: "Tripulación",
      propulsion: "Propulsión",
      fullTimeWorkers: "Trabajadores a Tiempo Completo",
      monthlyPerWorker: "Mensual por Trabajador",
      months: "meses",
      totalSalaries: "Total Salarios",
      chainsaws: "Motosierras",
      safetyEquipment: "Equipo de Seguridad",
      quantity: "Cantidad",
      costPerUnit: "Costo por Unidad",
      units: "unidades",
      total: "Total",
      manualDepiningCost: "Costo de Despinado Manual",
      totalManualProgram: "Programa Manual Total",
      socialEnvironmentalImpact: "Impacto Social y Ambiental",
      transparency: "Transparencia",
      thisPlanWill: "Este plan logrará:",
      allWorkWillBe: "Todo el trabajo será:",
      everyContributionSupports: "Cada contribución apoya:"
    },
    // Footer
    footer: {
      tagline: "Restaurando la Patagonia, un árbol a la vez.",
      copyright: "© {year} Epuyén Renace. Todos los derechos reservados."
    }
  },

  // ENGLISH
  en: {
    nav: {
      home: "Home",
      map: "Map",
      adopt: "Adopt",
      myForest: "My Forest",
      transparency: "Transparency",
      admin: "Admin",
      login: "Sign In",
      logout: "Sign Out",
      more: "More",
      community: "Community",
      education: "Education",
      governance: "Transparency",
      vision: "Our Vision"
    },
    vision: {
      badge: "Our Vision",
      title: "Our Vision",
      opening: "Our vision is to demonstrate to the world that it is possible to rebuild a place that has been ecologically destroyed — through transparency, structure, and collective action.",
      whatWeAre: {
        title: "What Epuyén Renace Is",
        description: "Epuyén Renace exists to create a post-fire regeneration model: a system where land recovery, ecological restoration, and community development are driven by verifiable data instead of blind trust."
      },
      transparency: {
        title: "Blockchain Transparency",
        description: "By using blockchain technology as a transparency layer, every contribution, every expense, and every action can be publicly tracked. Not to speculate — but to restore confidence in how recovery efforts are funded and executed."
      },
      belief: {
        title: "What We Believe",
        description: "We believe that when transparency replaces corruption and structure replaces improvisation, communities can rise again — even after total environmental loss."
      },
      goal: {
        title: "Our Goal",
        description: "Our goal is not only to restore Epuyén, but to prove that a new economic model for ecological recovery is possible — one that can be replicated in fire-affected regions around the world."
      },
      closing: {
        line1: "From ashes, a system can be rebuilt.",
        line2: "From destruction, a future can be designed."
      }
    },
    landing: {
      heroTitle: "Reborn with Epuyén",
      heroSubtitle: "Adopt a tree. Restore Patagonia.",
      heroCta: "Adopt a Tree",
      heroExplore: "Explore the Map",
      viewRoadmap: "View the Roadmap",
      missionTitle: "Our Mission",
      missionText: "Restore the native forests of Argentine Patagonia through community reforestation and radical transparency technology.",
      restoringPatagonia: "Restoring",
      patagonia: "Patagonia",
      howItWorksTitle: "How It Works",
      simpleProcess: "Simple Process",
      step1Title: "Explore the Map",
      step1Text: "Navigate our interactive map and select an available tree to adopt.",
      step2Title: "Adopt Your Tree",
      step2Text: "Make your donation and receive a unique token with your tree's GPS coordinates.",
      step3Title: "Track Its Growth",
      step3Text: "Receive updates with photos and progress tracking of your tree.",
      impactTitle: "Our Impact",
      treesPlanted: "Trees Planted",
      treesAdopted: "Trees Adopted",
      donorsCount: "Donors",
      co2Offset: "Tons CO₂ Offset",
      transparencyTitle: "Total Transparency",
      transparencyText: "Every donation and expense is publicly verifiable. No secrets, only results.",
      viewTransparency: "View Public Record",
      footerTagline: "Restoring Patagonia, one tree at a time.",
      // What Happened Section
      whatHappened: {
        title: "What Happened to Epuyén?",
        year: "In 2025 and 2026, Epuyén was hit by the worst wildfires in its history.",
        hectares: "More than 9,000 hectares of native Andean forest were destroyed.",
        ecosystems: "Entire ecosystems burned.",
        homes: "Homes were lost.",
        wildlife: "Wildlife disappeared.",
        landExposed: "The land was left exposed, dry, and vulnerable.",
        balanceBroken: "The fires did not only consume trees — they broke the natural balance that protects water, soil, and climate. Without forest cover, rainfall decreases, erosion increases, and the risk of future fires becomes even greater.",
        minimalEfforts: "Despite the scale of the disaster, recovery efforts were minimal. There was no comprehensive ecological restoration plan, no long-term prevention strategy, and no structural rebuilding program.",
        peopleStayed: "The people of Epuyén stayed. They stayed to care, to resist, and to start again.",
        todayScars: "Today, the land still carries the scars — but also the possibility of regeneration.",
        epuyenCreated: "Epuyén Renace was created to transform tragedy into structure: to restore native forests, reduce fire risk, rebuild ecological balance and ensure this never happens again.",
        fromAshes: "From ashes, chance does not arise: the future is built with intention, truth, and community."
      },
      coreChallenges: {
        title: "The Core Challenges",
        mainChallenge: "The main challenge in Epuyén is de-pining — the large-scale removal of invasive pine species that have overtaken the landscape.",
        effectiveMethod: "Through field experience and testing, we have identified the most effective method: mulching the pine on site, allowing the organic material to regenerate the soil instead of removing or burning it.",
        processRestores: "This process restores humidity, improves soil structure, and creates immediate conditions for native forest recovery.",
        parallelReplanting: "At the same time, replanting begins in parallel. Removal and regeneration must happen together — not years apart — to prevent erosion and re-colonization by invasive species.",
        secondMission: "Our second major mission is fire prevention and future risk reduction.",
        moreThanPlanting: "This requires more than planting trees. It demands permanent operational capacity, including the acquisition of specialized equipment capable of working in difficult terrain and responding quickly to fire threats.",
        foundationInvest: "To achieve this, the foundation must invest in:",
        investList: {
          machinery: "Forestry and mulching machinery",
          equipment: "Terrain-accessible equipment",
          tools: "Tools for fuel-load reduction and maintenance",
          infrastructure: "Long-term prevention infrastructure"
        },
        withoutEquipment: "Without this equipment, regeneration remains fragile and the cycle of destruction repeats.",
        breakCycle: "Epuyén Renace exists to break that cycle — by restoring the land, reducing fire risk, and building a permanent system of prevention for the future."
      },
      donationCategories: {
        title: "Donation Categories",
        subtitle: "Choose exactly how you want your contribution to be used",
        cta: {
          supportMission: "Support This Mission",
          ctaDescription: "Every donation goes directly to acquiring equipment and completing these phases. All expenses are publicly documented with photos, receipts, and GPS data.",
          donateToCategory: "Donate to This Category",
          viewTransparency: "View Transparency Records"
        },
        category1: {
          icon: "🟫",
          title: "De-Pining & Wildfire Prevention",
          description: "The devastation experienced in Epuyén cannot be solved through emergency response alone. To prevent future mega-fires, the territory must undergo structural fuel reduction, carried out over several years.",
          supports: "Your contribution supports permanent wildfire prevention infrastructure, local employment, and long-term ecological stability.",
          items: [
            "Removal of invasive pine",
            "Fuel load reduction",
            "Protection of native forest"
          ],
          method: "Mechanical de-pining with mulching + selective manual removal",
          impact: "Direct reduction of wildfire risk while regenerating the ecosystem",
          fiveYearPlan: {
            title: "Five-Year Aggressive Prevention Plan",
            subtitle: "De-Pining, Mulching & Wildfire Risk Reduction",
            intro: "The devastation experienced in Epuyén cannot be solved through emergency response alone. To prevent future mega-fires, the territory must undergo structural fuel reduction, carried out over several years, with methods that restore soil and ecosystem balance.",
            programDescription: "This plan establishes a five-year aggressive intervention program, focused on invasive pine removal using on-site mulching, combined with selective manual work where native forest remains.",
            objective: "To drastically reduce wildfire risk across the Epuyén valley by:",
            objectiveItems: [
              "Removing invasive pine species",
              "Eliminating extreme fuel loads",
              "Stabilizing soil and water systems",
              "Enabling native forest regeneration",
              "Creating permanent prevention capacity"
            ],
            targetArea: "Approximately 4,500 hectares of invasive pine (alive and dead)",
            targetAreaDetail: "Located across valley slopes, interface zones, and post-fire landscapes",
            annualTarget: "900 hectares/year",
            duration: "5 consecutive years",
            durationDetail: "12 months per year of operation",
            durationNote: "Wildfire prevention cannot be seasonal — fuel accumulates year-round.",
            operations: "12 months/year",
            methodology: {
              title: "Operational Method",
              intro: "The plan integrates two complementary methods:",
              methods: [
                "Mechanical de-pining with mulching",
                "Manual / surgical removal in mixed forest"
              ],
              note: "Both are required to avoid ecological damage and ensure effectiveness."
            },
            phases: {
              year1: {
                title: "Year 1 — Emergency Stabilization",
                items: [
                  "Priority zones near homes and infrastructure",
                  "Removal of dead pine and surface fuel",
                  "Creation of immediate protection corridors"
                ]
              },
              year2: {
                title: "Year 2 — Valley-Scale Intervention",
                items: [
                  "Expansion to large pine-dominated areas",
                  "Continuous mulching operations",
                  "Start of regeneration monitoring"
                ]
              },
              year3: {
                title: "Year 3 — Deep Landscape Treatment",
                items: [
                  "Interior slopes and difficult access zones",
                  "Combined mechanical + manual operations"
                ]
              },
              year4: {
                title: "Year 4 — Regrowth Control",
                items: [
                  "Second pass in treated areas",
                  "Suppression of pine regeneration",
                  "Soil stabilization reinforcement"
                ]
              },
              year5: {
                title: "Year 5 — Long-Term Stabilization",
                items: [
                  "Final fuel load balancing",
                  "Transition to maintenance phase",
                  "Monitoring and adaptive management"
                ]
              }
            },
            twoMethods: {
              intro: "The de-pining of Epuyén cannot rely on machinery alone. Large areas of the valley contain mixed forest, where invasive pine grows intertwined with native species. In these zones, heavy machinery cannot be used without destroying the native forest.",
              approach: "For this reason, the prevention plan combines heavy machinery for dense pine areas, manual surgical removal in mixed forests, and long-term local employment. This integrated approach allows true prevention without ecological damage.",
              mechanical: {
                title: "Mechanical De-Pining",
                description: "Used in dense pine stands where no native forest remains.",
                items: [
                  "Forestry mulchers",
                  "Excavators and support machinery",
                  "Large-scale fuel reduction"
                ],
                note: "This is the fastest method and covers large surfaces."
              },
              manual: {
                title: "Manual / Surgical De-Pining",
                description: "Used in sensitive zones:",
                zones: [
                  "Pine mixed with native forest",
                  "Regeneration areas",
                  "Riparian zones",
                  "Buffer areas near water, homes, and trails"
                ],
                method: "This work is done by trained crews using chainsaws, selectively removing invasive pine while preserving native species.",
                note: "This method is slower — but ecologically essential."
              }
            },
            employment: {
              title: "Local Employment Program",
              intro: "To carry out manual de-pining at scale, the project includes a 5-year employment program.",
              priority: "Priority hiring from Epuyén and surrounding communities",
              equipmentItems: [
                "Safety gear (helmets, chaps, boots, gloves)",
                "Spare chains, bars, fuel mix",
                "Maintenance tools"
              ],
              manualCostCategories: [
                "Salaries (50 workers × 5 years)",
                "Chainsaws (50 units)",
                "Safety & tools"
              ]
            },
            whyMulching: {
              title: "Why Mulching Is the Best Option",
              intro: "Mulching means grinding the pine directly on site and returning the organic material to the soil.",
              fundamentalDifference: "This is fundamentally different from removing wood or burning debris.",
              vsRemoving: {
                title: "Removing Wood",
                intro: "Removing wood:",
                problems: [
                  "Dries and exposes soil",
                  "Removes organic matter",
                  "Destroys microbial life",
                  "Increases erosion",
                  "Requires heavy transport logistics",
                  "Concentrates combustible waste elsewhere"
                ],
                conclusion: "It turns a forest into a biological desert."
              },
              vsBurning: {
                title: "Burning",
                intro: "Burning:",
                problems: [
                  "Releases carbon immediately",
                  "Sterilizes soil",
                  "Kills fungi, insects, and microorganisms",
                  "Increases hydrophobic soils (water repellency)",
                  "Dramatically increases erosion risk"
                ],
                conclusion: "Burned soils often reject water, worsening floods and landslides."
              },
              benefits: {
                title: "Mulching Benefits",
                intro: "Mulching:",
                items: [
                  "Returns carbon to the soil",
                  "Protects soil from sun and wind",
                  "Retains moisture",
                  "Feeds microorganisms and fungi",
                  "Accelerates soil regeneration",
                  "Prevents erosion",
                  "Suppresses invasive regrowth",
                  "Creates ideal conditions for native planting"
                ],
                conclusion: "Mulching transforms fuel into soil life.",
                statement: "It is the only method that reduces fire risk while regenerating the ecosystem at the same time."
              }
            },
            costExplanation: {
              title: "Associated Costs (5 Years)",
              mechanical: {
                title: "Mechanical De-Pining & Mulching",
                capex: {
                  title: "One-time Investment (CAPEX)",
                  includes: "Includes:",
                  items: [
                    "Forestry mulchers",
                    "Excavators and dozers",
                    "Loaders",
                    "Transport vehicles",
                    "Service units"
                  ],
                  cost: "USD 3.0 – 5.8 million",
                  note: "This equipment remains available long-term."
                },
                opex: {
                  title: "Operational Costs (5 years)",
                  includes: "Includes:",
                  items: [
                    "Fuel",
                    "Maintenance",
                    "Spare parts",
                    "Transport",
                    "Continuous operation"
                  ],
                  cost: "USD 6.1 – 10.7 million"
                }
              },
              manual: {
                title: "Manual / Surgical De-Pining",
                intro: "Required where pine is mixed with native forest.",
                includes: "Includes:",
                items: [
                  "50 full-time local workers",
                  "Professional chainsaws",
                  "Safety equipment"
                ],
                calculation: "50 workers × USD 1,000 × 60 months = USD 3,000,000",
                equipment: "Equipment & safety: USD 125,000",
                total: "Total manual program: USD 3.125 million"
              },
              totalCost: {
                title: "Total Five-Year Prevention Cost",
                components: [
                  { category: "Machinery investment", cost: "USD 3.0 – 5.8 M" },
                  { category: "Machinery operation (5 years)", cost: "USD 6.1 – 10.7 M" },
                  { category: "Manual de-pining (5 years)", cost: "USD 3.125 M" }
                ],
                total: "TOTAL PROGRAM",
                totalRange: "USD 12.2 – 19.6 million"
              }
            },
            results: {
              title: "What This Plan Achieves",
              intro: "Over five years, this program will:",
              items: [
                "Drastically reduce wildfire intensity",
                "Remove extreme fuel loads",
                "Stabilize soils and slopes",
                "Restore moisture cycles",
                "Protect remaining native forest",
                "Enable reforestation success",
                "Reduce future firefighting costs",
                "Create long-term ecological resilience",
                "Generate stable local employment"
              ]
            },
            finalMessage: {
              line1: "Firefighting alone reacts to disaster.",
              line2: "Mulching-based prevention eliminates the conditions that allow disaster to occur.",
              statement: "This is not cleanup. This is landscape engineering for safety."
            },
            capex: {
              title: "Investment Breakdown (CAPEX)",
              total: "Total Investment",
              argentinaLanded: {
                title: "Argentina Landed Cost (Imports + Logistics)",
                learnMore: "Learn more",
                learnLess: "Hide details",
                intro: "The international \"base price\" is not the real cost in Argentina. Heavy forestry machinery costs significantly more due to import taxes, VAT, customs clearance, port handling, inland transport to Patagonia, delays, and spare parts inflation.",
                points: [
                  "Typical import overhead can add +40% to +90% depending on equipment type and import pathway.",
                  "NGO exemptions may exist later, but they are not guaranteed before legal registration. We treat them as potential upside, not assumed.",
                  "Patagonia inland transport and port delays add meaningful cost.",
                  "Spare parts are expensive and slow in Argentina — we include a 10-15% readiness buffer (critical for uptime)."
                ],
                costBreakdown: {
                  title: "Realistic Cost Summary",
                  baseMachinery: "Base machinery (international price)",
                  baseRange: "~USD 3.0–5.8M",
                  importTaxes: "Import/taxes/logistics (Argentina)",
                  importRange: "+USD 2.4–2.8M",
                  spareParts: "Spare parts/readiness buffer (10-15%)",
                  spareRange: "+USD 0.7–1.0M",
                  totalLanded: "Estimated real landed CAPEX in Argentina",
                  totalRange: "USD 7.5–8.2M"
                },
                disclaimer: "All budgets reflect realistic landed costs in Argentina (taxes, logistics to Patagonia, readiness). Any future exemptions reduce cost and increase hectares treated."
              }
            },
            strategic: {
              title: "Strategic Importance",
              establishes: "This infrastructure establishes:",
              items: [
                "Permanent fire-prevention capacity",
                "Rapid intervention capability",
                "Independence from emergency-only responses",
                "Ability to maintain treated zones long-term"
              ],
              note: "This is the foundation of a real, sustainable prevention program."
            },
            conclusion: "This approach is not symbolic — it is structural. The aggressive 5-year de-pining plan is only achievable with a dedicated, professional forestry fleet combined with trained manual crews. This transforms Epuyén from a reactive disaster zone into a region with permanent wildfire-prevention infrastructure.",
            soilComparison: {
              title: "Native Forest Soil vs Pine Plantation Soil",
              subtitle: "Why fire spreads much faster in pine forests",
              intro: "The difference is not only the tree. The difference is the entire soil system underneath.",
              native: {
                title: "Native Forest Soil",
                species: "coihue, lenga, ñire, radal",
                description: "Native Patagonian forests create:",
                characteristics: [
                  "High organic diversity",
                  "Deep humus layer",
                  "Fungal networks (mycorrhizae)",
                  "Constant moisture retention",
                  "Spongy structure",
                  "Slow decomposition",
                  "High microbial activity"
                ],
                moisture: "25–45%",
                moistureLabel: "Typical soil moisture",
                moistureNote: "Even in summer.",
                fireBehavior: {
                  title: "Fire behavior:",
                  points: [
                    "Flames stay low",
                    "Fire spreads slowly",
                    "Often self-extinguishes",
                    "Burns patchy, not continuous",
                    "Difficult to crown"
                  ]
                },
                spreadSpeed: "0.1–0.5 meters per minute",
                spreadNote: "Often stops at night."
              },
              pine: {
                title: "Pine Plantation Soil",
                warning: "Pine radically alters soil.",
                characteristics: [
                  "Acidic litter (pH 3.5–4.5)",
                  "Resin-saturated needles",
                  "Poor microbial diversity",
                  "Almost no fungal symbiosis",
                  "Compacted mineral soil",
                  "Hydrophobic (repels water)",
                  "Rapid drying"
                ],
                moisture: "5–12%",
                moistureLabel: "Typical soil moisture",
                moistureNote: "Even near lakes.",
                fireBehavior: {
                  title: "Fire behavior:",
                  points: [
                    "Ignites easily",
                    "Fire travels continuously",
                    "Flames climb vertically",
                    "Intense radiant heat",
                    "Crowns ignite rapidly"
                  ]
                },
                spreadSpeed: "5–20 meters per minute",
                spreadWind: "40–60 meters per minute",
                spreadWindLabel: "In wind:",
                spreadComparison: "That's 100× faster."
              },
              fireLadders: {
                title: "Why pine fires move so fast",
                intro: "Because pine creates three fire ladders at once:",
                ladder1: {
                  title: "Resin needles (ground fuel)",
                  points: [
                    "Highly flammable",
                    "Ignition temperature ≈ 260°C",
                    "Native leaf litter ignites ≈ 450–500°C",
                    "Already nearly 2× difference"
                  ]
                },
                ladder2: {
                  title: "Vertical ladder fuel",
                  points: [
                    "Branches from ground to crown",
                    "Fire climbs easily",
                    "Native trees self-prune naturally"
                  ]
                },
                ladder3: {
                  title: "Crown continuity",
                  points: [
                    "Pine canopies are uniform",
                    "Fire jumps crown-to-crown",
                    "Native forest is irregular and broken"
                  ]
                }
              },
              comparisonTable: {
                title: "Quantified comparison",
                headers: ["Factor", "Native forest", "Pine plantation"],
                rows: [
                  ["Soil moisture", "25–45%", "5–12%"],
                  ["Litter ignition temp", "450–500°C", "260–300°C"],
                  ["Fire spread speed", "0.1–0.5 m/min", "5–60 m/min"],
                  ["Crown fire probability", "Very low", "Extremely high"],
                  ["Self-extinguishing", "Common", "Rare"],
                  ["Soil recovery after fire", "Fast", "Very slow"],
                  ["Erosion risk", "Low", "Extreme"]
                ]
              },
              intensity: {
                title: "Fire intensity comparison",
                label: "Fire intensity (kW/m):",
                native: "500–2,000 kW/m",
                pine: "20,000–60,000 kW/m",
                comparison: "That's 10–30 times more energy.",
                warning: "No firefighter can stand near that."
              },
              waterCycle: {
                title: "Water cycle difference (critical)",
                native: {
                  title: "Native forest soil:",
                  points: ["Absorbs rain", "Stores water", "Releases moisture slowly", "Cools microclimate"]
                },
                pine: {
                  title: "Pine soil:",
                  points: ["Repels rain", "Runoff increases", "Dries quickly", "Increases heat"]
                },
                conclusion: "This creates hot, dry, windy microclimates. Fire feeds on that."
              },
              feedback: {
                title: "Why fires 'explode' in pine areas",
                intro: "Because pine systems:",
                points: [
                  "Dry faster",
                  "Ignite earlier",
                  "Burn hotter",
                  "Spread faster",
                  "Burn continuously",
                  "Regenerate more pine afterward"
                ],
                conclusion: "It's a feedback loop."
              },
              summary: {
                title: "Summary in simple words",
                native: "Native forest = damp sponge",
                pine: "Pine plantation = gasoline carpet",
                note: "That's not exaggeration — that's physics."
              },
              publicQuote: "Pine trees do not only burn — they redesign the soil to burn faster.",
              whyWorks: {
                title: "Why de-pining works",
                intro: "Removing pine:",
                points: [
                  "Raises soil moisture",
                  "Restores fungi",
                  "Breaks fuel continuity",
                  "Lowers flame height",
                  "Slows fire spread",
                  "Allows native species to return"
                ],
                conclusion: "That's why prevention works."
              }
            },
            transparency: {
              title: "Transparency & Accountability",
              intro: "All work will be:",
              items: [
                "Georeferenced",
                "Measured in hectares treated",
                "Documented visually",
                "Reported monthly",
                "Published on the Epuyén Renace transparency platform"
              ],
              conclusion: "Every dollar will be traceable to land protection."
            },
            costExplanation: {
              title: "Cost Explanation",
              intro: "Real wildfire prevention cannot be achieved through isolated actions or short-term interventions.",
              requirement: "To protect Epuyén, a continuous five-year plan is required.",
              mechanical: {
                title: "1. Mechanical De-Pining",
                description: "This method is used in areas where invasive pine dominates the landscape.",
                capability: "It allows large-scale intervention and rapid reduction of dangerous fuel loads.",
                includes: "What this cost includes",
                items: [
                  "Forestry mulchers (specialized shredders)",
                  "Excavators and support equipment",
                  "Fuel, maintenance, and transport",
                  "Trained operators"
                ],
                oneTimeInvestment: "One-time investment:",
                oneTimeRange: "USD 3.0 – 5.8 million",
                operationalCost: "Operational cost (5 years):",
                operationalRange: "USD 6.1 – 10.7 million",
                note: "This investment creates permanent wildfire-prevention capacity."
              },
              manual: {
                title: "2. Manual / Surgical De-Pining",
                description: "In many areas, invasive pine grows mixed with native forest.",
                limitation: "Heavy machinery cannot be used without destroying native ecosystems.",
                whereApplied: "Where it is applied",
                zones: [
                  "Pine mixed with native forest",
                  "Regeneration areas",
                  "Riparian zones",
                  "Buffer zones"
                ],
                workers: "50 full-time workers",
                salary: "USD 1,000/month",
                duration: "5 years",
                totalCost: "Total manual de-pining (5 years):",
                totalAmount: "USD 3.125 million"
              },
              totalCost: {
                title: "Total Cost — Five-Year Prevention Plan",
                componentHeader: "Component",
                costHeader: "Cost",
                components: [
                  { name: "Machinery (one-time investment)", cost: "USD 3.0 – 5.8M" },
                  { name: "Machinery operation (5 years)", cost: "USD 6.1 – 10.7M" },
                  { name: "Manual de-pining (5 years)", cost: "USD 3.125M" }
                ],
                total: "TOTAL PROGRAM",
                totalRange: "USD 12.2 – 19.6 million"
              },
              delivers: {
                title: "What this plan delivers",
                intro: "This investment is not symbolic — it is structural.",
                notEmergency: "Not an emergency response",
                structural: "Permanent prevention infrastructure"
              },
              whyFiveYears: {
                title: "Why 5 Years?",
                intro: "Fire ecology does not respect annual budgets.",
                allows: "Only a 5-year commitment allows:",
                items: [
                  "Treating 4,500 hectares methodically",
                  "Responding to pine regrowth (which re-sprouts)",
                  "Building local capacity and employment",
                  "Creating lasting ecological resilience"
                ],
                conclusion: "Shorter timeframes cannot break the fire cycle."
              },
              transparency: {
                title: "Transparency & Accountability",
                intro: "All work will be:",
                items: [
                  "Georeferenced",
                  "Measured in hectares treated",
                  "Documented visually",
                  "Reported monthly"
                ],
                conclusion: "Every contribution is verifiable."
              }
            },
            preventionStatement: "Prevention is not an expense. It is the only insurance a forest has."
          }
        },
        category2: {
          icon: "🚒",
          title: "Firefighting Boat System for Lago Epuyén",
          description: "This category establishes a permanent water-based firefighting unit capable of rapid deployment and high-capacity pumping.",
          supports: "Donations support:",
          items: [
            "specialized firefighting vessel",
            "industrial high-capacity pump system",
            "hose systems and reels",
            "electric/hybrid propulsion",
            "safety and firefighting equipment"
          ],
          objective: "The objective is to transform Lago Epuyén from a passive element into an active fire-defense asset.",
          impact: "This category protects lives, forests, and infrastructure with response capability in minutes.",
          boatSystem: {
            title: "Firefighting Boat System for Lago Epuyén",
            subtitle: "Rapid Water-Based Fire Response Unit",
            objective: "To establish a permanent firefighting boat unit capable of rapid deployment, high-capacity water pumping, and supporting ground brigades — transforming Lago Epuyén from a passive element into an active fire-defense asset.",
            vesselLength: "9-12 meters",
            pumpCapacity: "4,000-8,000 L/min",
            crew: "6-10 firefighters",
            propulsion: "Electric/Hybrid",
            context: "Lago Epuyén represents one of the most strategic firefighting resources in the entire valley. However, despite its proximity to high-risk forest areas, there is currently no dedicated water-based firefighting system.",
            challengesTitle: "Why Water-Based Response?",
            challengesIntro: "Epuyén's geography creates three major challenges:",
            challenges: [
              "Steep forested slopes",
              "Limited road access",
              "Strong valley winds"
            ],
            solutionStatement: "Water-based response solves all three.",
            capabilitiesTitle: "A boat can:",
            capabilities: [
              "Reach fire fronts faster than trucks",
              "Pump unlimited water from the lake",
              "Operate even when roads are blocked",
              "Attack fires from below the slope",
              "Reduce response time by 60-80%"
            ],
            operationalFunctions: [
              "Active wildfire suppression",
              "Early attack during ignition",
              "Support of land brigades",
              "Structure protection near lake zone",
              "Patrol and rapid inspection",
              "Training and preparedness"
            ],
            integration: [
              "Municipal fire brigades",
              "Provincial emergency services",
              "Forest fire response units"
            ],
            environmentalBenefits: [
              "No fuel spills into the lake",
              "Reduced helicopter dependency",
              "Minimal environmental footprint",
              "Silent operation during night response"
            ],
            capex: {
              title: "Total Investment (CAPEX)",
              total: "Total Investment"
            },
            strategic: {
              title: "Strategic Value",
              establishes: "This system creates:",
              items: [
                "Permanent water-based firefighting capacity",
                "Rapid response capability within minutes",
                "Lower suppression costs",
                "Reduced fire spread probability",
                "Protection of homes, forests, and water sources"
              ],
              note: "It converts Lago Epuyén from a passive element into an active fire-defense asset."
            },
            conclusion: "A dedicated firefighting boat on Lago Epuyén represents one of the most efficient investments in wildfire prevention and response. It transforms the lake into a frontline defense system — protecting the valley before fires become disasters."
          }
        },
        category3: {
          icon: "🌱",
          title: "Reforestation & Future Preservation",
          description: "This category supports the long-term ecological recovery of Epuyén.",
          supports: "Donations are used for:",
          items: [
            "planting native trees",
            "nursery development",
            "soil regeneration",
            "long-term maintenance",
            "biodiversity restoration",
            "monitoring and protection of regenerated areas"
          ],
          impact: "This ensures that restored forests survive, mature, and remain protected for future generations."
        },
        category4: {
          icon: "♻️",
          title: "Waste Management & Contamination",
          description: "Through on-the-ground observation and community dialogue, we have identified that Epuyén faces a significant open waste and contamination challenge.",
          supports: "Currently focused on:",
          items: [
            "understanding existing waste flows",
            "identifying contamination risks",
            "mapping open dumping zones",
            "studying environmental and health impacts",
            "reviewing viable models from similar rural communities"
          ],
          objective: "The objective is not to impose a solution, but to build one that is realistic, sustainable, and appropriate for Epuyén's scale and geography.",
          impact: "Addressing contamination is essential to protecting water sources, restoring ecosystems, and ensuring a healthy future for the community.",
          researchPhase: {
            title: "Waste Management & Contamination",
            currentPhase: "Research & Diagnostic Phase",
            context: "Through on-the-ground observation and community dialogue, we have identified that Epuyén faces a significant open waste and contamination challenge, including informal dumping areas that pose long-term risks to soil, water, and public health.",
            statement: "This issue cannot be addressed through improvisation or isolated actions.",
            focusTitle: "Current Focus Areas:",
            focusAreas: [
              "Understanding existing waste flows",
              "Identifying contamination risks",
              "Mapping open dumping zones",
              "Studying environmental and health impacts",
              "Reviewing viable models used in similar rural and mountain communities"
            ],
            requirement: "Waste management requires technical accuracy, regulatory coordination, and long-term planning.",
            ethos: "As part of our ethos, no solution will be announced without proper research.",
            commitment: "Once this assessment phase is completed, Epuyén Renace will publish a clear, public, and transparent waste-management proposal, open for community review and institutional dialogue.",
            objective: "The objective is not to impose a solution, but to build one that is realistic, sustainable, and appropriate for Epuyén's scale and geography.",
            importance: "Addressing contamination is essential to protecting water sources, restoring ecosystems, and ensuring a healthy future for the community."
          }
        },
        category5: {
          icon: "🏛️",
          title: "33ha Biosphere Park & Foundation Center",
          description: "The long-term vision project: 33 hectares of public biosphere park with foundation headquarters, education center, and sustainable local economy.",
          supports: "Donations support:",
          items: [
            "foundation headquarters and environmental education center",
            "20 eco-houses for volunteers and visitors",
            "public park with trails and conservation areas",
            "420m² dome for events and conferences",
            "Japanese wellness spa",
            "lakeside restaurant",
            "dock for fire boat and public access",
            "local food production facility"
          ],
          objective: "The goal is to create a self-sustaining model that generates local employment, education, and regenerative tourism.",
          impact: "This category builds the permanent legacy and infrastructure for future generations."
        },
        transparency: {
          title: "Transparency by Category",
          description: "Each donation category has:",
          items: [
            "a dedicated budget",
            "public progress tracking",
            "documented expenses",
            "photos, GPS data, and reports",
            "blockchain-based transparency records"
          ],
          verify: "Donors can choose exactly how their contribution is used and verify its impact at every stage."
        },
        oneSystem: {
          title: "One System, Five Missions",
          depining: "De-pining reduces risk.",
          firefighting: "Firefighting protects in emergencies.",
          reforestation: "Reforestation restores life.",
          contamination: "Waste management protects water and health.",
          biosphere: "Biosphere park builds the sustainable future.",
          together: "Together, they form a complete and permanent post-fire recovery model for Epuyén — proving that a place can rise again when there's organization, technology, and real commitment."
        }
      }
    },
    roadmap: {
      title: "Roadmap",
      subtitle: "A long-term system to regenerate the land and give Epuyén a future. Not politics or charity — verifiable action.",
      thePlan: "The Plan",
      active: "Active",
      upcoming: "Upcoming",
      comingSoon: "Coming Soon",
      rAndD: "R&D",
      vision: "Vision",
      future: "Future",
      goal: "Goal",
      raised: "Raised",
      totalGoal: "Total Goal",
      treesAdopted: "Trees Adopted",
      projectPhases: "Project Phases",
      progress: "Progress",
      everyContribution: "Every contribution brings us closer to the goal",
      phase0: {
        title: "Foundation + Digital Transparency",
        description: "Create Fundación Epuyén Renace, launch website + public roadmap, set up drone/LiDAR digital map, define zones, KPIs, cost model and blockchain system for tracking donations and expenses.",
        tags: ["Website", "3D Map", "Blockchain", "Legal Foundation"],
        status: "Initial Setup"
      },
      phase1: {
        title: "Reforestation Sprint",
        description: "Plant 10,000 native trees. Each tree costs ~USD $25 and is tracked with GPS, photos, status timeline and public record.",
        tags: ["10,000 Trees", "GPS Tracking", "Photos", "Public Record"],
        treesAdopted: "trees adopted",
        available: "available"
      },
      phase2: {
        title: "Risk Reduction + Expansion",
        description: "Remove 5,000 invasive pines, plant 20,000 native trees, and acquire 2 chippers to process pine into mulch and reduce fire load.",
        tags: ["5,000 Pines Removed", "20,000 Natives", "2 Chippers"],
        proof: "Publish proof: removal logs + planting batches + receipts"
      },
      phase3: {
        title: "Patagonia Fire-Response Innovation",
        description: "Design and build a proprietary hybrid fire-fighting system: water/boat capability + drones + ground response. Goal: early detection + fast containment in remote terrain.",
        tags: ["Drones", "Hybrid Vehicle", "Early Detection", "Open R&D"],
        milestones: "Clear milestones, prototypes and public reports"
      },
      phase4: {
        title: "33HA Public Biosphere Park",
        description: "Purchase 33 hectares, owned by Fundación Epuyén Renace. Design it as a public biosphere park with: biodiversity restoration zones, invasive species education, regenerative food production demonstration, processing center, cafeteria, lakefront restaurant + docks, and education center.",
        tags: ["33 Hectares", "Education Center", "Lake Restaurant", "Docks", "Local Production"],
        purpose: "Permanent protection + jobs + education + sustainable local economy"
      },
      phase5: {
        title: "Full SaaS Platform",
        description: "Epuyén becomes a digital twin. Drone/LiDAR surveyed map: trees counted and registered, 1 tree = 1 token/certificate, interactive adoption marketplace, on-chain + off-chain transparency dashboards, volunteer/community modules, reports and auditing tools.",
        tags: ["Digital Twin", "LiDAR", "NFT Tokens", "On-Chain", "Auditing"],
        scalable: "Scalable model for other conservation projects"
      },
      summary: {
        foundation: "Foundation",
        trees10k: "10K Trees",
        expansion: "Expansion",
        fireFighting: "Fire-Fighting",
        park33ha: "33HA Park",
        platform: "Platform"
      }
    },
    education: {
      title: "Learn About the Forest",
      subtitle: "Knowledge is power. Understanding our ecosystem is the first step to protecting it. Here you'll find everything you need to know about the Patagonian forest.",
      badge: "Environmental Education",
      nativeForest: {
        title: "The Patagonian Native Forest",
        subtitle: "Meet the species we're protecting",
        lenga: {
          title: "Lenga (Nothofagus pumilio)",
          description: "Deciduous tree that can reach 30 meters. Its leaves turn red and golden in autumn, creating spectacular landscapes. It's fundamental for the biodiversity of the Andean-Patagonian forest."
        },
        coihue: {
          title: "Coihue (Nothofagus dombeyi)",
          description: "Evergreen species that can live over 500 years. It provides shelter and food for dozens of bird and mammal species. Its wood is valuable but its ecological value is incalculable."
        },
        cipres: {
          title: "Cordilleran Cypress",
          description: "Native conifer that can exceed 1000 years of age. Resistant and adapted to the Patagonian climate, it's a symbol of permanence and resilience."
        }
      },
      invasiveSpecies: {
        title: "Invasive Species",
        subtitle: "The pine problem and other threats",
        pine: {
          title: "Invasive Pine",
          description: "Introduced for commercial forestry, pine spreads aggressively, displacing native forest. It acidifies the soil, reduces biodiversity and dramatically increases fire risk.",
          impact: "High"
        },
        rosehip: {
          title: "Rose Hip",
          description: "Although it produces edible fruits, this European species spreads rapidly and competes with native vegetation for resources.",
          impact: "Medium"
        },
        broom: {
          title: "Broom",
          description: "Highly flammable shrub that colonizes degraded areas, making native forest regeneration difficult.",
          impact: "High"
        }
      },
      fireRisk: {
        title: "Fire Risk",
        subtitle: "Understanding and preventing the threat",
        whyPinesDangerous: {
          title: "Why are pines dangerous?",
          description: "Pines contain highly flammable resins. A pine forest can burn 10 times faster than a native forest. Additionally, their dense canopies facilitate crown fire spread, the most destructive type."
        },
        nativeForestRole: {
          title: "The role of native forest",
          description: "Native trees like lenga have higher moisture content and fewer resins. A healthy native forest acts as a natural firebreak and recovers better after a fire."
        },
        communityPrevention: {
          title: "Community prevention",
          description: "Pine removal, firebreak creation, and early detection systems are fundamental. Each native tree planted contributes to reducing the risk."
        }
      },
      biodiversity: {
        title: "Biodiversity",
        subtitle: "The life that depends on the forest",
        fauna: {
          title: "Emblematic fauna",
          description: "The huemul (endangered Patagonian deer), the pudú (world's smallest deer), the puma, and dozens of bird species depend on the native forest."
        },
        lifeNetwork: {
          title: "Web of life",
          description: "Each native tree supports a network of fungi, lichens, insects, birds and mammals. This biodiversity doesn't exist in pine plantations."
        },
        corridors: {
          title: "Biological corridors",
          description: "By restoring the forest, we create corridors that allow animals to move, find mates and maintain healthy populations."
        }
      },
      waterCycle: {
        mainTitle: "How Forests Bring Rain and Protect Our Water",
        howRainWorks: "How Rain Works",
        whyForests: "and Why Forests Are Like Nature's Water System",
        intro1: "Imagine the land is a living body.",
        intro2: "Forests are not just trees — they are the organs that help water move, rest, and return.",
        letsSeee: "Let's see how it works 👇",
        whereRainComes: {
          title: "Where does rain come from?",
          content: "When the sun warms the Earth:\n• Lakes and rivers release water into the air\n• Trees release water through their leaves\n\nThis water becomes invisible vapor and rises into the sky.\n\nWhen enough vapor gathers, clouds are born.\n\nWhen clouds get heavy — 🌧️ rain falls.\n\n**Trees help make clouds.**\n\nWithout trees, fewer clouds are formed."
        },
        treesBreathe: {
          title: "Trees breathe water into the sky",
          content: "Trees drink water from the soil with their roots.\n\nThen they release part of that water through their leaves.\n\nThis is called **evapotranspiration**, but kids can think of it like this:\n\n*Trees breathe water into the air.*\n\nMillions of trees breathing together create:\n• Humidity\n• Cooler air\n• More chances for rain\n\nThat's why forests make their own weather."
        },
        whenRainFalls: {
          title: "What happens when rain falls?",
          content: "When rain falls on a healthy forest:\n• Leaves slow the rain\n• Roots open the soil\n• Water goes gently underground\n\nThe soil becomes like a sponge.\n\nThis water is stored and slowly released for months.\n\nThat water feeds:\n• Springs\n• Streams\n• Lakes\n• Animals\n• People\n\nThis is why forests are called **water guardians**."
        },
        forestsGiveMemory: {
          title: "Forests give water memory",
          content: "Forests help water stay.\n\nThey don't let all the rain escape at once.\n\n**They remember water.**\n\nThis is called *water memory*.\n\nBecause of forests:\n• Lakes don't dry fast\n• Rivers flow even in summer\n• Wells don't disappear\n\nWithout forests, water forgets."
        },
        whenForestsBurn: {
          title: "What happens when forests burn?",
          content: "When a forest burns:\n• The soil becomes hard\n• Water can't enter the ground\n• Rain runs away quickly\n• Floods happen\n• Then long dry periods follow\n\nSo after fires we often see:\n• Too much water at once\n• Then not enough later\n\n**This is very dangerous for lakes.**"
        },
        canValleyHelp: {
          title: "Can one valley help another valley?",
          content: "Sometimes forests in nearby valleys help bring humidity and clouds.\n\nThis can help a little.\n\nBut water cannot travel far underground through mountains.\n\nThat means:\n\n**Every valley must protect its own forest.**\n\nBecause rain can arrive from the sky —\nbut water must be kept by the land."
        },
        whyNativeSpecial: {
          title: "Why native forests are special",
          content: "Native forests:\n• Grew here naturally\n• Protect the soil\n• Allow water to enter the ground\n• Resist fire better\n• Help life return after disasters\n\nThey work together with the land.\n\n**They belong here.**"
        },
        forestsNotDecoration: {
          title: "Forests are not decoration",
          content: "Forests are not just beautiful.\n\nThey are:\n• **Water makers**\n• **Water keepers**\n• **Climate protectors**\n• **Life supporters**\n\nWithout forests:\n• Lakes weaken\n• Rain becomes irregular\n• Land dries\n• Fire risk grows"
        },
        simpleTruth: {
          title: "A Simple Truth",
          noForest: "No forest = no water future",
          withForests: "But with forests:",
          rainReturns: "Rain returns",
          springsRecover: "Springs recover",
          lakesSurvive: "Lakes survive",
          lifeContinues: "Life continues",
          whenWeProtect: "When we protect forests, we protect tomorrow.",
          protectNow: "Protect a Tree Now"
        }
      },
      resources: {
        title: "Additional Resources",
        subtitle: "Materials to deepen your knowledge",
        guide: {
          title: "Native Species Guide",
          type: "PDF",
          description: "Identification and characteristics of Patagonian native trees"
        },
        documentary: {
          title: "Documentary: Forests in Danger",
          type: "Video",
          description: "History of the Patagonian forest and current challenges"
        },
        interactiveMap: {
          title: "Interactive Project Map",
          type: "Interactive",
          description: "Explore planting zones and monitor progress"
        }
      },
      cta: {
        title: "Ready to act?",
        description: "Knowledge becomes meaningful when it transforms into action. Every tree you adopt contributes to restoring this unique ecosystem.",
        adoptTree: "Adopt a Tree",
        exploreMap: "Explore the Map"
      }
    },
    governance: {
      title: "How We Govern",
      subtitle: "No blind trust. No opaque intermediaries. A system where every decision is verifiable and every dollar is traceable.",
      badge: "Transparency",
      principles: {
        title: "Transparency Principles",
        subtitle: "The pillars that guide every decision",
        radicalTransparency: {
          title: "Radical Transparency",
          description: "Every dollar that comes in and goes out is public. All decisions are documented. No exceptions."
        },
        communityParticipation: {
          title: "Community Participation",
          description: "Donors and the local community have a voice in important project decisions."
        },
        protectedFunds: {
          title: "Protected Funds",
          description: "Multi-signature required for fund movements. No individual can act alone."
        },
        accountability: {
          title: "Accountability",
          description: "Regular audits, quarterly public reports, and independent verification."
        }
      },
      treasury: {
        title: "Fund Distribution",
        subtitle: "How every donated dollar is allocated",
        badge: "Treasury",
        directPlanting: {
          category: "Direct Planting",
          percentage: 60,
          description: "Seedlings, labor, tools"
        },
        maintenance: {
          category: "Maintenance",
          percentage: 20,
          description: "Watering, monitoring, replacements"
        },
        operations: {
          category: "Operations",
          percentage: 15,
          description: "Technology, logistics, communication"
        },
        reserve: {
          category: "Reserve",
          percentage: 5,
          description: "Emergencies and contingencies"
        },
        viewPublicRecord: "View Public Expense Record"
      },
      multiSig: {
        title: "Multi-Signature",
        subtitle: "No one person can move funds unilaterally",
        badge: "Security",
        foundation: {
          name: "Fundación Epuyén",
          role: "Primary Administrator",
          required: true
        },
        council: {
          name: "Community Council",
          role: "Local Representative",
          required: true
        },
        auditor: {
          name: "External Auditor",
          role: "Independent Verifier",
          required: false
        },
        requirement: "Minimum 2 of 3 signatures to approve any fund movement. All transactions are public and verifiable.",
        requiredLabel: "Required"
      },
      governanceRoadmap: {
        title: "Governance Roadmap",
        subtitle: "Towards increasingly decentralized governance",
        badge: "Evolution",
        currentPhase: {
          phase: "Current Phase",
          title: "Foundation",
          status: "active",
          items: [
            "Total fund transparency",
            "Monthly public reports",
            "GPS and photo verification of plantings",
            "Public record of all expenses"
          ]
        },
        v1Phase: {
          phase: "V1 (Coming Soon)",
          title: "Participation",
          status: "upcoming",
          items: [
            "Donor voting system",
            "Community proposals",
            "Planting zone selection",
            "Project prioritization"
          ]
        },
        v2Phase: {
          phase: "V2 (Future)",
          title: "Decentralization",
          status: "future",
          items: [
            "On-chain treasury multi-sig",
            "Governance NFTs for donors",
            "Community DAO",
            "Automated on-chain audits"
          ]
        }
      },
      cta: {
        title: "Get Involved in Transparency",
        description: "As a donor, you have the right to participate in project decisions. Your voice matters in building this forest.",
        adoptTree: "Adopt a Tree",
        viewTransparency: "View Transparency"
      }
    },
    community: {
      title: "Voices of Epuyén",
      subtitle: "Meet the people building the forest's future",
      badge: "Our Community",
      featuredVoices: {
        title: "Featured Voices",
        subtitle: "Stories from those making regeneration possible",
        person1: {
          name: "María del Carmen",
          role: "Local Nursery Worker",
          quote: "Every seedling I grow carries a piece of my heart. Knowing that someone in the world will adopt it and follow its growth fills me with hope.",
          location: "Epuyén, Chubut"
        },
        person2: {
          name: "Roberto Huenul",
          role: "Community Forest Ranger",
          quote: "My grandfather taught me to read the forest. Today I teach others to protect it. This technology helps us show the world what we do.",
          location: "Lago Puelo"
        },
        person3: {
          name: "Laura Sepúlveda",
          role: "Biologist",
          quote: "Science and community together can achieve what neither can alone. This project demonstrates that transparency builds trust.",
          location: "El Bolsón"
        },
        person4: {
          name: "Martín Curruhuinca",
          role: "Mapuche Community",
          quote: "The land is not ours, we belong to the land. Caring for it is our ancestral responsibility and now also a global one.",
          location: "Cushamen"
        },
        person5: {
          name: "Sofía Marinao",
          role: "Rural Teacher",
          quote: "My students learn about the forest by planting trees. Seeing their enthusiasm confirms that the future is in good hands.",
          location: "Epuyén"
        },
        person6: {
          name: "Diego Fernández",
          role: "Forest Firefighter",
          quote: "Every fire breaks my heart. That's why I support prevention: more native forest, less pine, less risk.",
          location: "Cholila"
        }
      },
      documentary: {
        title: "Documentary: Voices of the Forest",
        description: "A visual journey through the stories of those who dedicate their lives to protecting Patagonia.",
        comingSoon: "Coming Soon",
        watchTrailer: "Watch Trailer"
      },
      events: {
        title: "Upcoming Events",
        subtitle: "Join our community",
        event1: {
          title: "Community Planting",
          date: "March 15, 2025",
          location: "Epuyén Nursery",
          description: "Planting day open to volunteers"
        },
        event2: {
          title: "Monitoring Workshop",
          date: "April 22, 2025",
          location: "Community Center",
          description: "Learn to monitor trees with GPS"
        },
        event3: {
          title: "Annual Assembly",
          date: "May 10, 2025",
          location: "Virtual + In-Person",
          description: "Review of achievements and 2025 planning"
        }
      },
      shareStory: {
        title: "Do You Have a Story to Share?",
        description: "If you're part of the Epuyén community or have adopted a tree, we'd love to hear your story.",
        cta: "Share My Story"
      }
    },
    map: {
      title: "Project Map",
      viewMap: "View Map",
      satellite: "Satellite",
      terrain: "Map",
      trees: "Trees",
      legend: "Legend",
      planned: "Planned",
      planted: "Planted",
      adopted: "Adopted",
      controls: "Controls",
      dragToMove: "Drag: move map",
      ctrlDragRotate: "Ctrl+Drag: rotate",
      scrollZoom: "Scroll: zoom",
      clickMarker: "Click marker: details",
      resetView: "Reset view",
      loading: "Loading 3D map...",
      interactiveMap: "3D Interactive Map",
      terrainSource: "Terrain: AWS Terrain Tiles",
      imagerySource: "Imagery: ESRI World Imagery"
    },
    tree: {
      details: "Tree Details",
      species: "Species",
      status: "Status",
      coordinates: "Coordinates",
      planted: "Planted",
      adopted: "Adopted",
      adoptedBy: "Adopted by",
      plantingDate: "Planting Date",
      photos: "Photos",
      adoptThisTree: "Adopt This Tree",
      viewCertificate: "View Certificate",
      statuses: {
        planned: "Planned",
        planted: "Planted",
        maintained: "Under Maintenance",
        dead: "Dead",
        replaced: "Replaced"
      }
    },
    adopt: {
      title: "Adopt a Tree",
      subtitle: "Your donation helps restore Patagonian forests",
      selectPackage: "Select a Package",
      sapling: "Sapling",
      youngTree: "Young Tree",
      matureTree: "Mature Tree",
      donorName: "Donor Name",
      donorNamePlaceholder: "Your name (optional)",
      anonymous: "Anonymous",
      proceedToPayment: "Proceed to Payment",
      processing: "Processing...",
      successTitle: "Thank You for Your Donation!",
      successMessage: "Your tree has been assigned. Check your certificate.",
      viewMyCertificate: "View My Certificate",
      securePayment: "Secure payment with Stripe"
    },
    myForest: {
      title: "My Forest",
      subtitle: "Your Adopted Trees",
      noTrees: "You haven't adopted any trees yet.",
      adoptNow: "Adopt Now",
      totalTrees: "Total Trees",
      certificate: "Certificate"
    },
    transparency: {
      title: "Transparency",
      subtitle: "Every dollar counts. Every expense is verifiable.",
      summary: "Summary",
      totalDonated: "Total Donated",
      totalSpent: "Total Spent",
      balance: "Balance",
      donations: "Donations",
      expenses: "Expenses",
      recentDonations: "Recent Donations",
      recentExpenses: "Recent Expenses",
      category: "Category",
      amount: "Amount",
      date: "Date",
      receipt: "Receipt",
      viewReceipt: "View Receipt",
      categories: {
        seedlings: "Seedlings",
        labor: "Labor",
        tools: "Tools",
        transport: "Transport",
        admin: "Administration"
      }
    },
    admin: {
      title: "Admin Dashboard",
      stats: "Statistics",
      trees: "Trees",
      batches: "Batches",
      importTrees: "Import Trees",
      createBatch: "Create Batch",
      addExpense: "Add Expense",
      uploadPhoto: "Upload Photo"
    },
    donate: {
      phasesAndMilestones: "Phases & Milestones",
      equipmentAndInfrastructure: "Equipment & Infrastructure",
      totalEquipmentCost: "Total Equipment Cost",
      priority: "Priority",
      phase: "Phase",
      ofGoal: "of",
      active: "Active",
      pending: "Pending",
      future: "Future",
      complete: "Complete"
    },
    common: {
      loading: "Loading...",
      error: "Error",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      close: "Close",
      back: "Back",
      next: "Next",
      search: "Search",
      filter: "Filter",
      all: "All",
      available: "Available",
      unavailable: "Unavailable",
      viewMore: "View More",
      learnMore: "Learn More",
      targetArea: "Target Area",
      annualTarget: "Annual Target",
      duration: "Duration",
      operations: "Operations",
      vesselLength: "Vessel Length",
      pumpCapacity: "Pump Capacity",
      crew: "Crew Capacity",
      propulsion: "Propulsion",
      fullTimeWorkers: "Full-time Workers",
      monthlyPerWorker: "Monthly per Worker",
      months: "months",
      totalSalaries: "Total Salaries",
      chainsaws: "Chainsaws",
      safetyEquipment: "Safety Equipment",
      quantity: "Quantity",
      costPerUnit: "Cost per Unit",
      units: "units",
      total: "Total",
      manualDepiningCost: "Manual De-Pining Cost",
      totalManualProgram: "Total Manual Program",
      socialEnvironmentalImpact: "Social & Environmental Impact",
      transparency: "Transparency",
      thisPlanWill: "This plan will:",
      allWorkWillBe: "All work will be:",
      everyContributionSupports: "Every contribution supports:"
    },
    footer: {
      tagline: "Restoring Patagonia, one tree at a time.",
      copyright: "© {year} Epuyén Renace. All rights reserved."
    }
  },

  // CHINESE (Simplified)
  zh: {
    nav: {
      home: "首页",
      map: "地图",
      adopt: "认养",
      myForest: "我的森林",
      transparency: "透明度",
      admin: "管理",
      login: "登录",
      logout: "退出",
      more: "更多",
      community: "社区",
      education: "教育",
      governance: "透明度",
      vision: "我们的愿景"
    },
    vision: {
      badge: "我们的愿景",
      title: "我们的愿景",
      opening: "我们的愿景是向世界证明，通过透明、结构和集体行动，重建一个生态被破坏的地方是可能的。",
      whatWeAre: {
        title: "Epuyén Renace是什么",
        description: "Epuyén Renace的存在是为了创建一个火灾后再生模型：一个系统，其中土地恢复、生态修复和社区发展由可验证的数据驱动，而不是盲目信任。"
      },
      transparency: {
        title: "区块链透明度",
        description: "通过使用区块链技术作为透明层，每一笔贡献、每一笔支出和每一个行动都可以公开追踪。不是为了投机——而是为了恢复人们对恢复工作如何资助和执行的信心。"
      },
      belief: {
        title: "我们相信",
        description: "我们相信，当透明取代腐败，结构取代即兴，社区可以重新崛起——即使在完全的环境损失之后。"
      },
      goal: {
        title: "我们的目标",
        description: "我们的目标不仅是恢复Epuyén，而是证明一种新的生态恢复经济模型是可能的——一种可以在世界各地受火灾影响的地区复制的模型。"
      },
      closing: {
        line1: "从灰烬中，一个系统可以重建。",
        line2: "从毁灭中，一个未来可以设计。"
      }
    },
    landing: {
      heroTitle: "与Epuyén一起重生",
      heroSubtitle: "认养一棵树，恢复巴塔哥尼亚。",
      heroCta: "认养一棵树",
      heroExplore: "探索地图",
      viewRoadmap: "查看路线图",
      missionTitle: "我们的使命",
      missionText: "通过社区重新造林和彻底透明技术，恢复阿根廷巴塔哥尼亚的原生森林。",
      restoringPatagonia: "恢复",
      patagonia: "巴塔哥尼亚",
      howItWorksTitle: "如何运作",
      simpleProcess: "简单流程",
      step1Title: "探索地图",
      step1Text: "浏览我们的互动地图，选择一棵可以认养的树。",
      step2Title: "认养你的树",
      step2Text: "完成捐赠，获得带有树木GPS坐标的独特代币。",
      step3Title: "跟踪成长",
      step3Text: "接收您树木的照片和进度更新。",
      impactTitle: "我们的影响",
      treesPlanted: "已种植的树",
      treesAdopted: "已认养的树",
      donorsCount: "捐赠者",
      co2Offset: "抵消的CO₂吨数",
      transparencyTitle: "完全透明",
      transparencyText: "每笔捐款和支出都可公开验证。没有秘密，只有结果。",
      viewTransparency: "查看公开记录",
      footerTagline: "恢复巴塔哥尼亚，一棵树一棵树地。",
      whatHappened: {
        title: "Epuyén发生了什么？",
        year: "2025年和2026年，Epuyén遭遇了历史上最严重的野火。",
        hectares: "超过9,000公顷的安第斯原生森林被毁。",
        ecosystems: "整个生态系统被烧毁。",
        homes: "家园被毁。",
        wildlife: "野生动物消失了。",
        landExposed: "土地变得裸露、干燥和脆弱。",
        balanceBroken: "大火不仅仅是烧毁了树木——它们打破了保护水、土壤和气候的自然平衡。没有森林覆盖，降雨减少，侵蚀增加，未来火灾的风险变得更大。",
        minimalEfforts: "尽管灾难规模巨大，但恢复工作却很少。没有全面的生态恢复计划，没有长期预防策略，也没有结构性重建计划。",
        peopleStayed: "Epuyén的人民留了下来。他们留下来守护、抵抗、重新开始。",
        todayScars: "今天，这片土地仍然带着伤疤——但也承载着再生的可能性。",
        epuyenCreated: "Epuyén Renace的创建是为了将悲剧转化为结构：恢复原生森林，降低火灾风险，重建生态平衡，并确保这种情况永远不会再发生。",
        fromAshes: "从灰烬中不会随机产生任何东西：未来是用意图、真理和社区来建设的。"
      },
      coreChallenges: {
        title: "核心挑战",
        mainChallenge: "Epuyén的主要挑战是除松——大规模清除已经占领景观的入侵松树种。",
        effectiveMethod: "通过实地经验和测试，我们确定了最有效的方法：就地粉碎松树，让有机材料再生土壤，而不是移除或焚烧。",
        processRestores: "这个过程恢复湿度，改善土壤结构，并为原生林恢复创造即时条件。",
        parallelReplanting: "同时，重新种植也同步开始。移除和再生必须同时进行——而不是相隔数年——以防止侵蚀和入侵物种的再次殖民。",
        secondMission: "我们的第二个主要任务是火灾预防和未来风险降低。",
        moreThanPlanting: "这不仅仅需要种树。它需要永久的运营能力，包括获取能够在困难地形工作并快速响应火灾威胁的专业设备。",
        foundationInvest: "为实现这一目标，基金会必须投资于：",
        investList: {
          machinery: "林业和粉碎机械",
          equipment: "可通行地形的设备",
          tools: "燃料负荷减少和维护工具",
          infrastructure: "长期预防基础设施"
        },
        withoutEquipment: "没有这些设备，再生仍然脆弱，破坏循环会重复。",
        breakCycle: "Epuyén Renace存在的意义就是打破这个循环——通过恢复土地、降低火灾风险，并为未来建立永久的预防系统。"
      },
      donationCategories: {
        title: "捐款类别",
        subtitle: "选择您希望如何使用您的捐款",
        cta: {
          supportMission: "支持这个使命",
          ctaDescription: "每一笔捐款都直接用于购买设备和完成这些阶段。所有支出都通过照片、收据和GPS数据公开记录。",
          donateToCategory: "捐赠到此类别",
          viewTransparency: "查看透明度记录"
        },
        category1: {
          icon: "🟫",
          title: "除松与野火预防",
          description: "一个为期五年的积极预防计划，旨在清除入侵松树物种、降低极端火灾风险，并保护Epuyén现存的原生森林。",
          supports: "您的捐款支持永久性野火预防基础设施、当地就业和长期生态稳定。",
          items: [
            "清除入侵松树",
            "减少燃料负荷",
            "保护原生森林"
          ],
          method: "机械与人工除松综合策略",
          impact: "直接降低野火强度并长期保护山谷",
          fiveYearPlan: {
            title: "五年积极除松计划",
            objective: "通过持续的预防工作，大幅降低Epuyén山谷的野火风险。",
            targetArea: "约4,500公顷的入侵松树（枯死和存活）。",
            annualTarget: "每年处理约900公顷。",
            duration: "5年持续运营。",
            operations: "全年现场作业，结合机械和人工团队。",
            phases: {
              year1: {
                title: "紧急稳定",
                description: "在住宅、通道和关键基础设施附近的高风险区域立即干预。"
              },
              year2: {
                title: "扩展阶段",
                description: "在更大的松树主导区域扩大作业，建立永久预防走廊。"
              },
              year3: {
                title: "深谷干预",
                description: "处理山谷内部区域，巩固混合森林区域的人工除松工作。"
              },
              year4: {
                title: "维护与再生控制",
                description: "二次干预以防止再生并加强长期防火能力。"
              },
              year5: {
                title: "稳定与过渡",
                description: "最终风险降低、生态监测和向长期维护过渡。"
              }
            },
            equipment: {
              title: "所需林业设备",
              totalCost: "300万至580万美元（一次性投资）",
              highVolumeMulchers: "用于密集松树区域的高容量林业粉碎机。",
              accessMulchers: "用于斜坡和有限通行地形的紧凑型粉碎机。",
              excavators: "带抓斗和防护的林业挖掘机。",
              dozer: "用于防火带和通道维护的推土机。",
              loader: "用于物流和材料处理的轮式装载机。",
              transport: "运输卡车和服务车辆。"
            },
            capex: {
              title: "资本投资（CAPEX）",
              total: "一次性购买的机械和基础设施，以创造永久预防能力。",
              argentinaLanded: {
                title: "阿根廷落地成本（进口+物流）",
                learnMore: "了解更多",
                learnLess: "隐藏详情",
                intro: "国际『基准价格』并非阿根廷的实际成本。由于进口税、增值税、海关清关、港口处理、巴塔哥尼亚内陆运输、延误和备件通胀，重型林业机械的成本明显更高。",
                points: [
                  "典型的进口开销可增加+40%至+90%，具体取决于设备类型和进口途径。",
                  "非政府组织豁免可能在稍后存在，但在法律注册之前无法保证。我们将其视为潜在好处，而非假设。",
                  "巴塔哥尼亚内陆运输和港口延误增加了可观的成本。",
                  "备件在阿根廷既昂贵又缓慢——我们包括10-15%的准备缓冲（对正常运行至关重要）。"
                ],
                costBreakdown: {
                  title: "实际成本摘要",
                  baseMachinery: "基础机械（国际价格）",
                  baseRange: "~300万-580万美元",
                  importTaxes: "进口/税费/物流（阿根廷）",
                  importRange: "+240万-280万美元",
                  spareParts: "备件/准备缓冲（10-15%）",
                  spareRange: "+70万-100万美元",
                  totalLanded: "阿根廷估计实际落地CAPEX",
                  totalRange: "750万-820万美元"
                },
                disclaimer: "所有预算反映阿根廷的实际落地成本（税费、巴塔哥尼亚物流、准备）。任何未来的豁免都会降低成本并增加处理公顷数。"
              }
            },
            soilComparison: {
              title: "原生森林土壤 vs 松树种植园土壤",
              subtitle: "为什么火灾在松树林中传播得更快",
              intro: "差异不仅仅在于树木。差异在于下面的整个土壤系统。",
              native: {
                title: "原生森林土壤",
                species: "南青冈、阔叶南青冈、小叶南青冈、黄杨",
                description: "巴塔哥尼亚原生森林创造：",
                characteristics: [
                  "高有机多样性",
                  "深腐殖质层",
                  "真菌网络（菌根）",
                  "持续保湿",
                  "海绵状结构",
                  "缓慢分解",
                  "高微生物活性"
                ],
                moisture: "25-45%",
                moistureLabel: "典型土壤湿度",
                moistureNote: "即使在夏季。",
                fireBehavior: {
                  title: "火灾行为：",
                  points: [
                    "火焰保持低位",
                    "火势蔓延缓慢",
                    "经常自行熄灭",
                    "零星燃烧，不连续",
                    "难以蔓延到树冠"
                  ]
                },
                spreadSpeed: "每分钟0.1-0.5米",
                spreadNote: "通常在夜间停止。"
              },
              pine: {
                title: "松树种植园土壤",
                warning: "松树彻底改变土壤。",
                characteristics: [
                  "酸性枯叶层（pH 3.5-4.5）",
                  "含树脂的针叶",
                  "微生物多样性差",
                  "几乎没有真菌共生",
                  "压实的矿物土壤",
                  "疏水性（排斥水）",
                  "快速干燥"
                ],
                moisture: "5-12%",
                moistureLabel: "典型土壤湿度",
                moistureNote: "即使在湖边。",
                fireBehavior: {
                  title: "火灾行为：",
                  points: [
                    "容易点燃",
                    "火势连续蔓延",
                    "火焰垂直攀升",
                    "强烈的辐射热",
                    "树冠快速点燃"
                  ]
                },
                spreadSpeed: "每分钟5-20米",
                spreadWind: "每分钟40-60米",
                spreadWindLabel: "有风时：",
                spreadComparison: "快100倍。"
              },
              publicQuote: "松树不仅会燃烧——它们重新设计土壤以燃烧得更快。",
              quoteNote: "这不是夸张——这是物理学。",
              whyWorks: {
                title: "为什么除松有效",
                intro: "移除松树：",
                benefits: [
                  "提高土壤湿度",
                  "恢复真菌",
                  "打破燃料连续性",
                  "降低火焰高度",
                  "减缓火势蔓延",
                  "允许原生物种回归"
                ],
                conclusion: "这就是预防有效的原因。"
              }
            },
            strategic: {
              title: "战略价值",
              establishes: "这项投资为Epuyén建立永久的野火预防能力。",
              items: [
                "长期燃料负荷减少",
                "快速响应预防能力",
                "减少紧急消防成本",
                "对未来火灾的领土韧性"
              ],
              note: "这些基础设施可用数十年。"
            },
            twoMethods: {
              intro: "除松无法通过单一方法实现。",
              approach: "该计划根据生态条件整合两种互补方法。",
              mechanical: {
                title: "机械除松",
                description: "用于完全被入侵松树主导的区域。",
                items: [
                  "高速燃料减少",
                  "大面积处理",
                  "恢复准备"
                ],
                note: "仅在原生森林不存在的地方应用。"
              },
              manual: {
                title: "人工/外科除松",
                description: "在原生森林残留的地方选择性清除松树。",
                zones: [
                  "松树与原生森林混合区",
                  "再生区",
                  "水道",
                  "住宅缓冲区"
                ],
                method: "由训练有素的团队使用电锯逐棵清除。",
                note: "对防止生态破坏至关重要。"
              }
            },
            employment: {
              title: "当地就业计划",
              intro: "人工除松创造稳定的长期就业。",
              priority: "优先雇用Epuyén及周边社区居民。",
              equipmentItems: [
                "专业电锯",
                "安全设备",
                "维护工具"
              ],
              manualCostCategories: [
                "工资",
                "工具和设备",
                "操作安全"
              ]
            },
            conclusion: "这个五年计划将野火预防从紧急反应转变为永久领土保护。",
            costExplanation: {
              title: "成本说明",
              intro: "有效的预防需要持续的长期投资。",
              requirement: "短期行动不足以打破野火循环。",
              integration: "该计划整合了机械、劳动力、维护和监测。",
              mechanical: {
                title: "机械除松成本",
                description: "重型机械使大规模干预成为可能。",
                capability: "允许快速处理高风险松树主导区域。",
                includes: "涵盖所有与机械相关的操作。",
                items: [
                  "林业粉碎机",
                  "挖掘机和推土机",
                  "运输物流",
                  "燃料",
                  "维护",
                  "备件",
                  "现场作业"
                ],
                oneTimeInvestment: "一次性投资",
                oneTimeRange: "300万至580万美元",
                operationalCost: "运营成本（5年）",
                operationalRange: "610万至1070万美元",
                note: "创造永久预防基础设施。"
              },
              manual: {
                title: "人工除松成本",
                description: "在机械无法安全使用的地方需要。",
                limitation: "重型机械会损坏原生森林。",
                requirement: "选择性人工干预至关重要。",
                whereApplied: "应用于敏感生态区域。",
                zones: [
                  "混合森林",
                  "河岸区域",
                  "住宅附近",
                  "再生区",
                  "高生态价值区域"
                ],
                includes: "涵盖劳动力和设备。",
                items: [
                  "50名全职工人",
                  "专业电锯",
                  "防护设备",
                  "工具和维护",
                  "操作安全"
                ],
                workers: "50名工人",
                salary: "每月1,000美元",
                duration: "5年",
                totalCost: "总成本",
                totalAmount: "312.5万美元"
              },
              totalCost: {
                title: "五年预防总成本",
                componentHeader: "组成部分",
                costHeader: "成本",
                components: [
                  { category: "机械投资", cost: "300万至580万美元" },
                  { category: "机械运营（5年）", cost: "610万至1070万美元" },
                  { category: "人工除松（5年）", cost: "312.5万美元" }
                ],
                total: "项目总成本",
                totalRange: "1220万至1960万美元"
              },
              delivers: {
                title: "该计划提供什么",
                intro: "五年内，该计划提供：",
                items: [
                  "大幅降低野火风险",
                  "消除燃料负荷",
                  "保护原生森林",
                  "土壤和水分恢复",
                  "永久预防走廊",
                  "当地就业稳定",
                  "减少未来紧急成本",
                  "长期生态韧性"
                ],
                notEmergency: "这不是紧急响应。",
                structural: "这是结构性野火预防。"
              },
              whyFiveYears: {
                title: "为什么是五年？",
                intro: "生态系统不会在几个月内稳定。",
                allows: "五年时间框架允许：",
                items: [
                  "清除主要入侵松树",
                  "防止再生",
                  "土壤稳定",
                  "支持自然恢复",
                  "长期风险降低"
                ],
                conclusion: "较短的时间框架无法打破火灾循环。"
              },
              transparency: {
                title: "透明度",
                intro: "所有资金将可公开追踪。",
                items: [
                  "地理定位工作区域",
                  "处理公顷报告",
                  "月度更新",
                  "视觉文档",
                  "公共透明度仪表板"
                ],
                conclusion: "每笔捐款都可验证。"
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "Epuyén湖消防船系统",
          description: "此类别建立永久性水上消防单位，能够快速部署和高容量泵送。",
          supports: "捐款支持：",
          items: [
            "专业消防船",
            "工业高容量泵系统",
            "软管系统和卷轴",
            "电动/混合动力推进",
            "安全和消防设备"
          ],
          objective: "目标是将Epuyén湖从被动元素转变为主动火灾防御资产。",
          impact: "此类别在几分钟内保护生命、森林和基础设施。",
          boatSystem: {
            title: "Epuyén湖消防船系统",
            subtitle: "快速水上消防响应单位",
            objective: "建立永久性消防船单位，能够快速部署、高容量水泵和支持地面部队——将Epuyén湖从被动元素转变为主动火灾防御资产。",
            vesselLength: "9-12米",
            pumpCapacity: "4,000-8,000升/分钟",
            crew: "6-10名消防员",
            propulsion: "电动/混合动力",
            challengesTitle: "为什么需要水上响应？",
            challengesIntro: "Epuyén的地理环境带来三大挑战：",
            challenges: [
              "陡峭的森林山坡",
              "有限的道路通行",
              "强烈的山谷风"
            ],
            solutionStatement: "水上响应解决所有三个问题。",
            capabilitiesTitle: "船可以：",
            capabilities: [
              "比卡车更快到达火场前线",
              "从湖中无限泵水",
              "即使道路被封锁也能运行",
              "从山坡下方攻击火灾",
              "减少60-80%的响应时间"
            ],
            capex: {
              title: "总投资（CAPEX）",
              total: "总投资"
            },
            strategic: {
              title: "战略价值",
              establishes: "该系统创建：",
              items: [
                "永久性水上消防能力",
                "几分钟内快速响应能力",
                "更低的灭火成本",
                "减少火势蔓延概率",
                "保护家园、森林和水源"
              ],
              note: "将Epuyén湖从被动元素转变为主动火灾防御资产。"
            },
            conclusion: "Epuyén湖上的专用消防船代表了野火预防和响应中最有效的投资之一。它将湖泊转变为前线防御系统——在火灾成为灾难之前保护山谷。"
          }
        },
        category3: {
          icon: "🌱",
          title: "再造林和未来保护",
          description: "此类别支持Epuyén的长期生态恢复。",
          supports: "捐款用于：",
          items: [
            "种植原生树木",
            "苗圃开发",
            "土壤再生",
            "长期维护",
            "生物多样性恢复",
            "再生区域的监测和保护"
          ],
          impact: "这确保恢复的森林能够生存、成熟并为后代保护。"
        },
        category4: {
          icon: "♻️",
          title: "废物管理与污染",
          description: "通过实地观察和社区对话，我们发现Epuyén面临重大的露天废物和污染挑战。",
          supports: "目前专注于：",
          items: [
            "了解现有废物流",
            "识别污染风险",
            "绘制露天倾倒区",
            "研究环境和健康影响",
            "审查类似农村社区的可行模式"
          ],
          objective: "目标不是强加解决方案，而是建立一个适合Epuyén规模和地理的现实、可持续的方案。",
          impact: "解决污染对于保护水源、恢复生态系统和确保社区健康未来至关重要。",
          researchPhase: {
            title: "废物管理与污染",
            currentPhase: "研究与诊断阶段",
            context: "通过实地观察和社区对话，我们发现Epuyén面临重大的露天废物和污染挑战，包括对土壤、水和公共健康构成长期风险的非正式倾倒区。",
            statement: "这个问题不能通过即兴或孤立的行动来解决。",
            focusTitle: "当前关注领域：",
            focusAreas: [
              "了解现有废物流",
              "识别污染风险",
              "绘制露天倾倒区",
              "研究环境和健康影响",
              "审查类似农村和山区社区使用的可行模式"
            ],
            requirement: "废物管理需要技术准确性、监管协调和长期规划。",
            ethos: "作为我们理念的一部分，没有适当研究就不会宣布任何解决方案。",
            commitment: "一旦评估阶段完成，Epuyén Renace将发布清晰、公开、透明的废物管理提案，供社区审查和机构对话。",
            objective: "目标不是强加解决方案，而是建立一个适合Epuyén规模和地理的现实、可持续的方案。",
            importance: "解决污染对于保护水源、恢复生态系统和确保社区健康未来至关重要。"
          }
        },
        category5: {
          icon: "🏛️",
          title: "33公顷生物圈公园和基金会中心",
          description: "长期愿景项目：33公顷的公共生物圈公园，配备基金会总部、教育中心和可持续本地经济。",
          supports: "捐款支持：",
          items: [
            "基金会总部和环境教育中心",
            "20栋生态房屋供志愿者和访客使用",
            "带有步道和保护区的公共公园",
            "420平方米活动和会议穹顶",
            "日式养生温泉",
            "湖畔餐厅",
            "消防船停靠码头和公共通道",
            "本地食品生产设施"
          ],
          objective: "目标是创建一个自我可持续的模式，产生本地就业、教育和再生旅游。",
          impact: "此类别为后代建设永久遗产和基础设施。"
        },
        transparency: {
          title: "按类别透明",
          description: "每个捐款类别都有：",
          items: [
            "专门的预算",
            "公开进度跟踪",
            "记录的支出",
            "照片、GPS数据和报告",
            "基于区块链的透明记录"
          ],
          verify: "捐赠者可以准确选择如何使用他们的捐款，并在每个阶段验证其影响。"
        },
        oneSystem: {
          title: "一个系统，五个使命",
          depining: "除松减少风险。",
          firefighting: "消防在紧急情况下保护。",
          reforestation: "再造林恢复生命。",
          contamination: "废物管理保护水源和健康。",
          biosphere: "生物圈公园建设可持续未来。",
          together: "它们共同构成了Epuyén完整而永久的火灾后恢复模式——证明当有组织、技术和真正的承诺时，一个地方可以再次崛起。"
        }
      }
    },
    roadmap: {
      title: "路线图",
      subtitle: "一个长期系统，用于再生土地并为Epuyén带来未来。这不是政治或慈善——而是可验证的行动。",
      thePlan: "计划",
      active: "进行中",
      upcoming: "即将到来",
      comingSoon: "即将推出",
      rAndD: "研发",
      vision: "愿景",
      future: "未来",
      goal: "目标",
      raised: "已筹集",
      totalGoal: "总目标",
      treesAdopted: "已认养的树",
      projectPhases: "项目阶段",
      progress: "进度",
      everyContribution: "每一份贡献都让我们更接近目标",
      phase0: {
        title: "基础 + 数字透明",
        description: "创建Epuyén Renace基金会，启动网站+公开路线图，用无人机/LiDAR配置数字地图，定义区域、KPI、成本模型和区块链系统以追踪捐款和支出。",
        tags: ["网站", "3D地图", "区块链", "法律基金会"],
        status: "初始设置"
      },
      phase1: {
        title: "重新造林冲刺",
        description: "种植10,000棵原生树。每棵树约25美元，用GPS、照片、状态时间线和公开记录进行追踪。",
        tags: ["10,000棵树", "GPS追踪", "照片", "公开记录"],
        treesAdopted: "棵树已认养",
        available: "可用"
      },
      phase2: {
        title: "风险降低 + 扩展",
        description: "移除5,000棵入侵松树，种植20,000棵原生树，并购买2台碎木机将松木加工成覆盖物以减少燃料负荷。",
        tags: ["移除5,000棵松树", "20,000棵原生树", "2台碎木机"],
        proof: "发布证据：移除记录 + 种植批次 + 收据"
      },
      phase3: {
        title: "巴塔哥尼亚消防创新",
        description: "设计和建造专有的混合消防系统：水/船能力 + 无人机 + 地面响应。目标：在偏远地形进行早期检测 + 快速遏制。",
        tags: ["无人机", "混合车辆", "早期检测", "开放研发"],
        milestones: "清晰的里程碑、原型和公开报告"
      },
      phase4: {
        title: "33公顷公共生物圈公园",
        description: "购买33公顷土地，归Epuyén Renace基金会所有。将其设计为公共生物圈公园。",
        tags: ["33公顷", "教育中心", "湖畔餐厅", "码头", "当地生产"],
        purpose: "永久保护 + 就业 + 教育 + 可持续的当地经济"
      },
      phase5: {
        title: "完整SaaS平台",
        description: "Epuyén成为数字孪生体。无人机/LiDAR调查地图：树木计数和登记，1棵树 = 1个代币/证书。",
        tags: ["数字孪生", "LiDAR", "NFT代币", "链上", "审计"],
        scalable: "可扩展到其他保护项目的模型"
      },
      summary: {
        foundation: "基础",
        trees10k: "1万棵树",
        expansion: "扩展",
        fireFighting: "消防",
        park33ha: "33公顷公园",
        platform: "平台"
      }
    },
    education: {
      title: "了解森林",
      subtitle: "知识就是力量。了解我们的生态系统是保护它的第一步。",
      badge: "环境教育",
      nativeForest: {
        title: "巴塔哥尼亚原生森林",
        subtitle: "了解我们正在保护的物种",
        lenga: { title: "Lenga", description: "落叶树，可长到30米高。秋天叶子变成红色和金色。" },
        coihue: { title: "Coihue", description: "常绿物种，可存活500年以上。" },
        cipres: { title: "科迪勒拉柏树", description: "原生针叶树，可超过1000年。" }
      },
      invasiveSpecies: {
        title: "入侵物种",
        subtitle: "松树问题和其他威胁",
        pine: { title: "入侵松树", description: "积极扩散，取代原生森林，增加火灾风险。", impact: "高" },
        rosehip: { title: "野玫瑰果", description: "迅速传播并与原生植被争夺资源。", impact: "中" },
        broom: { title: "金雀花", description: "高度易燃的灌木。", impact: "高" }
      },
      fireRisk: {
        title: "火灾风险",
        subtitle: "了解和预防威胁",
        whyPinesDangerous: { title: "为什么松树危险？", description: "松树含有高度易燃的树脂。" },
        nativeForestRole: { title: "原生森林的作用", description: "原生树含水量更高，更耐火。" },
        communityPrevention: { title: "社区预防", description: "移除松树和早期检测系统是基础。" }
      },
      biodiversity: {
        title: "生物多样性",
        subtitle: "依赖森林的生命",
        fauna: { title: "标志性动物", description: "马驼鹿、普度鹿、美洲狮等都依赖原生森林。" },
        lifeNetwork: { title: "生命网络", description: "每棵原生树支撑着生命网络。" },
        corridors: { title: "生物走廊", description: "恢复森林创建动物走廊。" }
      },
      waterCycle: {
        mainTitle: "森林如何带来降雨并保护我们的水",
        howRainWorks: "雨是如何形成的",
        whyForests: "以及为什么森林像大自然的水系统",
        intro1: "想象地球是一个活的身体。",
        intro2: "森林不仅仅是树木——它们是帮助水移动、休息和返回的器官。",
        letsSeee: "让我们看看它是如何运作的 👇",
        whereRainComes: { title: "雨从哪里来？", content: "当太阳加热地球时，湖泊和树木将水释放到空气中形成云。" },
        treesBreathe: { title: "树木向天空呼吸水分", content: "树木通过蒸腾作用向空气中释放水分。" },
        whenRainFalls: { title: "当雨落下时会发生什么？", content: "森林的叶子和根帮助水进入地下储存。" },
        forestsGiveMemory: { title: "森林给水以记忆", content: "森林帮助水留下来，慢慢释放。" },
        whenForestsBurn: { title: "当森林燃烧时会发生什么？", content: "土壤变硬，水快速流走，导致洪水和干旱。" },
        canValleyHelp: { title: "一个山谷能帮助另一个山谷吗？", content: "每个山谷都必须保护自己的森林。" },
        whyNativeSpecial: { title: "为什么原生森林特别", content: "原生森林在这里自然生长，与土地协同工作。" },
        forestsNotDecoration: { title: "森林不是装饰", content: "森林是水的创造者和守护者。" },
        simpleTruth: {
          title: "一个简单的真理",
          noForest: "没有森林 = 没有水的未来",
          withForests: "但有了森林：",
          rainReturns: "雨回来了",
          springsRecover: "泉水恢复了",
          lakesSurvive: "湖泊存活了",
          lifeContinues: "生命继续",
          protectForests: "当我们保护森林时，我们就保护了明天。",
          cta: "现在保护一棵树"
        }
      },
      resources: {
        title: "额外资源",
        subtitle: "深化知识的材料",
        viewResource: "查看资源",
        guide: { title: "原生物种指南", type: "PDF", description: "巴塔哥尼亚原生树的识别和特征" },
        documentary: { title: "纪录片：濒危森林", type: "视频", description: "巴塔哥尼亚森林的历史和当前挑战" },
        map: { title: "项目互动地图", type: "互动", description: "探索种植区域并监控进度" }
      },
      cta: { title: "准备好行动了吗？", description: "知识转化为行动才有意义。" }
    },
    governance: {
      title: "我们如何治理",
      subtitle: "没有盲目信任。没有不透明的中介。一个每个决定都可验证的系统。",
      badge: "治理",
      principles: {
        title: "治理原则",
        subtitle: "指导每个决定的支柱",
        radicalTransparency: { title: "彻底透明", description: "每一美元的进出都是公开的。" },
        communityParticipation: { title: "社区参与", description: "捐赠者和当地社区有发言权。" },
        protectedFunds: { title: "受保护的资金", description: "资金转移需要多重签名。" },
        accountability: { title: "问责制", description: "定期审计和公开报告。" }
      },
      treasury: {
        title: "资金分配",
        subtitle: "每一美元捐款的分配方式",
        badge: "财务",
        viewPublicRecord: "查看公开支出记录",
        directPlanting: { category: "直接种植", percentage: 60, description: "树苗、劳动力、工具" },
        maintenance: { category: "维护", percentage: 20, description: "灌溉、监测、替换" },
        operations: { category: "运营", percentage: 15, description: "技术、物流、通信" },
        reserve: { category: "储备", percentage: 5, description: "紧急情况" }
      },
      multiSig: {
        title: "多重签名",
        subtitle: "没有人可以单方面转移资金",
        badge: "安全",
        requirement: "任何资金转移都需要至少2/3的签名。",
        requiredLabel: "必需",
        foundation: { name: "Epuyén基金会", role: "主管理员", required: true },
        council: { name: "社区委员会", role: "当地代表", required: true },
        auditor: { name: "外部审计师", role: "独立验证者", required: false }
      },
      governanceRoadmap: {
        title: "治理路线图",
        subtitle: "走向更加去中心化的治理",
        badge: "演进",
        currentPhase: { phase: "当前阶段", title: "基础", status: "active", items: ["资金完全透明", "每月公开报告", "GPS验证种植", "所有支出公开记录"] },
        v1Phase: { phase: "V1（即将推出）", title: "参与", status: "upcoming", items: ["捐赠者投票系统", "社区提案", "种植区域选择", "项目优先级"] },
        v2Phase: { phase: "V2（未来）", title: "去中心化", status: "future", items: ["财务链上多重签名", "捐赠者治理NFT", "社区DAO", "自动链上审计"] }
      },
      cta: { title: "参与治理", description: "作为捐赠者，您有权参与项目决策。", adoptTree: "认养一棵树", viewTransparency: "查看透明度" }
    },
    community: {
      title: "Epuyén的声音",
      subtitle: "认识正在建设森林未来的人们",
      badge: "我们的社区",
      featuredVoices: {
        title: "特色声音",
        subtitle: "让再生成为可能的人们的故事",
        person1: {
          name: "玛丽亚·德尔·卡门",
          role: "当地苗圃栽培师",
          quote: "我培育的每棵苗都承载着我的一部分心意。知道世界上有人会认养它并跟踪它的成长，这让我充满希望。",
          location: "Epuyén, Chubut"
        },
        person2: {
          name: "罗伯托·韦努尔",
          role: "社区森林护林员",
          quote: "我的祖父教我如何读懂森林。今天我教别人如何保护它。这项技术帮助我们向世界展示我们所做的事情。",
          location: "Lago Puelo"
        },
        person3: {
          name: "劳拉·塞普尔维达",
          role: "生物学家",
          quote: "科学和社区一起可以实现任何一方单独无法实现的事情。这个项目证明了透明度能产生信任。",
          location: "El Bolsón"
        },
        person4: {
          name: "马丁·库鲁维因卡",
          role: "马普切社区",
          quote: "土地不属于我们，我们属于土地。照顾它是我们祖先的责任，现在也是全球的责任。",
          location: "Cushamen"
        },
        person5: {
          name: "索菲亚·马里纳奥",
          role: "乡村教师",
          quote: "我的学生通过种树来了解森林。看到他们的热情让我确信未来掌握在好人手中。",
          location: "Epuyén"
        },
        person6: {
          name: "迭戈·费尔南德斯",
          role: "森林消防员",
          quote: "每一场火灾都让我心碎。这就是为什么我支持预防：更多原生森林，更少松树，更少风险。",
          location: "Cholila"
        }
      },
      documentary: {
        title: "纪录片：森林的声音",
        description: "通过那些致力于保护巴塔哥尼亚的人们的故事进行的视觉之旅。",
        comingSoon: "即将推出",
        watchTrailer: "观看预告片"
      },
      events: {
        title: "即将举行的活动",
        subtitle: "加入我们的社区",
        event1: {
          title: "社区种植",
          date: "2025年3月15日",
          location: "Epuyén苗圃",
          description: "向志愿者开放的种植日"
        },
        event2: {
          title: "监测工作坊",
          date: "2025年4月22日",
          location: "社区中心",
          description: "学习如何用GPS监测树木"
        },
        event3: {
          title: "年度大会",
          date: "2025年5月10日",
          location: "线上+线下",
          description: "回顾成就并规划2025年"
        }
      },
      shareStory: {
        title: "有故事要分享吗？",
        description: "如果您是Epuyén社区的一员或认养了一棵树，我们很想听听您的故事。",
        cta: "分享我的故事"
      }
    },
    common: {
      loading: "加载中...",
      error: "错误",
      success: "成功",
      cancel: "取消",
      confirm: "确认",
      save: "保存",
      delete: "删除",
      edit: "编辑",
      view: "查看",
      close: "关闭",
      back: "返回",
      next: "下一步",
      search: "搜索",
      filter: "筛选",
      all: "全部",
      available: "可用",
      unavailable: "不可用",
      viewMore: "查看更多",
      learnMore: "了解更多",
      targetArea: "目标面积",
      annualTarget: "年度目标",
      duration: "持续时间",
      operations: "运营",
      vesselLength: "船体长度",
      pumpCapacity: "泵容量",
      crew: "船员容量",
      propulsion: "推进系统",
      fullTimeWorkers: "全职工人",
      monthlyPerWorker: "每位工人月薪",
      months: "个月",
      totalSalaries: "总工资",
      chainsaws: "电锯",
      safetyEquipment: "安全设备",
      quantity: "数量",
      costPerUnit: "单位成本",
      units: "单位",
      total: "总计",
      manualDepiningCost: "手动除松成本",
      totalManualProgram: "手动项目总计",
      socialEnvironmentalImpact: "社会和环境影响",
      transparency: "透明度",
      thisPlanWill: "此计划将：",
      allWorkWillBe: "所有工作将：",
      everyContributionSupports: "每笔捐款支持："
    },
    donate: {
      phasesAndMilestones: "阶段与里程碑",
      equipmentAndInfrastructure: "设备与基础设施",
      totalEquipmentCost: "设备总成本",
      priority: "优先",
      phase: "阶段",
      ofGoal: "目标",
      active: "进行中",
      pending: "待定",
      future: "未来",
      complete: "完成"
    },
    footer: {
      tagline: "恢复巴塔哥尼亚，一棵树一棵树地。",
      copyright: "© {year} Epuyén Renace。保留所有权利。"
    }
  },

  // ARABIC
  ar: {
    nav: {
      home: "الرئيسية",
      map: "الخريطة",
      adopt: "تبني",
      myForest: "غابتي",
      transparency: "الشفافية",
      admin: "الإدارة",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      more: "المزيد",
      community: "المجتمع",
      education: "التعليم",
      governance: "الشفافية",
      vision: "رؤيتنا"
    },
    vision: {
      badge: "رؤيتنا",
      title: "رؤيتنا",
      opening: "رؤيتنا هي أن نثبت للعالم أنه من الممكن إعادة بناء مكان دُمر بيئياً — من خلال الشفافية والهيكلة والعمل الجماعي.",
      whatWeAre: {
        title: "ما هو إيبويين ريناسر",
        description: "إيبويين ريناسر موجود لإنشاء نموذج تجديد ما بعد الحريق: نظام تكون فيه استعادة الأراضي والترميم البيئي وتنمية المجتمع مدفوعة ببيانات قابلة للتحقق بدلاً من الثقة العمياء."
      },
      transparency: {
        title: "شفافية البلوكتشين",
        description: "باستخدام تقنية البلوكتشين كطبقة شفافية، يمكن تتبع كل مساهمة وكل نفقة وكل إجراء علنياً. ليس للمضاربة — ولكن لاستعادة الثقة في كيفية تمويل وتنفيذ جهود التعافي."
      },
      belief: {
        title: "ما نؤمن به",
        description: "نؤمن بأنه عندما تحل الشفافية محل الفساد والهيكلة محل الارتجال، يمكن للمجتمعات أن تنهض من جديد — حتى بعد خسارة بيئية كاملة."
      },
      goal: {
        title: "هدفنا",
        description: "هدفنا ليس فقط استعادة إيبويين، بل إثبات أن نموذجاً اقتصادياً جديداً للتعافي البيئي ممكن — نموذج يمكن تكراره في المناطق المتضررة من الحرائق حول العالم."
      },
      closing: {
        line1: "من الرماد، يمكن إعادة بناء نظام.",
        line2: "من الدمار، يمكن تصميم مستقبل."
      }
    },
    landing: {
      heroTitle: "انبعث من جديد مع إيبويين",
      heroSubtitle: "تبنَّ شجرة. أعد الحياة لباتاغونيا.",
      heroCta: "تبنَّ شجرة",
      heroExplore: "استكشف الخريطة",
      viewRoadmap: "عرض خارطة الطريق",
      missionTitle: "مهمتنا",
      missionText: "استعادة الغابات الأصلية في باتاغونيا الأرجنتينية من خلال إعادة التحريج المجتمعي وتقنية الشفافية الكاملة.",
      restoringPatagonia: "استعادة",
      patagonia: "باتاغونيا",
      howItWorksTitle: "كيف يعمل؟",
      simpleProcess: "عملية بسيطة",
      step1Title: "استكشف الخريطة",
      step1Text: "تصفح خريطتنا التفاعلية واختر شجرة متاحة للتبني.",
      step2Title: "تبنَّ شجرتك",
      step2Text: "قم بالتبرع واحصل على رمز فريد بإحداثيات GPS لشجرتك.",
      step3Title: "تابع نموها",
      step3Text: "احصل على تحديثات بالصور ومتابعة تقدم شجرتك.",
      impactTitle: "أثرنا",
      treesPlanted: "أشجار مزروعة",
      treesAdopted: "أشجار متبناة",
      donorsCount: "متبرعون",
      co2Offset: "طن CO₂ معوضة",
      transparencyTitle: "شفافية كاملة",
      transparencyText: "كل تبرع ونفقة قابلة للتحقق علنياً. لا أسرار، فقط نتائج.",
      viewTransparency: "عرض السجل العام",
      footerTagline: "استعادة باتاغونيا، شجرة واحدة في كل مرة.",
      whatHappened: {
        title: "ماذا حدث لإيبويين؟",
        year: "في 2025 و2026، تعرضت إيبويين لأسوأ حرائق الغابات في تاريخها.",
        hectares: "تم تدمير أكثر من 9,000 هكتار من الغابات الأندينية الأصلية.",
        ecosystems: "احترقت أنظمة بيئية بأكملها.",
        homes: "فُقدت المنازل.",
        wildlife: "اختفت الحياة البرية.",
        landExposed: "تُركت الأرض مكشوفة وجافة وهشة.",
        balanceBroken: "لم تستهلك الحرائق الأشجار فقط — بل كسرت التوازن الطبيعي الذي يحمي الماء والتربة والمناخ. بدون غطاء حرجي، تنخفض الأمطار، وتزداد التعرية، ويصبح خطر الحرائق المستقبلية أكبر.",
        minimalEfforts: "على الرغم من حجم الكارثة، كانت جهود التعافي ضئيلة. لم يكن هناك خطة شاملة للاستعادة البيئية، ولا استراتيجية وقاية طويلة المدى، ولا برنامج إعادة بناء هيكلي.",
        peopleStayed: "بقي أهل إيبويين. بقوا ليرعوا، ويقاوموا، ويبدأوا من جديد.",
        todayScars: "اليوم، لا تزال الأرض تحمل الندوب — لكنها تحمل أيضاً إمكانية التجدد.",
        epuyenCreated: "تم إنشاء إيبويين ريناسر لتحويل المأساة إلى بنية: لاستعادة الغابات الأصلية، وتقليل مخاطر الحرائق، وإعادة بناء التوازن البيئي وضمان عدم تكرار ذلك أبداً.",
        fromAshes: "من الرماد لا تنشأ الصدفة: المستقبل يُبنى بالنية والحقيقة والمجتمع."
      },
      coreChallenges: {
        title: "التحديات الأساسية",
        mainChallenge: "التحدي الرئيسي في إيبويين هو إزالة الصنوبر — الإزالة واسعة النطاق لأنواع الصنوبر الغازية التي سيطرت على المشهد الطبيعي.",
        effectiveMethod: "من خلال الخبرة الميدانية والاختبار، حددنا الطريقة الأكثر فعالية: تقطيع الصنوبر في الموقع، مما يسمح للمادة العضوية بتجديد التربة بدلاً من إزالتها أو حرقها.",
        processRestores: "هذه العملية تستعيد الرطوبة، وتحسن بنية التربة، وتخلق ظروفاً فورية لاستعادة الغابات الأصلية.",
        parallelReplanting: "في الوقت نفسه، تبدأ إعادة الزراعة بالتوازي. يجب أن تحدث الإزالة والتجديد معاً — ليس بفارق سنوات — لمنع التآكل وإعادة استعمار الأنواع الغازية.",
        secondMission: "مهمتنا الرئيسية الثانية هي الوقاية من الحرائق وتقليل المخاطر المستقبلية.",
        moreThanPlanting: "هذا يتطلب أكثر من زراعة الأشجار. إنه يتطلب قدرة تشغيلية دائمة، بما في ذلك الحصول على معدات متخصصة قادرة على العمل في التضاريس الصعبة والاستجابة السريعة لتهديدات الحرائق.",
        foundationInvest: "لتحقيق ذلك، يجب على المؤسسة الاستثمار في:",
        investList: {
          machinery: "آلات الغابات والتقطيع",
          equipment: "معدات قادرة على الوصول للتضاريس الصعبة",
          tools: "أدوات لتقليل حمل الوقود والصيانة",
          infrastructure: "بنية تحتية للوقاية طويلة المدى"
        },
        withoutEquipment: "بدون هذه المعدات، يظل التجديد هشاً ويتكرر دورة التدمير.",
        breakCycle: "إيبويين ريناسر موجودة لكسر هذه الدورة — من خلال استعادة الأرض، وتقليل مخاطر الحرائق، وبناء نظام دائم للوقاية من أجل المستقبل."
      },
      donationCategories: {
        title: "فئات التبرع",
        subtitle: "اختر بالضبط كيف تريد استخدام مساهمتك",
        cta: {
          supportMission: "ادعم هذه المهمة",
          ctaDescription: "كل تبرع يذهب مباشرة لشراء المعدات وإكمال هذه المراحل. جميع النفقات موثقة علنياً بالصور والإيصالات وبيانات GPS.",
          donateToCategory: "تبرع لهذه الفئة",
          viewTransparency: "عرض سجلات الشفافية"
        },
        category1: {
          icon: "🟫",
          title: "إزالة الصنوبر والوقاية من الحرائق",
          description: "برنامج وقائي مكثف لمدة خمس سنوات لإزالة أنواع الصنوبر الغازية، وتقليل مخاطر الحرائق الشديدة، وحماية الغابات الأصلية المتبقية في إيبويين.",
          supports: "تدعم مساهمتك البنية التحتية الدائمة للوقاية من الحرائق، والتوظيف المحلي، والاستقرار البيئي طويل المدى.",
          items: [
            "إزالة الصنوبر الغازي",
            "تقليل حمولة الوقود",
            "حماية الغابات الأصلية"
          ],
          method: "استراتيجية متكاملة لإزالة الصنوبر الآلية واليدوية",
          impact: "تقليل مباشر لشدة الحرائق وحماية طويلة المدى للوادي",
          fiveYearPlan: {
            title: "خطة إزالة الصنوبر المكثفة لخمس سنوات",
            objective: "تقليل مخاطر الحرائق بشكل جذري في جميع أنحاء وادي إيبويين من خلال العمل الوقائي المستمر.",
            targetArea: "حوالي 4,500 هكتار من الصنوبر الغازي (الميت والحي).",
            annualTarget: "حوالي 900 هكتار معالج سنوياً.",
            duration: "5 سنوات من التشغيل المستمر.",
            operations: "عمليات ميدانية على مدار السنة تجمع بين الآلات والفرق اليدوية.",
            phases: {
              year1: {
                title: "استقرار الطوارئ",
                description: "تدخل فوري في المناطق عالية الخطورة بالقرب من المنازل وطرق الوصول والبنية التحتية الحيوية."
              },
              year2: {
                title: "مرحلة التوسع",
                description: "توسيع العمليات عبر مناطق أكبر يهيمن عليها الصنوبر وإنشاء ممرات وقاية دائمة."
              },
              year3: {
                title: "التدخل في عمق الوادي",
                description: "معالجة مناطق الوادي الداخلية وتعزيز إزالة الصنوبر اليدوية في مناطق الغابات المختلطة."
              },
              year4: {
                title: "الصيانة والتحكم في النمو",
                description: "تدخلات المرور الثاني لمنع النمو المتجدد وتعزيز مقاومة الحرائق طويلة المدى."
              },
              year5: {
                title: "الاستقرار والانتقال",
                description: "تقليل المخاطر النهائي، والرصد البيئي، والانتقال نحو الصيانة طويلة المدى."
              }
            },
            equipment: {
              title: "المعدات الحرجية المطلوبة",
              totalCost: "3.0 – 5.8 مليون دولار (استثمار لمرة واحدة)",
              highVolumeMulchers: "آلات تقطيع حرجية عالية السعة لمناطق الصنوبر الكثيفة.",
              accessMulchers: "آلات تقطيع مدمجة للمنحدرات والتضاريس محدودة الوصول.",
              excavators: "حفارات حرجية مع قابضات وحماية.",
              dozer: "جرافة لفواصل الحريق وصيانة الممرات.",
              loader: "رافعة شوكية للخدمات اللوجستية ومناولة المواد.",
              transport: "شاحنات نقل ومركبات خدمة."
            },
            capex: {
              title: "الاستثمار الرأسمالي (CAPEX)",
              total: "آلات وبنية تحتية تُشترى مرة واحدة لخلق قدرة وقائية دائمة."
            },
            strategic: {
              title: "القيمة الاستراتيجية",
              establishes: "يُنشئ هذا الاستثمار قدرة دائمة للوقاية من الحرائق لإيبويين.",
              items: [
                "تقليل حمولة الوقود طويل المدى",
                "قدرة وقائية للاستجابة السريعة",
                "تقليل تكاليف مكافحة الحرائق الطارئة",
                "مرونة إقليمية ضد الحرائق المستقبلية"
              ],
              note: "تبقى هذه البنية التحتية متاحة لعقود."
            },
            twoMethods: {
              intro: "لا يمكن تحقيق إزالة الصنوبر من خلال طريقة واحدة.",
              approach: "تدمج الخطة نهجين متكاملين بناءً على الظروف البيئية.",
              mechanical: {
                title: "إزالة الصنوبر الآلية",
                description: "تُستخدم في المناطق التي يهيمن عليها الصنوبر الغازي بالكامل.",
                items: [
                  "تقليل الوقود عالي السرعة",
                  "معالجة المساحات الكبيرة",
                  "التحضير للاستعادة"
                ],
                note: "تُطبق فقط حيث تغيب الغابات الأصلية."
              },
              manual: {
                title: "إزالة الصنوبر اليدوية / الجراحية",
                description: "إزالة انتقائية للصنوبر حيث تبقى الغابات الأصلية.",
                zones: [
                  "غابات الصنوبر والأشجار الأصلية المختلطة",
                  "مناطق التجديد",
                  "المجاري المائية",
                  "مناطق الحماية السكنية"
                ],
                method: "إزالة شجرة بشجرة باستخدام فرق مدربة ومناشير.",
                note: "ضرورية لمنع الضرر البيئي."
              }
            },
            employment: {
              title: "برنامج التوظيف المحلي",
              intro: "تخلق إزالة الصنوبر اليدوية توظيفاً مستقراً طويل المدى.",
              priority: "أولوية التوظيف لسكان إيبويين والمجتمعات المحيطة.",
              equipmentItems: [
                "مناشير احترافية",
                "معدات السلامة",
                "أدوات الصيانة"
              ],
              manualCostCategories: [
                "الرواتب",
                "الأدوات والمعدات",
                "السلامة التشغيلية"
              ]
            },
            conclusion: "تحول هذه الخطة الخمسية الوقاية من الحرائق من رد فعل طارئ إلى حماية إقليمية دائمة.",
            costExplanation: {
              title: "شرح التكاليف",
              intro: "تتطلب الوقاية الفعالة استثماراً مستمراً طويل المدى.",
              requirement: "الإجراءات قصيرة المدى غير كافية لكسر دورة الحرائق.",
              integration: "تدمج الخطة الآلات والعمالة والصيانة والرصد.",
              mechanical: {
                title: "تكاليف إزالة الصنوبر الآلية",
                description: "تمكّن الآلات الثقيلة التدخل واسع النطاق.",
                capability: "تسمح بالمعالجة السريعة للمناطق عالية الخطورة التي يهيمن عليها الصنوبر.",
                includes: "تغطي جميع العمليات المتعلقة بالآلات.",
                items: [
                  "آلات التقطيع الحرجية",
                  "الحفارات والجرافات",
                  "لوجستيات النقل",
                  "الوقود",
                  "الصيانة",
                  "قطع الغيار",
                  "العمليات الميدانية"
                ],
                oneTimeInvestment: "استثمار لمرة واحدة",
                oneTimeRange: "3.0 – 5.8 مليون دولار",
                operationalCost: "تكلفة التشغيل (5 سنوات)",
                operationalRange: "6.1 – 10.7 مليون دولار",
                note: "يخلق بنية تحتية وقائية دائمة."
              },
              manual: {
                title: "تكاليف إزالة الصنوبر اليدوية",
                description: "مطلوبة حيث لا يمكن استخدام الآلات بأمان.",
                limitation: "ستلحق الآلات الثقيلة الضرر بالغابات الأصلية.",
                requirement: "التدخل البشري الانتقائي ضروري.",
                whereApplied: "تُطبق في المناطق البيئية الحساسة.",
                zones: [
                  "الغابات المختلطة",
                  "المناطق النهرية",
                  "بالقرب من المنازل",
                  "مناطق التجديد",
                  "مناطق القيمة البيئية العالية"
                ],
                includes: "تغطي القوى العاملة والمعدات.",
                items: [
                  "50 عاملاً بدوام كامل",
                  "مناشير احترافية",
                  "معدات الحماية",
                  "الأدوات والصيانة",
                  "السلامة التشغيلية"
                ],
                workers: "50 عاملاً",
                salary: "1,000 دولار شهرياً",
                duration: "5 سنوات",
                totalCost: "التكلفة الإجمالية",
                totalAmount: "3.125 مليون دولار"
              },
              totalCost: {
                title: "إجمالي تكلفة الوقاية لخمس سنوات",
                componentHeader: "المكون",
                costHeader: "التكلفة",
                components: [
                  { category: "استثمار الآلات", cost: "3.0 – 5.8 مليون دولار" },
                  { category: "تشغيل الآلات (5 سنوات)", cost: "6.1 – 10.7 مليون دولار" },
                  { category: "إزالة الصنوبر اليدوية (5 سنوات)", cost: "3.125 مليون دولار" }
                ],
                total: "إجمالي تكلفة البرنامج",
                totalRange: "12.2 – 19.6 مليون دولار"
              },
              delivers: {
                title: "ما تقدمه هذه الخطة",
                intro: "على مدى خمس سنوات، يوفر البرنامج:",
                items: [
                  "تقليل كبير لمخاطر الحرائق",
                  "إزالة حمولة الوقود",
                  "حماية الغابات الأصلية",
                  "استعادة التربة والرطوبة",
                  "ممرات وقاية دائمة",
                  "استقرار التوظيف المحلي",
                  "تقليل تكاليف الطوارئ المستقبلية",
                  "مرونة بيئية طويلة المدى"
                ],
                notEmergency: "هذا ليس استجابة طارئة.",
                structural: "إنها وقاية هيكلية من الحرائق."
              },
              whyFiveYears: {
                title: "لماذا خمس سنوات؟",
                intro: "لا تستقر النظم البيئية في أشهر.",
                allows: "يسمح أفق خمس سنوات بـ:",
                items: [
                  "إزالة الكتلة الرئيسية من الصنوبر الغازي",
                  "منع النمو المتجدد",
                  "استقرار التربة",
                  "دعم التجديد الطبيعي",
                  "تقليل المخاطر طويل المدى"
                ],
                conclusion: "الجداول الزمنية الأقصر لا يمكنها كسر دورة الحرائق."
              },
              transparency: {
                title: "الشفافية",
                intro: "ستكون جميع الأموال قابلة للتتبع علنياً.",
                items: [
                  "مناطق العمل المحددة جغرافياً",
                  "تقارير الهكتارات المعالجة",
                  "تحديثات شهرية",
                  "توثيق مرئي",
                  "لوحة شفافية عامة"
                ],
                conclusion: "كل مساهمة قابلة للتحقق."
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "نظام قارب مكافحة الحرائق لبحيرة إيبويين",
          description: "هذه الفئة تنشئ وحدة دائمة لمكافحة الحرائق المائية قادرة على النشر السريع والضخ عالي السعة.",
          supports: "التبرعات تدعم:",
          items: [
            "سفينة متخصصة لمكافحة الحرائق",
            "نظام مضخة صناعية عالية السعة",
            "أنظمة الخراطيم والبكرات",
            "دفع كهربائي/هجين",
            "معدات السلامة ومكافحة الحرائق"
          ],
          objective: "الهدف هو تحويل بحيرة إيبويين من عنصر سلبي إلى أصل دفاع نشط ضد الحرائق.",
          impact: "هذه الفئة تحمي الأرواح والغابات والبنية التحتية مع قدرة استجابة في دقائق.",
          boatSystem: {
            title: "نظام قارب مكافحة الحرائق لبحيرة إيبويين",
            subtitle: "وحدة استجابة سريعة للحرائق المائية",
            objective: "إنشاء وحدة قارب مكافحة حرائق دائمة قادرة على النشر السريع وضخ المياه عالي السعة ودعم الفرق الأرضية — تحويل بحيرة إيبويين من عنصر سلبي إلى أصل دفاع نشط ضد الحرائق.",
            vesselLength: "9-12 متر",
            pumpCapacity: "4,000-8,000 لتر/دقيقة",
            crew: "6-10 رجال إطفاء",
            propulsion: "كهربائي/هجين",
            challengesTitle: "لماذا الاستجابة المائية؟",
            challengesIntro: "تخلق جغرافية إيبويين ثلاثة تحديات رئيسية:",
            challenges: [
              "منحدرات حرجية شديدة الانحدار",
              "وصول طرقي محدود",
              "رياح وادي قوية"
            ],
            solutionStatement: "الاستجابة المائية تحل الثلاثة.",
            capabilitiesTitle: "يمكن للقارب:",
            capabilities: [
              "الوصول إلى جبهات الحريق أسرع من الشاحنات",
              "ضخ مياه غير محدودة من البحيرة",
              "العمل حتى عندما تكون الطرق مسدودة",
              "مهاجمة الحرائق من أسفل المنحدر",
              "تقليل وقت الاستجابة بنسبة 60-80%"
            ],
            capex: {
              title: "إجمالي الاستثمار (CAPEX)",
              total: "إجمالي الاستثمار",
              argentinaLanded: {
                title: "تكلفة التسليم في الأرجنتين (الاستيراد + اللوجستيات)",
                learnMore: "معرفة المزيد",
                learnLess: "إخفاء التفاصيل",
                intro: "السعر الدولي \"الأساسي\" ليس التكلفة الحقيقية في الأرجنتين. تكلف آلات الغابات الثقيلة أكثر بكثير بسبب ضرائب الاستيراد وضريبة القيمة المضافة والتخليص الجمركي ومناولة الميناء والنقل الداخلي إلى باتاغونيا والتأخيرات وتضخم قطع الغيار.",
                points: [
                  "يمكن أن تضيف تكاليف الاستيراد النموذجية +40% إلى +90% حسب نوع المعدات ومسار الاستيراد.",
                  "قد توجد إعفاءات للمنظمات غير الحكومية لاحقًا، لكنها غير مضمونة قبل التسجيل القانوني. نعتبرها ميزة محتملة وليست مفترضة.",
                  "يضيف النقل الداخلي إلى باتاغونيا وتأخيرات الميناء تكلفة ملموسة.",
                  "قطع الغيار باهظة الثمن وبطيئة في الأرجنتين - نشمل احتياطي جاهزية 10-15% (حاسم لوقت التشغيل)."
                ],
                costBreakdown: {
                  title: "ملخص التكلفة الواقعية",
                  baseMachinery: "الآلات الأساسية (السعر الدولي)",
                  baseRange: "~3.0-5.8 مليون دولار",
                  importTaxes: "الاستيراد/الضرائب/اللوجستيات (الأرجنتين)",
                  importRange: "+2.4-2.8 مليون دولار",
                  spareParts: "قطع الغيار/احتياطي الجاهزية (10-15%)",
                  spareRange: "+0.7-1.0 مليون دولار",
                  totalLanded: "التكلفة الرأسمالية المقدرة الفعلية في الأرجنتين",
                  totalRange: "7.5-8.2 مليون دولار"
                },
                disclaimer: "تعكس جميع الميزانيات تكاليف التسليم الواقعية في الأرجنتين (الضرائب، اللوجستيات إلى باتاغونيا، الجاهزية). أي إعفاءات مستقبلية تقلل التكلفة وتزيد الهكتارات المعالجة."
              }
            },
            soilComparison: {
              title: "تربة الغابات الأصلية مقابل تربة مزارع الصنوبر",
              subtitle: "لماذا ينتشر الحريق أسرع بكثير في غابات الصنوبر",
              intro: "الفرق ليس فقط في الشجرة. الفرق في نظام التربة بأكمله تحتها.",
              native: {
                title: "تربة الغابات الأصلية",
                species: "كويهو، لينغا، نيري، رادال",
                description: "تخلق غابات باتاغونيا الأصلية:",
                characteristics: [
                  "تنوع عضوي عالي",
                  "طبقة دبال عميقة",
                  "شبكات فطرية (الجذور الفطرية)",
                  "احتفاظ مستمر بالرطوبة",
                  "بنية إسفنجية",
                  "تحلل بطيء",
                  "نشاط ميكروبي عالي"
                ],
                moisture: "25-45%",
                moistureLabel: "رطوبة التربة النموذجية",
                moistureNote: "حتى في الصيف.",
                fireBehavior: {
                  title: "سلوك الحريق:",
                  points: [
                    "تبقى اللهب منخفضة",
                    "ينتشر الحريق ببطء",
                    "غالبًا ما ينطفئ ذاتيًا",
                    "يحترق بشكل متقطع وليس متصل",
                    "من الصعب أن يصل إلى التاج"
                  ]
                },
                spreadSpeed: "0.1-0.5 متر في الدقيقة",
                spreadNote: "غالبًا يتوقف في الليل."
              },
              pine: {
                title: "تربة مزارع الصنوبر",
                warning: "الصنوبر يغير التربة جذريًا.",
                characteristics: [
                  "فضلات حمضية (pH 3.5-4.5)",
                  "إبر مشبعة بالراتنج",
                  "تنوع ميكروبي ضعيف",
                  "شبه انعدام للتكافل الفطري",
                  "تربة معدنية مضغوطة",
                  "طاردة للماء",
                  "جفاف سريع"
                ],
                moisture: "5-12%",
                moistureLabel: "رطوبة التربة النموذجية",
                moistureNote: "حتى بالقرب من البحيرات.",
                fireBehavior: {
                  title: "سلوك الحريق:",
                  points: [
                    "يشتعل بسهولة",
                    "ينتقل الحريق بشكل متواصل",
                    "تتسلق اللهب عموديًا",
                    "حرارة إشعاعية شديدة",
                    "تشتعل التيجان بسرعة"
                  ]
                },
                spreadSpeed: "5-20 متر في الدقيقة",
                spreadWind: "40-60 متر في الدقيقة",
                spreadWindLabel: "في الرياح:",
                spreadComparison: "أسرع 100 مرة."
              },
              publicQuote: "أشجار الصنوبر لا تحترق فقط - إنها تعيد تصميم التربة لتحترق أسرع.",
              quoteNote: "هذه ليست مبالغة - هذه فيزياء.",
              whyWorks: {
                title: "لماذا تعمل إزالة الصنوبر",
                intro: "إزالة الصنوبر:",
                benefits: [
                  "ترفع رطوبة التربة",
                  "تستعيد الفطريات",
                  "تكسر استمرارية الوقود",
                  "تخفض ارتفاع اللهب",
                  "تبطئ انتشار الحريق",
                  "تسمح للأنواع الأصلية بالعودة"
                ],
                conclusion: "لهذا السبب تنجح الوقاية."
              },
              fireLadders: {
                title: "لماذا تتحرك حرائق الصنوبر بسرعة",
                intro: "لأن الصنوبر يخلق ثلاثة سلالم حريق في آن واحد:",
                ladder1: {
                  title: "إبر الراتنج (وقود أرضي)",
                  points: ["قابلة للاشتعال بشدة", "درجة حرارة الاشتعال ≈ 260°C", "أوراق الغابة الأصلية تشتعل ≈ 450-500°C", "فرق تقريبًا 2×"]
                },
                ladder2: {
                  title: "سلم الوقود العمودي",
                  points: ["فروع من الأرض إلى التاج", "النار تتسلق بسهولة", "الأشجار الأصلية تتقلم ذاتيًا"]
                },
                ladder3: {
                  title: "استمرارية التاج",
                  points: ["مظلات الصنوبر موحدة", "النار تقفز من تاج إلى تاج", "الغابة الأصلية غير منتظمة ومتقطعة"]
                }
              },
              comparisonTable: {
                title: "مقارنة كمية",
                headers: ["العامل", "الغابة الأصلية", "مزرعة الصنوبر"],
                rows: [
                  ["رطوبة التربة", "25-45%", "5-12%"],
                  ["درجة حرارة اشتعال الفضلات", "450-500°C", "260-300°C"],
                  ["سرعة انتشار الحريق", "0.1-0.5 م/دقيقة", "5-60 م/دقيقة"],
                  ["احتمالية حريق التاج", "منخفضة جداً", "عالية للغاية"],
                  ["الانطفاء الذاتي", "شائع", "نادر"],
                  ["تعافي التربة بعد الحريق", "سريع", "بطيء جداً"],
                  ["خطر التعرية", "منخفض", "شديد"]
                ]
              },
              intensity: {
                title: "مقارنة شدة الحريق",
                label: "شدة الحريق (كيلوواط/م):",
                native: "500-2,000 كيلوواط/م",
                pine: "20,000-60,000 كيلوواط/م",
                comparison: "هذا يعني 10-30 مرة أكثر طاقة.",
                warning: "لا يمكن لأي رجل إطفاء الوقوف بالقرب من ذلك."
              },
              waterCycle: {
                title: "فرق دورة المياه (حرج)",
                native: {
                  title: "تربة الغابة الأصلية:",
                  points: ["تمتص المطر", "تخزن الماء", "تطلق الرطوبة ببطء", "تبرد المناخ المحلي"]
                },
                pine: {
                  title: "تربة الصنوبر:",
                  points: ["تطرد المطر", "يزداد الجريان السطحي", "تجف بسرعة", "تزيد الحرارة"]
                },
                conclusion: "هذا يخلق مناخات محلية حارة وجافة وعاصفة. النار تتغذى على ذلك."
              },
              feedback: {
                title: "لماذا تنفجر الحرائق في مناطق الصنوبر",
                intro: "لأن أنظمة الصنوبر:",
                points: ["تجف أسرع", "تشتعل أبكر", "تحترق أكثر سخونة", "تنتشر أسرع", "تحترق بشكل متواصل", "تجدد المزيد من الصنوبر بعد ذلك"],
                conclusion: "إنها حلقة تغذية راجعة."
              },
              summary: {
                title: "ملخص بكلمات بسيطة",
                native: "الغابة الأصلية = إسفنجة رطبة",
                pine: "مزرعة الصنوبر = سجادة بنزين",
                note: "هذه ليست مبالغة — هذه فيزياء."
              }
            },
            strategic: {
              title: "القيمة الاستراتيجية",
              establishes: "هذا النظام يخلق:",
              items: [
                "قدرة دائمة لمكافحة الحرائق المائية",
                "قدرة استجابة سريعة في دقائق",
                "تكاليف إخماد أقل",
                "تقليل احتمالية انتشار الحريق",
                "حماية المنازل والغابات ومصادر المياه"
              ],
              note: "يحول بحيرة إيبويين من عنصر سلبي إلى أصل دفاع نشط ضد الحرائق."
            },
            conclusion: "يمثل قارب مكافحة الحرائق المخصص في بحيرة إيبويين أحد أكثر الاستثمارات كفاءة في الوقاية من الحرائق البرية والاستجابة لها. إنه يحول البحيرة إلى نظام دفاع أمامي — يحمي الوادي قبل أن تصبح الحرائق كوارث."
          }
        },
        category3: {
          icon: "🌱",
          title: "إعادة التحريج والحفاظ على المستقبل",
          description: "هذه الفئة تدعم الاستعادة البيئية طويلة المدى لإيبويين.",
          supports: "التبرعات تستخدم لـ:",
          items: [
            "زراعة الأشجار الأصلية",
            "تطوير المشاتل",
            "تجديد التربة",
            "الصيانة طويلة المدى",
            "استعادة التنوع البيولوجي",
            "مراقبة وحماية المناطق المستعادة"
          ],
          impact: "هذا يضمن أن الغابات المستعادة تنجو وتنضج وتبقى محمية للأجيال القادمة."
        },
        category4: {
          icon: "♻️",
          title: "إدارة النفايات والتلوث",
          description: "من خلال المراقبة الميدانية والحوار المجتمعي، حددنا أن إيبويين تواجه تحدياً كبيراً في النفايات المفتوحة والتلوث.",
          supports: "نركز حالياً على:",
          items: [
            "فهم تدفقات النفايات الحالية",
            "تحديد مخاطر التلوث",
            "رسم خرائط مناطق الإغراق المفتوح",
            "دراسة الآثار البيئية والصحية",
            "مراجعة النماذج القابلة للتطبيق من المجتمعات الريفية المماثلة"
          ],
          objective: "الهدف ليس فرض حل، بل بناء حل واقعي ومستدام ومناسب لحجم وجغرافية إيبويين.",
          impact: "معالجة التلوث ضرورية لحماية مصادر المياه واستعادة النظم البيئية وضمان مستقبل صحي للمجتمع.",
          researchPhase: {
            title: "إدارة النفايات والتلوث",
            currentPhase: "مرحلة البحث والتشخيص",
            context: "من خلال المراقبة الميدانية والحوار المجتمعي، حددنا أن إيبويين تواجه تحدياً كبيراً في النفايات المفتوحة والتلوث، بما في ذلك مناطق الإغراق غير الرسمية التي تشكل مخاطر طويلة المدى للتربة والمياه والصحة العامة.",
            statement: "لا يمكن معالجة هذه المشكلة من خلال الارتجال أو الإجراءات المنعزلة.",
            focusTitle: "مجالات التركيز الحالية:",
            focusAreas: [
              "فهم تدفقات النفايات الحالية",
              "تحديد مخاطر التلوث",
              "رسم خرائط مناطق الإغراق المفتوح",
              "دراسة الآثار البيئية والصحية",
              "مراجعة النماذج القابلة للتطبيق المستخدمة في المجتمعات الريفية والجبلية المماثلة"
            ],
            requirement: "تتطلب إدارة النفايات الدقة التقنية والتنسيق التنظيمي والتخطيط طويل المدى.",
            ethos: "كجزء من مبادئنا، لن يتم الإعلان عن أي حل دون البحث المناسب.",
            commitment: "بمجرد اكتمال مرحلة التقييم هذه، سينشر Epuyén Renace اقتراحاً واضحاً وعلنياً وشفافاً لإدارة النفايات، مفتوحاً للمراجعة المجتمعية والحوار المؤسسي.",
            objective: "الهدف ليس فرض حل، بل بناء حل واقعي ومستدام ومناسب لحجم وجغرافية إيبويين.",
            importance: "معالجة التلوث ضرورية لحماية مصادر المياه واستعادة النظم البيئية وضمان مستقبل صحي للمجتمع."
          }
        },
        transparency: {
          title: "الشفافية حسب الفئة",
          description: "كل فئة تبرع لديها:",
          items: [
            "ميزانية مخصصة",
            "تتبع عام للتقدم",
            "نفقات موثقة",
            "صور وبيانات GPS وتقارير",
            "سجلات شفافية قائمة على البلوكشين"
          ],
          verify: "يمكن للمتبرعين اختيار كيفية استخدام مساهمتهم بالضبط والتحقق من تأثيرها في كل مرحلة."
        },
        oneSystem: {
          title: "نظام واحد، خمس مهام",
          depining: "إزالة الصنوبر تقلل المخاطر.",
          firefighting: "مكافحة الحرائق تحمي في حالات الطوارئ.",
          reforestation: "إعادة التحريج تستعيد الحياة.",
          contamination: "إدارة النفايات تحمي المياه والصحة.",
          biosphere: "حديقة المحيط الحيوي تبني المستقبل المستدام.",
          together: "معاً، يشكلون نموذجاً كاملاً ودائماً للتعافي من الحرائق لإيبويين — مما يثبت أن المكان يمكن أن ينهض مرة أخرى عندما يكون هناك تنظيم وتكنولوجيا والتزام حقيقي."
        }
      }
    },
    roadmap: {
      title: "خارطة الطريق",
      subtitle: "نظام طويل المدى لتجديد الأرض وإعطاء إيبويين مستقبلاً. ليست سياسة أو صدقة — إنها عمل قابل للتحقق.",
      thePlan: "الخطة",
      active: "نشط",
      upcoming: "قادم",
      comingSoon: "قريباً",
      rAndD: "بحث وتطوير",
      vision: "رؤية",
      future: "المستقبل",
      goal: "الهدف",
      raised: "تم جمعه",
      totalGoal: "الهدف الإجمالي",
      treesAdopted: "أشجار متبناة",
      projectPhases: "مراحل المشروع",
      progress: "التقدم",
      everyContribution: "كل مساهمة تقربنا من الهدف",
      phase0: {
        title: "التأسيس + الشفافية الرقمية",
        description: "إنشاء مؤسسة إيبويين ريناسر، إطلاق الموقع + خارطة طريق عامة، إعداد خريطة رقمية بالدرون/ليدار، تحديد المناطق والمؤشرات ونموذج التكلفة ونظام البلوكتشين لتتبع التبرعات والنفقات.",
        tags: ["الموقع", "خريطة 3D", "بلوكتشين", "مؤسسة قانونية"],
        status: "الإعداد الأولي"
      },
      phase1: {
        title: "سباق التشجير",
        description: "زراعة 10,000 شجرة أصلية. تكلفة كل شجرة ~25 دولار أمريكي ويتم تتبعها بنظام GPS والصور والجدول الزمني والسجل العام.",
        tags: ["10,000 شجرة", "تتبع GPS", "صور", "سجل عام"],
        treesAdopted: "أشجار متبناة",
        available: "متاحة"
      },
      phase2: {
        title: "تقليل المخاطر + التوسع",
        description: "إزالة 5,000 صنوبر غازية، زراعة 20,000 شجرة أصلية، وشراء 2 آلة تقطيع لمعالجة الصنوبر إلى نشارة وتقليل حمل الوقود.",
        tags: ["إزالة 5,000 صنوبر", "20,000 أصلية", "2 آلة تقطيع"],
        proof: "نشر الأدلة: سجلات الإزالة + دفعات الزراعة + الإيصالات"
      },
      phase3: {
        title: "ابتكار مكافحة الحرائق في باتاغونيا",
        description: "تصميم وبناء نظام هجين خاص لمكافحة الحرائق: قدرة مياه/قارب + طائرات بدون طيار + استجابة أرضية. الهدف: الكشف المبكر + الاحتواء السريع في التضاريس النائية.",
        tags: ["طائرات بدون طيار", "مركبة هجينة", "كشف مبكر", "بحث وتطوير مفتوح"],
        milestones: "معالم واضحة ونماذج أولية وتقارير عامة"
      },
      phase4: {
        title: "حديقة المحيط الحيوي العامة 33 هكتار",
        description: "شراء 33 هكتاراً، مملوكة لمؤسسة إيبويين ريناسر. تصميمها كحديقة محيط حيوي عامة مع: مناطق استعادة التنوع البيولوجي، تعليم الأنواع الغازية، عرض إنتاج الغذاء المتجدد، مركز معالجة، كافتيريا، مطعم على البحيرة + أرصفة، ومركز تعليمي.",
        tags: ["33 هكتار", "مركز تعليمي", "مطعم البحيرة", "أرصفة", "إنتاج محلي"],
        purpose: "حماية دائمة + وظائف + تعليم + اقتصاد محلي مستدام"
      },
      phase5: {
        title: "منصة SaaS الكاملة",
        description: "تصبح إيبويين توأماً رقمياً. خريطة مسح بالدرون/ليدار: أشجار معدودة ومسجلة، شجرة 1 = رمز/شهادة 1، سوق تبني تفاعلي، لوحات شفافية على السلسلة وخارجها، وحدات متطوعين/مجتمع، تقارير وأدوات تدقيق.",
        tags: ["توأم رقمي", "ليدار", "رموز NFT", "على السلسلة", "تدقيق"],
        scalable: "نموذج قابل للتطوير لمشاريع الحفظ الأخرى"
      },
      summary: {
        foundation: "التأسيس",
        trees10k: "10 آلاف شجرة",
        expansion: "التوسع",
        fireFighting: "مكافحة الحرائق",
        park33ha: "حديقة 33 هكتار",
        platform: "المنصة"
      }
    },
    education: {
      title: "تعلم عن الغابة",
      subtitle: "المعرفة قوة. فهم نظامنا البيئي هو الخطوة الأولى لحمايته.",
      badge: "التعليم البيئي",
      nativeForest: {
        title: "غابة باتاغونيا الأصلية",
        subtitle: "تعرف على الأنواع التي نحميها",
        lenga: {
          title: "لينغا (Nothofagus pumilio)",
          description: "شجرة نفضية يمكن أن تصل إلى 30 متراً. تتحول أوراقها إلى اللون الأحمر والذهبي في الخريف، مما يخلق مناظر طبيعية رائعة."
        },
        coihue: {
          title: "كويهوي (Nothofagus dombeyi)",
          description: "نوع دائم الخضرة يمكن أن يعيش أكثر من 500 عام. يوفر المأوى والغذاء لعشرات أنواع الطيور والثدييات."
        },
        cipres: {
          title: "سرو الكورديليرا",
          description: "صنوبرية أصلية يمكن أن تتجاوز 1000 عام من العمر. مقاومة ومتكيفة مع مناخ باتاغونيا."
        }
      },
      invasiveSpecies: {
        title: "الأنواع الغازية",
        subtitle: "مشكلة الصنوبر والتهديدات الأخرى",
        pine: {
          title: "الصنوبر الغازي",
          description: "تم إدخاله للتحريج التجاري، ينتشر الصنوبر بقوة، مما يزيح الغابة الأصلية. يحمض التربة ويقلل التنوع البيولوجي ويزيد بشكل كبير من خطر الحرائق.",
          impact: "مرتفع"
        },
        rosehip: {
          title: "ورد المسك",
          description: "على الرغم من أنها تنتج ثماراً صالحة للأكل، فإن هذا النوع الأوروبي ينتشر بسرعة وينافس النباتات الأصلية على الموارد.",
          impact: "متوسط"
        },
        broom: {
          title: "الرتم",
          description: "شجيرة قابلة للاشتعال بدرجة عالية تستعمر المناطق المتدهورة، مما يجعل تجديد الغابة الأصلية صعباً.",
          impact: "مرتفع"
        }
      },
      fireRisk: {
        title: "خطر الحرائق",
        subtitle: "فهم التهديد والوقاية منه",
        whyPinesDangerous: {
          title: "لماذا الصنوبر خطير؟",
          description: "يحتوي الصنوبر على راتنجات قابلة للاشتعال بدرجة عالية. يمكن لغابة صنوبر أن تحترق 10 مرات أسرع من غابة أصلية."
        },
        nativeForestRole: {
          title: "دور الغابة الأصلية",
          description: "الأشجار الأصلية مثل لينغا تحتوي على رطوبة أعلى وراتنجات أقل. الغابة الأصلية الصحية تعمل كحاجز طبيعي للنار."
        },
        communityPrevention: {
          title: "الوقاية المجتمعية",
          description: "إزالة الصنوبر وإنشاء حواجز الحريق وأنظمة الكشف المبكر أساسية. كل شجرة أصلية مزروعة تساهم في تقليل المخاطر."
        }
      },
      biodiversity: {
        title: "التنوع البيولوجي",
        subtitle: "الحياة التي تعتمد على الغابة",
        fauna: {
          title: "الحيوانات الرمزية",
          description: "الهويمول (غزال باتاغونيا المهدد بالانقراض)، البودو (أصغر غزال في العالم)، البوما، وعشرات أنواع الطيور تعتمد على الغابة الأصلية."
        },
        lifeNetwork: {
          title: "شبكة الحياة",
          description: "كل شجرة أصلية تدعم شبكة من الفطريات والأشنات والحشرات والطيور والثدييات. هذا التنوع البيولوجي غير موجود في مزارع الصنوبر."
        },
        corridors: {
          title: "الممرات البيولوجية",
          description: "باستعادة الغابة، نخلق ممرات تسمح للحيوانات بالتنقل وإيجاد شركاء والحفاظ على تجمعات صحية."
        }
      },
      waterCycle: {
        mainTitle: "كيف تجلب الغابات المطر وتحمي مياهنا",
        howRainWorks: "كيف يعمل المطر",
        whyForests: "ولماذا الغابات تشبه نظام المياه في الطبيعة",
        intro1: "تخيل أن الأرض جسم حي.",
        intro2: "الغابات ليست مجرد أشجار — إنها الأعضاء التي تساعد الماء على التحرك والراحة والعودة.",
        letsSeee: "دعنا نرى كيف يعمل 👇",
        whereRainComes: {
          title: "من أين يأتي المطر؟",
          content: "عندما تسخن الشمس الأرض:\n• البحيرات والأنهار تطلق الماء في الهواء\n• الأشجار تطلق الماء من خلال أوراقها\n\nيصبح هذا الماء بخاراً غير مرئي ويرتفع إلى السماء.\n\nعندما يتجمع ما يكفي من البخار، تولد الغيوم.\n\nعندما تصبح الغيوم ثقيلة — 🌧️ ينزل المطر.\n\n**الأشجار تساعد في تكوين الغيوم.**\n\nبدون أشجار، تتكون غيوم أقل."
        },
        treesBreathe: {
          title: "الأشجار تتنفس الماء إلى السماء",
          content: "الأشجار تشرب الماء من التربة بجذورها.\n\nثم تطلق جزءاً من هذا الماء من خلال أوراقها.\n\nهذا يسمى **النتح**، لكن يمكن التفكير فيه هكذا:\n\n*الأشجار تتنفس الماء في الهواء.*\n\nملايين الأشجار تتنفس معاً تخلق:\n• رطوبة\n• هواء أبرد\n• فرص أكثر للمطر\n\nلهذا السبب الغابات تصنع طقسها الخاص."
        },
        whenRainFalls: {
          title: "ماذا يحدث عندما ينزل المطر؟",
          content: "عندما ينزل المطر على غابة صحية:\n• الأوراق تبطئ المطر\n• الجذور تفتح التربة\n• الماء يذهب بلطف تحت الأرض\n\nتصبح التربة مثل الإسفنجة.\n\nهذا الماء يُخزن ويُطلق ببطء لأشهر.\n\nهذا الماء يغذي:\n• الينابيع\n• الجداول\n• البحيرات\n• الحيوانات\n• الناس\n\nلهذا تُسمى الغابات **حارسات الماء**."
        },
        forestsGiveMemory: {
          title: "الغابات تعطي الماء ذاكرة",
          content: "الغابات تساعد الماء على البقاء.\n\nلا تدع كل المطر يهرب دفعة واحدة.\n\n**إنها تتذكر الماء.**\n\nهذا يُسمى *ذاكرة الماء*.\n\nبفضل الغابات:\n• البحيرات لا تجف بسرعة\n• الأنهار تتدفق حتى في الصيف\n• الآبار لا تختفي\n\nبدون غابات، الماء ينسى."
        },
        whenForestsBurn: {
          title: "ماذا يحدث عندما تحترق الغابات؟",
          content: "عندما تحترق غابة:\n• التربة تصبح صلبة\n• الماء لا يستطيع دخول الأرض\n• المطر يهرب بسرعة\n• تحدث فيضانات\n• ثم تتبع فترات جفاف طويلة\n\nبعد الحرائق غالباً نرى:\n• ماء كثير جداً دفعة واحدة\n• ثم لا يكفي لاحقاً\n\n**هذا خطير جداً على البحيرات.**"
        },
        canValleyHelp: {
          title: "هل يمكن لوادٍ أن يساعد وادياً آخر؟",
          content: "أحياناً الغابات في الأودية القريبة تساعد في جلب الرطوبة والغيوم.\n\nهذا يمكن أن يساعد قليلاً.\n\nلكن الماء لا يستطيع السفر بعيداً تحت الأرض عبر الجبال.\n\nهذا يعني:\n\n**كل وادٍ يجب أن يحمي غابته الخاصة.**\n\nلأن المطر يمكن أن يأتي من السماء —\nلكن الماء يجب أن تحتفظ به الأرض."
        },
        whyNativeSpecial: {
          title: "لماذا الغابات الأصلية مميزة",
          content: "الغابات الأصلية:\n• نمت هنا طبيعياً\n• تحمي التربة\n• تسمح للماء بدخول الأرض\n• تقاوم النار بشكل أفضل\n• تساعد الحياة على العودة بعد الكوارث\n\nإنها تعمل مع الأرض.\n\n**إنها تنتمي هنا.**"
        },
        forestsNotDecoration: {
          title: "الغابات ليست زينة",
          content: "الغابات ليست جميلة فقط.\n\nإنها:\n• **صانعات الماء**\n• **حارسات الماء**\n• **حاميات المناخ**\n• **داعمات الحياة**\n\nبدون غابات:\n• البحيرات تضعف\n• المطر يصبح غير منتظم\n• الأرض تجف\n• خطر الحرائق يزداد"
        },
        simpleTruth: {
          title: "حقيقة بسيطة",
          noForest: "لا غابة = لا مستقبل للماء",
          withForests: "لكن مع الغابات:",
          rainReturns: "يعود المطر",
          springsRecover: "تتعافى الينابيع",
          lakesSurvive: "تنجو البحيرات",
          lifeContinues: "تستمر الحياة",
          protectForests: "عندما نحمي الغابات، نحمي الغد.",
          cta: "احمِ شجرة الآن"
        }
      },
      resources: {
        title: "موارد إضافية",
        subtitle: "مواد لتعميق معرفتك",
        viewResource: "عرض المورد",
        guide: {
          title: "دليل الأنواع الأصلية",
          type: "PDF",
          description: "تعريف وخصائص أشجار باتاغونيا الأصلية"
        },
        documentary: {
          title: "وثائقي: غابات في خطر",
          type: "فيديو",
          description: "تاريخ غابة باتاغونيا والتحديات الحالية"
        },
        map: {
          title: "خريطة المشروع التفاعلية",
          type: "تفاعلي",
          description: "استكشف مناطق الزراعة وتابع التقدم"
        }
      },
      cta: {
        title: "مستعد للعمل؟",
        description: "تصبح المعرفة ذات معنى عندما تتحول إلى عمل. كل شجرة تتبناها تساهم في استعادة هذا النظام البيئي الفريد.",
        adoptTree: "تبنَّ شجرة",
        exploreMap: "استكشف الخريطة"
      }
    },
    governance: {
      title: "كيف نحكم",
      subtitle: "لا ثقة عمياء. لا وسطاء غامضون. نظام يمكن التحقق من كل قرار فيه وتتبع كل دولار.",
      badge: "الحوكمة",
      principles: {
        title: "مبادئ الحوكمة",
        subtitle: "الركائز التي توجه كل قرار",
        radicalTransparency: {
          title: "شفافية كاملة",
          description: "كل دولار يدخل ويخرج علني. جميع القرارات موثقة. بدون استثناءات."
        },
        communityParticipation: {
          title: "مشاركة المجتمع",
          description: "للمتبرعين والمجتمع المحلي صوت في قرارات المشروع المهمة."
        },
        protectedFunds: {
          title: "أموال محمية",
          description: "توقيع متعدد مطلوب لتحريك الأموال. لا يمكن لأي فرد التصرف بمفرده."
        },
        accountability: {
          title: "المساءلة",
          description: "عمليات تدقيق منتظمة، تقارير عامة ربع سنوية، والتحقق المستقل."
        }
      },
      treasury: {
        title: "توزيع الأموال",
        subtitle: "كيف يتم تخصيص كل دولار متبرع به",
        badge: "الخزينة",
        viewPublicRecord: "عرض سجل النفقات العام",
        directPlanting: {
          category: "الزراعة المباشرة",
          percentage: 60,
          description: "الشتلات، العمالة، الأدوات"
        },
        maintenance: {
          category: "الصيانة",
          percentage: 20,
          description: "الري، المراقبة، الاستبدال"
        },
        operations: {
          category: "العمليات",
          percentage: 15,
          description: "التكنولوجيا، اللوجستيات، الاتصالات"
        },
        reserve: {
          category: "الاحتياطي",
          percentage: 5,
          description: "الطوارئ والحالات الطارئة"
        }
      },
      multiSig: {
        title: "التوقيع المتعدد",
        subtitle: "لا يمكن لشخص واحد تحريك الأموال من جانب واحد",
        badge: "الأمان",
        requirement: "الحد الأدنى 2 من 3 توقيعات للموافقة على أي حركة أموال. جميع المعاملات عامة وقابلة للتحقق.",
        requiredLabel: "مطلوب",
        foundation: {
          name: "مؤسسة إيبويين",
          role: "المدير الرئيسي",
          required: true
        },
        council: {
          name: "المجلس المجتمعي",
          role: "الممثل المحلي",
          required: true
        },
        auditor: {
          name: "المدقق الخارجي",
          role: "المحقق المستقل",
          required: false
        }
      },
      governanceRoadmap: {
        title: "خارطة طريق الحوكمة",
        subtitle: "نحو حوكمة أكثر لامركزية",
        badge: "التطور",
        currentPhase: {
          phase: "المرحلة الحالية",
          title: "التأسيس",
          status: "active",
          items: [
            "شفافية كاملة للأموال",
            "تقارير عامة شهرية",
            "التحقق من الزراعة بالـ GPS والصور",
            "سجل عام لجميع النفقات"
          ]
        },
        v1Phase: {
          phase: "الإصدار 1 (قريباً)",
          title: "المشاركة",
          status: "upcoming",
          items: [
            "نظام تصويت للمتبرعين",
            "مقترحات مجتمعية",
            "اختيار مناطق الزراعة",
            "تحديد أولويات المشاريع"
          ]
        },
        v2Phase: {
          phase: "الإصدار 2 (المستقبل)",
          title: "اللامركزية",
          status: "future",
          items: [
            "توقيع متعدد على السلسلة للخزينة",
            "NFTs للحوكمة للمتبرعين",
            "منظمة مستقلة لامركزية مجتمعية",
            "تدقيق آلي على السلسلة"
          ]
        }
      },
      cta: {
        title: "شارك في الحوكمة",
        description: "كمتبرع، لديك الحق في المشاركة في قرارات المشروع. صوتك مهم في بناء هذه الغابة.",
        adoptTree: "تبنَّ شجرة",
        viewTransparency: "عرض الشفافية"
      }
    },
    community: {
      title: "أصوات إيبويين",
      subtitle: "تعرف على الأشخاص الذين يبنون مستقبل الغابة",
      badge: "مجتمعنا",
      featuredVoices: {
        title: "أصوات مميزة",
        subtitle: "قصص من الذين يجعلون التجديد ممكناً",
        person1: {
          name: "ماريا ديل كارمن",
          role: "مربية شتلات محلية",
          quote: "كل شتلة أزرعها تحمل جزءاً من قلبي. معرفة أن شخصاً في العالم سيتبناها ويتابع نموها يملأني بالأمل.",
          location: "إيبويين، تشوبوت"
        },
        person2: {
          name: "روبرتو هوينول",
          role: "حارس غابات مجتمعي",
          quote: "علمني جدي كيف أقرأ الغابة. اليوم أعلم الآخرين كيف يحمونها. هذه التكنولوجيا تساعدنا في إظهار ما نفعله للعالم.",
          location: "لاغو بويلو"
        },
        person3: {
          name: "لاورا سيبولفيدا",
          role: "عالمة أحياء",
          quote: "العلم والمجتمع معاً يمكنهما تحقيق ما لا يستطيع أي منهما وحده. هذا المشروع يثبت أن الشفافية تولد الثقة.",
          location: "إل بولسون"
        },
        person4: {
          name: "مارتين كوروهوينكا",
          role: "مجتمع مابوتشي",
          quote: "الأرض ليست ملكنا، نحن ملك الأرض. رعايتها مسؤوليتنا الموروثة والآن أيضاً العالمية.",
          location: "كوشامين"
        },
        person5: {
          name: "صوفيا مارينو",
          role: "معلمة ريفية",
          quote: "طلابي يتعلمون عن الغابة بزراعة الأشجار. رؤية حماسهم يؤكد لي أن المستقبل في أيدٍ أمينة.",
          location: "إيبويين"
        },
        person6: {
          name: "دييغو فرنانديز",
          role: "رجل إطفاء غابات",
          quote: "كل حريق يحطم روحي. لهذا أدعم الوقاية: المزيد من الغابات الأصلية، أقل صنوبر، أقل خطر.",
          location: "تشوليلا"
        }
      },
      documentary: {
        title: "وثائقي: أصوات الغابة",
        description: "رحلة بصرية عبر قصص من يكرسون حياتهم لحماية باتاغونيا.",
        comingSoon: "قريباً",
        watchTrailer: "شاهد الإعلان"
      },
      events: {
        title: "الأحداث القادمة",
        subtitle: "انضم إلى مجتمعنا",
        event1: {
          title: "زراعة مجتمعية",
          date: "15 مارس 2025",
          location: "مشتل إيبويين",
          description: "يوم زراعة مفتوح للمتطوعين"
        },
        event2: {
          title: "ورشة المراقبة",
          date: "22 أبريل 2025",
          location: "المركز المجتمعي",
          description: "تعلم كيفية مراقبة الأشجار بـ GPS"
        },
        event3: {
          title: "الجمعية السنوية",
          date: "10 مايو 2025",
          location: "افتراضي + حضوري",
          description: "مراجعة الإنجازات والتخطيط لعام 2025"
        }
      },
      shareStory: {
        title: "لديك قصة للمشاركة؟",
        description: "إذا كنت جزءاً من مجتمع إيبويين أو تبنيت شجرة، نحب أن نسمع قصتك.",
        cta: "شارك قصتي"
      }
    },
    map: {
      title: "خريطة المشروع",
      viewMap: "عرض الخريطة",
      satellite: "القمر الصناعي",
      terrain: "الخريطة",
      trees: "أشجار",
      legend: "الأسطورة",
      planned: "مخطط",
      planted: "مزروع",
      adopted: "متبنى",
      controls: "التحكمات",
      loading: "جارٍ تحميل الخريطة ثلاثية الأبعاد..."
    },
    tree: {
      details: "تفاصيل الشجرة",
      species: "النوع",
      status: "الحالة",
      coordinates: "الإحداثيات",
      planted: "مزروعة",
      adopted: "متبناة",
      adoptedBy: "تبناها",
      plantingDate: "تاريخ الزراعة",
      photos: "الصور",
      adoptThisTree: "تبنَّ هذه الشجرة",
      viewCertificate: "عرض الشهادة",
      statuses: {
        planned: "مخططة",
        planted: "مزروعة",
        maintained: "في الصيانة",
        dead: "ميتة",
        replaced: "مستبدلة"
      }
    },
    adopt: {
      title: "تبنَّ شجرة",
      subtitle: "تبرعك يساعد في استعادة غابات باتاغونيا",
      selectPackage: "اختر الباقة",
      sapling: "شتلة",
      youngTree: "شجرة صغيرة",
      matureTree: "شجرة ناضجة",
      donorName: "اسم المتبرع",
      donorNamePlaceholder: "اسمك (اختياري)",
      anonymous: "مجهول",
      proceedToPayment: "متابعة الدفع",
      processing: "جارٍ المعالجة...",
      successTitle: "شكراً لتبرعك!",
      successMessage: "تم تخصيص شجرتك. راجع شهادتك.",
      viewMyCertificate: "عرض شهادتي",
      securePayment: "دفع آمن مع Stripe"
    },
    myForest: {
      title: "غابتي",
      subtitle: "أشجارك المتبناة",
      noTrees: "لم تتبنَّ أي أشجار بعد.",
      adoptNow: "تبنَّ الآن",
      totalTrees: "إجمالي الأشجار",
      certificate: "شهادة"
    },
    transparency: {
      title: "الشفافية",
      subtitle: "كل دولار يُحسب. كل نفقة قابلة للتحقق.",
      summary: "ملخص",
      totalDonated: "إجمالي التبرعات",
      totalSpent: "إجمالي المصروفات",
      balance: "الرصيد",
      donations: "التبرعات",
      expenses: "النفقات",
      recentDonations: "التبرعات الأخيرة",
      recentExpenses: "النفقات الأخيرة",
      category: "الفئة",
      amount: "المبلغ",
      date: "التاريخ",
      receipt: "الإيصال",
      viewReceipt: "عرض الإيصال",
      categories: {
        seedlings: "شتلات",
        labor: "عمالة",
        tools: "أدوات",
        transport: "نقل",
        admin: "إدارة"
      }
    },
    admin: {
      title: "لوحة الإدارة",
      stats: "إحصائيات",
      trees: "أشجار",
      batches: "دفعات",
      importTrees: "استيراد أشجار",
      createBatch: "إنشاء دفعة",
      addExpense: "إضافة مصروف",
      uploadPhoto: "رفع صورة"
    },
    donate: {
      phasesAndMilestones: "المراحل والإنجازات",
      equipmentAndInfrastructure: "المعدات والبنية التحتية",
      totalEquipmentCost: "التكلفة الإجمالية للمعدات",
      priority: "أولوية",
      phase: "مرحلة",
      ofGoal: "من",
      active: "نشط",
      pending: "قيد الانتظار",
      future: "مستقبلي",
      complete: "مكتمل"
    },
    common: {
      loading: "جارٍ التحميل...",
      error: "خطأ",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      view: "عرض",
      close: "إغلاق",
      back: "رجوع",
      next: "التالي",
      search: "بحث",
      filter: "تصفية",
      all: "الكل",
      available: "متاح",
      unavailable: "غير متاح",
      viewMore: "عرض المزيد",
      learnMore: "اعرف المزيد",
      targetArea: "المساحة المستهدفة",
      annualTarget: "الهدف السنوي",
      duration: "المدة",
      operations: "العمليات",
      vesselLength: "طول السفينة",
      pumpCapacity: "سعة المضخة",
      crew: "سعة الطاقم",
      propulsion: "الدفع",
      fullTimeWorkers: "عمال بدوام كامل",
      monthlyPerWorker: "شهرياً لكل عامل",
      months: "أشهر",
      totalSalaries: "إجمالي الرواتب",
      chainsaws: "مناشير",
      safetyEquipment: "معدات السلامة",
      quantity: "الكمية",
      costPerUnit: "التكلفة لكل وحدة",
      units: "وحدات",
      total: "المجموع",
      manualDepiningCost: "تكلفة إزالة الصنوبر اليدوية",
      totalManualProgram: "إجمالي البرنامج اليدوي",
      socialEnvironmentalImpact: "الأثر الاجتماعي والبيئي",
      transparency: "الشفافية",
      thisPlanWill: "هذه الخطة ستحقق:",
      allWorkWillBe: "كل العمل سيكون:",
      everyContributionSupports: "كل مساهمة تدعم:"
    },
    footer: {
      tagline: "استعادة باتاغونيا، شجرة واحدة في كل مرة.",
      copyright: "© {year} إيبويين ريناسر. جميع الحقوق محفوظة."
    }
  },

  // JAPANESE
  ja: {
    nav: {
      home: "ホーム",
      map: "地図",
      adopt: "養子縁組",
      myForest: "私の森",
      transparency: "透明性",
      admin: "管理",
      login: "ログイン",
      logout: "ログアウト",
      more: "もっと見る",
      community: "コミュニティ",
      education: "教育",
      governance: "透明性",
      vision: "私たちのビジョン"
    },
    vision: {
      badge: "私たちのビジョン",
      title: "私たちのビジョン",
      opening: "私たちのビジョンは、透明性、構造、そして集団行動を通じて、生態学的に破壊された場所を再建することが可能であることを世界に示すことです。",
      whatWeAre: {
        title: "エプジェン・リナセルとは",
        description: "エプジェン・リナセルは、火災後の再生モデルを作成するために存在します：盲目的な信頼ではなく、検証可能なデータによって土地の回復、生態系の修復、コミュニティの発展が推進されるシステムです。"
      },
      transparency: {
        title: "ブロックチェーンの透明性",
        description: "ブロックチェーン技術を透明性のレイヤーとして使用することで、すべての貢献、すべての支出、すべての行動を公開で追跡できます。投機のためではなく、復旧活動がどのように資金提供され実行されるかについての信頼を回復するためです。"
      },
      belief: {
        title: "私たちの信念",
        description: "透明性が腐敗に取って代わり、構造が即興に取って代わるとき、コミュニティは再び立ち上がることができると信じています—完全な環境損失の後でさえも。"
      },
      goal: {
        title: "私たちの目標",
        description: "私たちの目標は、エプジェンを復元するだけでなく、生態学的回復のための新しい経済モデルが可能であることを証明することです—世界中の火災の影響を受けた地域で複製できるモデルです。"
      },
      closing: {
        line1: "灰から、システムは再建できます。",
        line2: "破壊から、未来は設計できます。"
      }
    },
    landing: {
      heroTitle: "エプジェンと共に再生",
      heroSubtitle: "木を養子縁組。パタゴニアを復元。",
      heroCta: "木を養子縁組する",
      heroExplore: "地図を探索",
      viewRoadmap: "ロードマップを見る",
      missionTitle: "私たちの使命",
      missionText: "コミュニティの森林再生と徹底した透明性技術により、アルゼンチン・パタゴニアの原生林を復元します。",
      restoringPatagonia: "復元する",
      patagonia: "パタゴニア",
      howItWorksTitle: "仕組み",
      simpleProcess: "シンプルなプロセス",
      step1Title: "地図を探索",
      step1Text: "インタラクティブな地図をナビゲートし、養子縁組可能な木を選択します。",
      step2Title: "木を養子縁組",
      step2Text: "寄付を行い、木のGPS座標付きのユニークなトークンを受け取ります。",
      step3Title: "成長を追跡",
      step3Text: "木の写真と進捗状況の更新を受け取ります。",
      impactTitle: "私たちの影響",
      treesPlanted: "植樹された木",
      treesAdopted: "養子縁組された木",
      donorsCount: "寄付者",
      co2Offset: "CO₂相殺トン",
      transparencyTitle: "完全な透明性",
      transparencyText: "すべての寄付と支出は公開で検証可能です。秘密なし、結果のみ。",
      viewTransparency: "公開記録を見る",
      footerTagline: "パタゴニアを復元、一本の木から。",
      whatHappened: {
        title: "エプジェンで何が起きたのか？",
        year: "2025年と2026年、エプジェンは史上最悪の山火事に見舞われました。",
        hectares: "9,000ヘクタール以上のアンデス原生林が破壊されました。",
        ecosystems: "生態系全体が燃えました。",
        homes: "家々が失われました。",
        wildlife: "野生動物が消えました。",
        landExposed: "土地は露出し、乾燥し、脆弱になりました。",
        balanceBroken: "火災は木を消費しただけでなく、水、土壌、気候を保護する自然のバランスを壊しました。森林被覆がなければ、降雨量は減少し、浸食は増加し、将来の火災リスクはさらに大きくなります。",
        minimalEfforts: "災害の規模にもかかわらず、復旧努力は最小限でした。包括的な生態学的復元計画も、長期的な予防戦略も、構造的な再建プログラムもありませんでした。",
        peopleStayed: "エプジェンの人々は留まりました。守り、抵抗し、再び始めるために。",
        todayScars: "今日、土地はまだ傷跡を残しています—しかし、再生の可能性も秘めています。",
        epuyenCreated: "エプジェン・リナセルは、悲劇を構造に変えるために設立されました：原生林を復元し、火災リスクを減らし、生態学的バランスを再構築し、これが二度と起こらないようにするためです。",
        fromAshes: "灰から偶然は生まれない：未来は意図、真実、そしてコミュニティで築かれる。"
      },
      coreChallenges: {
        title: "核心的な課題",
        mainChallenge: "エプジェンの主な課題は松の除去です — 景観を占領した侵入松種の大規模な除去です。",
        effectiveMethod: "現場での経験とテストを通じて、最も効果的な方法を特定しました：松を現場で粉砕し、有機物を除去したり燃やしたりするのではなく、土壌を再生させることです。",
        processRestores: "このプロセスは湿度を回復し、土壌構造を改善し、原生林の回復に即座の条件を作り出します。",
        parallelReplanting: "同時に、再植林も並行して始まります。除去と再生は一緒に行われなければなりません — 何年も離れてではなく — 侵食と侵入種による再植民を防ぐために。",
        secondMission: "私たちの第二の主要な使命は、火災予防と将来のリスク削減です。",
        moreThanPlanting: "これは木を植える以上のことを必要とします。困難な地形で作業し、火災の脅威に迅速に対応できる専門機器の取得を含む、恒久的な運用能力が求められます。",
        foundationInvest: "これを達成するために、財団は以下に投資する必要があります：",
        investList: {
          machinery: "林業および粉砕機械",
          equipment: "地形にアクセス可能な機器",
          tools: "燃料負荷削減とメンテナンスのためのツール",
          infrastructure: "長期予防インフラ"
        },
        withoutEquipment: "この機器がなければ、再生は脆弱なままであり、破壊のサイクルが繰り返されます。",
        breakCycle: "エプジェン・リナセルは、そのサイクルを断ち切るために存在します — 土地を復元し、火災リスクを減らし、将来のための恒久的な予防システムを構築することによって。"
      },
      donationCategories: {
        title: "寄付カテゴリー",
        subtitle: "あなたの貢献をどのように使用するかを正確に選択できます",
        cta: {
          supportMission: "このミッションを支援する",
          ctaDescription: "すべての寄付は機器の取得とこれらのフェーズの完了に直接使われます。すべての支出は写真、領収書、GPSデータとともに公開で記録されます。",
          donateToCategory: "このカテゴリーに寄付する",
          viewTransparency: "透明性記録を見る"
        },
        category1: {
          icon: "🟫",
          title: "松除去と山火事予防",
          description: "侵入性の松を除去し、極端な火災リスクを軽減し、エプジェンに残る原生林を保護するための5年間の積極的な予防プログラム。",
          supports: "あなたの寄付は、恒久的な山火事予防インフラ、地元雇用、長期的な生態系の安定を支援します。",
          items: [
            "侵入性松の除去",
            "燃料負荷の軽減",
            "原生林の保護"
          ],
          method: "機械的および手動松除去の統合戦略",
          impact: "山火事の強度の直接的な軽減と渓谷の長期的な保護",
          fiveYearPlan: {
            title: "5年間の積極的松除去計画",
            objective: "継続的な予防作業を通じて、エプジェン渓谷全体の山火事リスクを劇的に軽減する。",
            targetArea: "約4,500ヘクタールの侵入性松（枯死および生存）。",
            annualTarget: "年間約900ヘクタールを処理。",
            duration: "5年間の継続運営。",
            operations: "機械と手動クルーを組み合わせた通年の現場作業。",
            phases: {
              year1: {
                title: "緊急安定化",
                description: "住宅、アクセスルート、重要インフラ付近の高リスクゾーンへの即時介入。"
              },
              year2: {
                title: "拡大フェーズ",
                description: "松が優勢な広大なエリアへの作業拡大と恒久的な予防回廊の確立。"
              },
              year3: {
                title: "渓谷深部への介入",
                description: "渓谷内部ゾーンの処理と混合林エリアでの手動松除去の強化。"
              },
              year4: {
                title: "維持管理と再成長抑制",
                description: "再成長を防ぎ、長期的な耐火性を強化するための二次介入。"
              },
              year5: {
                title: "安定化と移行",
                description: "最終的なリスク軽減、生態学的モニタリング、長期維持管理への移行。"
              }
            },
            equipment: {
              title: "必要な林業機器",
              totalCost: "300万〜580万ドル（一回限りの投資）",
              highVolumeMulchers: "密集した松エリア用の高容量林業粉砕機。",
              accessMulchers: "斜面やアクセス制限地形用のコンパクト粉砕機。",
              excavators: "グラップルと保護装置付き林業用ショベル。",
              dozer: "防火帯とアクセス維持用のドーザー。",
              loader: "物流と材料ハンドリング用のホイールローダー。",
              transport: "輸送トラックとサービス車両。"
            },
            capex: {
              title: "設備投資（CAPEX）",
              total: "恒久的な予防能力を創出するために一度購入する機械とインフラ。"
            },
            strategic: {
              title: "戦略的価値",
              establishes: "この投資はエプジェンに恒久的な山火事予防能力を確立します。",
              items: [
                "長期的な燃料負荷軽減",
                "迅速対応予防能力",
                "緊急消火コストの削減",
                "将来の火災に対する領土的回復力"
              ],
              note: "このインフラは数十年にわたって利用可能です。"
            },
            twoMethods: {
              intro: "松除去は単一の方法では達成できません。",
              approach: "計画は生態学的条件に基づいて2つの補完的なアプローチを統合します。",
              mechanical: {
                title: "機械的松除去",
                description: "侵入性松に完全に支配されたエリアで使用。",
                items: [
                  "高速燃料削減",
                  "広域処理",
                  "復元準備"
                ],
                note: "原生林が存在しない場所にのみ適用。"
              },
              manual: {
                title: "手動/外科的松除去",
                description: "原生林が残っている場所での選択的な松除去。",
                zones: [
                  "松と原生林の混合林",
                  "再生ゾーン",
                  "水路",
                  "住宅バッファーエリア"
                ],
                method: "訓練されたクルーとチェーンソーによる一本一本の除去。",
                note: "生態学的損害を防ぐために不可欠。"
              }
            },
            employment: {
              title: "地元雇用プログラム",
              intro: "手動松除去は安定した長期雇用を創出します。",
              priority: "エプジェンと周辺コミュニティの住民を優先採用。",
              equipmentItems: [
                "プロ仕様のチェーンソー",
                "安全装備",
                "メンテナンスツール"
              ],
              manualCostCategories: [
                "給与",
                "ツールと機器",
                "運用安全"
              ]
            },
            conclusion: "この5年計画は、山火事予防を緊急対応から恒久的な領土保護へと変革します。",
            costExplanation: {
              title: "コスト説明",
              intro: "効果的な予防には継続的な長期投資が必要です。",
              requirement: "短期的な行動では火災サイクルを断ち切るには不十分です。",
              integration: "計画は機械、労働力、メンテナンス、モニタリングを統合します。",
              mechanical: {
                title: "機械的松除去コスト",
                description: "重機により大規模介入が可能になります。",
                capability: "松が優勢な高リスクゾーンの迅速な処理を可能にします。",
                includes: "機械関連のすべての作業をカバー。",
                items: [
                  "林業粉砕機",
                  "ショベルとドーザー",
                  "輸送物流",
                  "燃料",
                  "メンテナンス",
                  "スペアパーツ",
                  "現場作業"
                ],
                oneTimeInvestment: "一回限りの投資",
                oneTimeRange: "300万〜580万ドル",
                operationalCost: "運営コスト（5年間）",
                operationalRange: "610万〜1,070万ドル",
                note: "恒久的な予防インフラを創出。"
              },
              manual: {
                title: "手動松除去コスト",
                description: "機械が安全に使用できない場所で必要。",
                limitation: "重機は原生林を損傷します。",
                requirement: "選択的な人的介入が不可欠。",
                whereApplied: "敏感な生態学的ゾーンに適用。",
                zones: [
                  "混合林",
                  "河岸エリア",
                  "住宅付近",
                  "再生ゾーン",
                  "高生態価値エリア"
                ],
                includes: "労働力と機器をカバー。",
                items: [
                  "50人のフルタイム労働者",
                  "プロ仕様チェーンソー",
                  "保護具",
                  "ツールとメンテナンス",
                  "運用安全"
                ],
                workers: "50人の労働者",
                salary: "月額1,000ドル",
                duration: "5年間",
                totalCost: "総コスト",
                totalAmount: "312.5万ドル"
              },
              totalCost: {
                title: "5年間予防総コスト",
                componentHeader: "コンポーネント",
                costHeader: "コスト",
                components: [
                  { category: "機械投資", cost: "300万〜580万ドル" },
                  { category: "機械運用（5年間）", cost: "610万〜1,070万ドル" },
                  { category: "手動松除去（5年間）", cost: "312.5万ドル" }
                ],
                total: "プログラム総コスト",
                totalRange: "1,220万〜1,960万ドル"
              },
              delivers: {
                title: "この計画が提供するもの",
                intro: "5年間で、プログラムは以下を提供します：",
                items: [
                  "山火事リスクの大幅な軽減",
                  "燃料負荷の除去",
                  "原生林の保護",
                  "土壌と水分の回復",
                  "恒久的な予防回廊",
                  "地元雇用の安定",
                  "将来の緊急コストの削減",
                  "長期的な生態学的回復力"
                ],
                notEmergency: "これは緊急対応ではありません。",
                structural: "これは構造的な山火事予防です。"
              },
              whyFiveYears: {
                title: "なぜ5年間？",
                intro: "生態系は数ヶ月では安定しません。",
                allows: "5年間の期間により以下が可能になります：",
                items: [
                  "主要な侵入性松の除去",
                  "再成長の防止",
                  "土壌の安定化",
                  "自然再生の支援",
                  "長期的なリスク軽減"
                ],
                conclusion: "短い期間では火災サイクルを断ち切ることができません。"
              },
              transparency: {
                title: "透明性",
                intro: "すべての資金は公開で追跡可能です。",
                items: [
                  "地理的に特定された作業ゾーン",
                  "処理ヘクタールの報告",
                  "月次更新",
                  "視覚的ドキュメント",
                  "公開透明性ダッシュボード"
                ],
                conclusion: "すべての寄付は検証可能です。"
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "エプジェン湖消防ボートシステム",
          description: "このカテゴリーは、迅速な展開と大容量ポンプが可能な恒久的な水上消防ユニットを確立します。",
          supports: "寄付は以下を支援します：",
          items: [
            "専門消防船",
            "産業用大容量ポンプシステム",
            "ホースシステムとリール",
            "電気/ハイブリッド推進",
            "安全装置と消防機器"
          ],
          objective: "目標はエプジェン湖を受動的な要素から能動的な消防防御資産に変えることです。",
          impact: "このカテゴリーは数分以内の対応能力で命、森林、インフラを保護します。",
          boatSystem: {
            title: "エプジェン湖消防ボートシステム",
            subtitle: "水上迅速消防対応ユニット",
            objective: "迅速な展開、大容量水ポンプ、地上部隊支援が可能な恒久的消防ボートユニットを確立し、エプジェン湖を受動的要素から能動的消防防御資産に変革します。",
            vesselLength: "9-12メートル",
            pumpCapacity: "4,000-8,000 L/分",
            crew: "消防士6-10名",
            propulsion: "電気/ハイブリッド",
            challengesTitle: "なぜ水上対応なのか？",
            challengesIntro: "エプジェンの地形は3つの主要な課題を生み出します：",
            challenges: [
              "急峻な森林斜面",
              "限られた道路アクセス",
              "強い渓谷風"
            ],
            solutionStatement: "水上対応は3つすべてを解決します。",
            capabilitiesTitle: "ボートは：",
            capabilities: [
              "トラックより早く火災前線に到達",
              "湖から無制限の水をポンプ",
              "道路が封鎖されても運用可能",
              "斜面の下から火災を攻撃",
              "対応時間を60-80%短縮"
            ],
            capex: {
              title: "総投資（CAPEX）",
              total: "総投資額",
              argentinaLanded: {
                title: "アルゼンチン着地コスト（輸入＋物流）",
                learnMore: "詳細を見る",
                learnLess: "詳細を隠す",
                intro: "国際的な「基準価格」はアルゼンチンの実際のコストではありません。輸入税、付加価値税、通関、港湾取扱い、パタゴニアへの内陸輸送、遅延、スペアパーツのインフレにより、重機は大幅に高くなります。",
                points: [
                  "一般的な輸入オーバーヘッドは、機器の種類と輸入経路に応じて+40%から+90%を追加できます。",
                  "NGO免除は後で存在する可能性がありますが、法的登録前には保証されません。潜在的な利点として扱い、仮定としては扱いません。",
                  "パタゴニアへの内陸輸送と港の遅延は相当なコストを追加します。",
                  "アルゼンチンではスペアパーツは高価で遅い — 10-15%の準備バッファを含みます（稼働時間に重要）。"
                ],
                costBreakdown: {
                  title: "現実的なコスト概要",
                  baseMachinery: "基本機械（国際価格）",
                  baseRange: "~300万-580万ドル",
                  importTaxes: "輸入/税金/物流（アルゼンチン）",
                  importRange: "+240万-280万ドル",
                  spareParts: "スペアパーツ/準備バッファ（10-15%）",
                  spareRange: "+70万-100万ドル",
                  totalLanded: "アルゼンチンでの推定実際着地CAPEX",
                  totalRange: "750万-820万ドル"
                },
                disclaimer: "すべての予算はアルゼンチンの現実的な着地コスト（税金、パタゴニアへの物流、準備）を反映しています。将来の免除はコストを削減し、処理ヘクタールを増加させます。"
              }
            },
            soilComparison: {
              title: "原生林の土壌 vs 松林の土壌",
              subtitle: "なぜ火災は松林でより速く広がるのか",
              intro: "違いは木だけではありません。違いはその下の土壌システム全体にあります。",
              native: {
                title: "原生林の土壌",
                species: "コイウエ、レンガ、ニーレ、ラダル",
                description: "パタゴニアの原生林は以下を作り出します：",
                characteristics: [
                  "高い有機的多様性",
                  "深い腐植層",
                  "菌類ネットワーク（菌根）",
                  "継続的な水分保持",
                  "スポンジ状の構造",
                  "ゆっくりとした分解",
                  "高い微生物活性"
                ],
                moisture: "25-45%",
                moistureLabel: "典型的な土壌水分",
                moistureNote: "夏でも。",
                fireBehavior: {
                  title: "火災の挙動：",
                  points: [
                    "炎は低く留まる",
                    "火はゆっくり広がる",
                    "しばしば自然に消える",
                    "連続的ではなくパッチ状に燃える",
                    "樹冠に達しにくい"
                  ]
                },
                spreadSpeed: "毎分0.1-0.5メートル",
                spreadNote: "夜間に止まることが多い。"
              },
              pine: {
                title: "松林の土壌",
                warning: "松は土壌を根本的に変えます。",
                characteristics: [
                  "酸性のリター（pH 3.5-4.5）",
                  "樹脂を含んだ針葉",
                  "貧弱な微生物多様性",
                  "ほぼ菌類共生がない",
                  "圧縮された鉱物土壌",
                  "撥水性（水をはじく）",
                  "急速な乾燥"
                ],
                moisture: "5-12%",
                moistureLabel: "典型的な土壌水分",
                moistureNote: "湖の近くでも。",
                fireBehavior: {
                  title: "火災の挙動：",
                  points: [
                    "容易に着火",
                    "火は連続的に移動",
                    "炎は垂直に上昇",
                    "強烈な放射熱",
                    "樹冠が急速に着火"
                  ]
                },
                spreadSpeed: "毎分5-20メートル",
                spreadWind: "毎分40-60メートル",
                spreadWindLabel: "風がある場合：",
                spreadComparison: "100倍速い。"
              },
              publicQuote: "松は燃えるだけではなく — より速く燃えるように土壌を再設計します。",
              quoteNote: "これは誇張ではありません — これは物理学です。",
              whyWorks: {
                title: "除松が効く理由",
                intro: "松を除去すると：",
                benefits: [
                  "土壌水分が上昇",
                  "菌類が回復",
                  "燃料の連続性が断たれる",
                  "炎の高さが低下",
                  "火災の広がりが遅くなる",
                  "在来種が戻れるようになる"
                ],
                conclusion: "だから予防は効果があります。"
              },
              fireLadders: {
                title: "松火災が速く移動する理由",
                intro: "松は同時に3つの火災はしごを作るため：",
                ladder1: {
                  title: "樹脂針葉（地上燃料）",
                  points: ["非常に可燃性", "着火温度 ≈ 260°C", "原生林の落葉は ≈ 450-500°Cで着火", "ほぼ2倍の差"]
                },
                ladder2: {
                  title: "垂直はしご燃料",
                  points: ["地面から樹冠までの枝", "火は簡単に登る", "原生樹は自然に自己剪定"]
                },
                ladder3: {
                  title: "樹冠の連続性",
                  points: ["松の樹冠は均一", "火は樹冠から樹冠へ飛ぶ", "原生林は不規則で途切れている"]
                }
              },
              comparisonTable: {
                title: "定量比較",
                headers: ["要因", "原生林", "松林"],
                rows: [
                  ["土壌水分", "25-45%", "5-12%"],
                  ["落葉着火温度", "450-500°C", "260-300°C"],
                  ["火災拡散速度", "0.1-0.5 m/分", "5-60 m/分"],
                  ["樹冠火災確率", "非常に低い", "極めて高い"],
                  ["自然消火", "よくある", "まれ"],
                  ["火災後の土壌回復", "速い", "非常に遅い"],
                  ["浸食リスク", "低い", "極端"]
                ]
              },
              intensity: {
                title: "火災強度比較",
                label: "火災強度（kW/m）：",
                native: "500-2,000 kW/m",
                pine: "20,000-60,000 kW/m",
                comparison: "10-30倍のエネルギー。",
                warning: "消防士は近づけません。"
              },
              waterCycle: {
                title: "水循環の違い（重要）",
                native: {
                  title: "原生林の土壌：",
                  points: ["雨を吸収", "水を貯蔵", "ゆっくり水分を放出", "微気候を冷却"]
                },
                pine: {
                  title: "松林の土壌：",
                  points: ["雨をはじく", "流出が増加", "すぐに乾燥", "熱を増加"]
                },
                conclusion: "これは暑く、乾燥し、風の強い微気候を作ります。火はそれを糧とします。"
              },
              feedback: {
                title: "松林で火災が「爆発」する理由",
                intro: "松システムは：",
                points: ["より速く乾燥", "より早く着火", "より熱く燃焼", "より速く拡散", "連続的に燃焼", "その後さらに松を再生"],
                conclusion: "フィードバックループです。"
              },
              summary: {
                title: "簡単な言葉での要約",
                native: "原生林 = 湿ったスポンジ",
                pine: "松林 = ガソリンカーペット",
                note: "これは誇張ではありません — これは物理学です。"
              }
            },
            strategic: {
              title: "戦略的価値",
              establishes: "このシステムは以下を創出します：",
              items: [
                "恒久的な水上消防能力",
                "数分以内の迅速対応能力",
                "より低い消火コスト",
                "火災拡大確率の低減",
                "住宅、森林、水源の保護"
              ],
              note: "エプジェン湖を受動的要素から能動的消防防御資産に変換します。"
            },
            conclusion: "エプジェン湖の専用消防ボートは、山火事予防と対応における最も効率的な投資の1つです。湖を最前線の防御システムに変え、火災が災害になる前に渓谷を保護します。"
          }
        },
        category3: {
          icon: "🌱",
          title: "再植林と将来の保全",
          description: "このカテゴリーはエプジェンの長期的な生態学的回復を支援します。",
          supports: "寄付は以下に使用されます：",
          items: [
            "原生樹の植林",
            "苗床開発",
            "土壌再生",
            "長期メンテナンス",
            "生物多様性の回復",
            "再生地域の監視と保護"
          ],
          impact: "これにより、回復した森林が生き残り、成熟し、将来の世代のために保護されることが保証されます。"
        },
        category4: {
          icon: "♻️",
          title: "廃棄物管理と汚染",
          description: "現地観察とコミュニティ対話を通じて、エプジェンが重大な露天廃棄物と汚染の課題に直面していることを確認しました。",
          supports: "現在の焦点:",
          items: [
            "既存の廃棄物フローの理解",
            "汚染リスクの特定",
            "露天投棄ゾーンのマッピング",
            "環境と健康への影響の調査",
            "類似の農村コミュニティの実行可能なモデルのレビュー"
          ],
          objective: "目標は解決策を押し付けることではなく、エプジェンの規模と地理に適した現実的で持続可能な解決策を構築することです。",
          impact: "汚染への対処は、水源の保護、生態系の回復、コミュニティの健康な未来の確保に不可欠です。",
          researchPhase: {
            title: "廃棄物管理と汚染",
            currentPhase: "調査・診断フェーズ",
            context: "現地観察とコミュニティ対話を通じて、エプジェンが土壌、水、公衆衛生に長期的なリスクをもたらす非公式投棄エリアを含む、重大な露天廃棄物と汚染の課題に直面していることを確認しました。",
            statement: "この問題は即興や孤立した行動では対処できません。",
            focusTitle: "現在の焦点領域:",
            focusAreas: [
              "既存の廃棄物フローの理解",
              "汚染リスクの特定",
              "露天投棄ゾーンのマッピング",
              "環境と健康への影響の調査",
              "類似の農村・山岳コミュニティで使用されている実行可能なモデルのレビュー"
            ],
            requirement: "廃棄物管理には技術的正確さ、規制調整、長期計画が必要です。",
            ethos: "私たちの理念の一環として、適切な調査なしに解決策を発表することはありません。",
            commitment: "この評価フェーズが完了したら、Epuyén Renaceはコミュニティレビューと制度的対話に開かれた、明確で公開的で透明な廃棄物管理提案を公開します。",
            objective: "目標は解決策を押し付けることではなく、エプジェンの規模と地理に適した現実的で持続可能な解決策を構築することです。",
            importance: "汚染への対処は、水源の保護、生態系の回復、コミュニティの健康な未来の確保に不可欠です。"
          }
        },
        transparency: {
          title: "カテゴリー別透明性",
          description: "各寄付カテゴリーには：",
          items: [
            "専用予算",
            "公開進捗追跡",
            "文書化された支出",
            "写真、GPSデータ、レポート",
            "ブロックチェーンベースの透明性記録"
          ],
          verify: "寄付者は貢献がどのように使用されるかを正確に選択し、各段階でその影響を確認できます。"
        },
        oneSystem: {
          title: "1つのシステム、5つのミッション",
          depining: "松除去はリスクを減らします。",
          firefighting: "消火は緊急時に保護します。",
          reforestation: "再植林は命を回復します。",
          contamination: "廃棄物管理は水と健康を保護します。",
          biosphere: "生物圏公園は持続可能な未来を構築します。",
          together: "これらは一緒に、エプジェンの完全で恒久的な火災後回復モデルを形成します — 組織、技術、そして本当のコミットメントがあれば、場所は再び立ち上がることができることを証明しています。"
        }
      }
    },
    roadmap: {
      title: "ロードマップ",
      subtitle: "土地を再生し、エプジェンに未来を与える長期システム。政治や慈善ではなく、検証可能な行動。",
      thePlan: "計画",
      active: "アクティブ",
      upcoming: "次回",
      comingSoon: "近日公開",
      rAndD: "研究開発",
      vision: "ビジョン",
      future: "将来",
      goal: "目標",
      raised: "調達済み",
      totalGoal: "総目標",
      treesAdopted: "養子縁組された木",
      projectPhases: "プロジェクトフェーズ",
      progress: "進捗",
      everyContribution: "すべての貢献が私たちを目標に近づけます",
      phase0: {
        title: "財団 + デジタル透明性",
        description: "エプジェン・リナセル財団を設立、ウェブサイト+公開ロードマップを開始、ドローン/LiDARデジタルマップを設定、ゾーン、KPI、コストモデル、ブロックチェーンシステムを定義。",
        tags: ["ウェブサイト", "3Dマップ", "ブロックチェーン", "法的財団"],
        status: "初期設定"
      },
      phase1: {
        title: "植林スプリント",
        description: "10,000本の在来樹を植樹。各木は約25ドルで、GPS、写真、ステータスタイムライン、公開記録で追跡されます。",
        tags: ["10,000本の木", "GPS追跡", "写真", "公開記録"],
        treesAdopted: "本養子縁組済み",
        available: "本利用可能"
      },
      phase2: {
        title: "リスク削減 + 拡大",
        description: "5,000本の侵略的な松を除去、20,000本の在来樹を植樹、2台のチッパーを取得して松をマルチに処理し、火災負荷を軽減。",
        tags: ["5,000本の松除去", "20,000本の在来樹", "2台のチッパー"],
        proof: "証拠を公開：除去ログ+植樹バッチ+領収書"
      },
      phase3: {
        title: "パタゴニア消防イノベーション",
        description: "独自のハイブリッド消防システムを設計・構築：水/ボート能力+ドローン+地上対応。目標：遠隔地での早期検出+迅速な封じ込め。",
        tags: ["ドローン", "ハイブリッド車両", "早期検出", "オープンR&D"],
        milestones: "明確なマイルストーン、プロトタイプ、公開レポート"
      },
      phase4: {
        title: "33HA公共生物圏公園",
        description: "33ヘクタールを購入し、エプジェン・リナセル財団が所有。公共の生物圏公園として設計：生物多様性回復ゾーン、侵入種教育、再生食品生産デモ、加工センター、カフェテリア、湖畔レストラン+桟橋、教育センター。",
        tags: ["33ヘクタール", "教育センター", "湖レストラン", "桟橋", "地元生産"],
        purpose: "永久保護+雇用+教育+持続可能な地域経済"
      },
      phase5: {
        title: "フルSaaSプラットフォーム",
        description: "エプジェンがデジタルツインに。ドローン/LiDAR測量マップ：木を数えて登録、1本=1トークン/証明書、インタラクティブな養子縁組マーケットプレイス、オンチェーン+オフチェーン透明性ダッシュボード、ボランティア/コミュニティモジュール、レポートと監査ツール。",
        tags: ["デジタルツイン", "LiDAR", "NFTトークン", "オンチェーン", "監査"],
        scalable: "他の保全プロジェクト向けのスケーラブルモデル"
      },
      summary: {
        foundation: "財団",
        trees10k: "1万本",
        expansion: "拡大",
        fireFighting: "消防",
        park33ha: "33HA公園",
        platform: "プラットフォーム"
      }
    },
    education: {
      title: "森について学ぶ",
      subtitle: "知識は力です。生態系を理解することが、それを守る第一歩です。",
      badge: "環境教育",
      nativeForest: {
        title: "パタゴニアの原生林",
        subtitle: "私たちが保護している種を知る",
        lenga: {
          title: "レンガ (Nothofagus pumilio)",
          description: "30メートルに達することができる落葉樹。秋には葉が赤と金色に変わり、壮観な景観を作り出します。"
        },
        coihue: {
          title: "コイウエ (Nothofagus dombeyi)",
          description: "500年以上生きることができる常緑種。数十種の鳥類と哺乳類に避難所と食料を提供します。"
        },
        cipres: {
          title: "コルディリェラ・サイプレス",
          description: "1000年以上の樹齢に達することができる在来針葉樹。パタゴニアの気候に耐性があり適応しています。"
        }
      },
      invasiveSpecies: {
        title: "侵入種",
        subtitle: "松の問題とその他の脅威",
        pine: {
          title: "侵略的な松",
          description: "商業林業のために導入された松は、積極的に広がり、原生林を追い出します。土壌を酸性化し、生物多様性を減少させ、火災リスクを劇的に増加させます。",
          impact: "高"
        },
        rosehip: {
          title: "ローズヒップ",
          description: "食用の果実を生産しますが、このヨーロッパの種は急速に広がり、在来植生と資源を競合します。",
          impact: "中"
        },
        broom: {
          title: "エニシダ",
          description: "非常に燃えやすい低木で、劣化した地域に定着し、原生林の再生を困難にします。",
          impact: "高"
        }
      },
      fireRisk: {
        title: "火災リスク",
        subtitle: "脅威を理解し予防する",
        whyPinesDangerous: {
          title: "なぜ松は危険なのか？",
          description: "松には非常に燃えやすい樹脂が含まれています。松林は原生林の10倍の速さで燃えることがあります。"
        },
        nativeForestRole: {
          title: "原生林の役割",
          description: "レンガのような在来樹は水分含有量が高く、樹脂が少ないです。健康な原生林は自然の防火帯として機能します。"
        },
        communityPrevention: {
          title: "コミュニティ予防",
          description: "松の除去、防火帯の作成、早期検出システムが基本です。植えられた各在来樹がリスク軽減に貢献します。"
        }
      },
      biodiversity: {
        title: "生物多様性",
        subtitle: "森に依存する生命",
        fauna: {
          title: "象徴的な動物相",
          description: "ウエムル（絶滅危惧種のパタゴニア鹿）、プドゥ（世界最小の鹿）、ピューマ、数十種の鳥類が原生林に依存しています。"
        },
        lifeNetwork: {
          title: "生命のネットワーク",
          description: "各在来樹は菌類、地衣類、昆虫、鳥類、哺乳類のネットワークを支えています。この生物多様性は松の植林地には存在しません。"
        },
        corridors: {
          title: "生物学的回廊",
          description: "森を復元することで、動物が移動し、つがいを見つけ、健康な個体群を維持できる回廊を作ります。"
        }
      },
      waterCycle: {
        mainTitle: "森がどのように雨をもたらし、水を守るか",
        howRainWorks: "雨の仕組み",
        whyForests: "そしてなぜ森は自然の水システムのようなのか",
        intro1: "地球が生きた体であると想像してください。",
        intro2: "森は単なる木ではありません — 水が動き、休み、戻るのを助ける器官です。",
        letsSeee: "どのように機能するか見てみましょう 👇",
        whereRainComes: {
          title: "雨はどこから来るのか？",
          content: "太陽が地球を暖めると：\n• 湖や川が空気中に水を放出します\n• 木が葉を通して水を放出します\n\nこの水は目に見えない蒸気になり、空に上昇します。\n\n十分な蒸気が集まると、雲が生まれます。\n\n雲が重くなると — 🌧️ 雨が降ります。\n\n**木は雲を作るのを助けます。**\n\n木がなければ、雲は少なくなります。"
        },
        treesBreathe: {
          title: "木は水を空に呼吸する",
          content: "木は根で土から水を飲みます。\n\nそして葉を通してその水の一部を放出します。\n\nこれは**蒸散**と呼ばれますが、こう考えることができます：\n\n*木は空気中に水を呼吸します。*\n\n何百万本もの木が一緒に呼吸すると：\n• 湿度\n• より涼しい空気\n• 雨の可能性が増える\n\nだから森は自分の天気を作ります。"
        },
        whenRainFalls: {
          title: "雨が降ると何が起きるか？",
          content: "健康な森に雨が降ると：\n• 葉が雨を遅くする\n• 根が土を開く\n• 水が優しく地下に入る\n\n土はスポンジのようになります。\n\nこの水は蓄えられ、何ヶ月もかけてゆっくりと放出されます。\n\nこの水は以下を養います：\n• 泉\n• 小川\n• 湖\n• 動物\n• 人々\n\nだから森は**水の守護者**と呼ばれます。"
        },
        forestsGiveMemory: {
          title: "森は水に記憶を与える",
          content: "森は水が留まるのを助けます。\n\nすべての雨を一度に逃がしません。\n\n**森は水を覚えています。**\n\nこれは*水の記憶*と呼ばれます。\n\n森のおかげで：\n• 湖はすぐに干上がらない\n• 川は夏でも流れる\n• 井戸は消えない\n\n森がなければ、水は忘れます。"
        },
        whenForestsBurn: {
          title: "森が燃えると何が起きるか？",
          content: "森が燃えると：\n• 土が硬くなる\n• 水が地面に入れない\n• 雨が素早く流れ去る\n• 洪水が起きる\n• その後、長い乾期が続く\n\n火災の後、よく見られるのは：\n• 一度に多すぎる水\n• その後、十分な水がない\n\n**これは湖にとって非常に危険です。**"
        },
        canValleyHelp: {
          title: "谷は他の谷を助けることができるか？",
          content: "近くの谷の森が湿気や雲をもたらすのを助けることがあります。\n\nこれは少し助けになります。\n\nしかし、水は山を通って地下を遠くまで移動できません。\n\nつまり：\n\n**すべての谷は自分の森を守らなければなりません。**\n\n雨は空から来ることができますが —\n水は土地によって守られなければなりません。"
        },
        whyNativeSpecial: {
          title: "なぜ原生林は特別なのか",
          content: "原生林は：\n• ここで自然に育った\n• 土を守る\n• 水が地面に入るのを許す\n• 火に強い\n• 災害後に生命が戻るのを助ける\n\n土地と共に働きます。\n\n**ここに属しています。**"
        },
        forestsNotDecoration: {
          title: "森は装飾ではない",
          content: "森は美しいだけではありません。\n\n森は：\n• **水の創造者**\n• **水の守護者**\n• **気候の保護者**\n• **生命の維持者**\n\n森がなければ：\n• 湖が弱くなる\n• 雨が不規則になる\n• 土地が乾く\n• 火災リスクが高まる"
        },
        simpleTruth: {
          title: "シンプルな真実",
          noForest: "森がなければ = 水の未来はない",
          withForests: "しかし森があれば：",
          rainReturns: "雨が戻る",
          springsRecover: "泉が回復する",
          lakesSurvive: "湖が生き残る",
          lifeContinues: "生命が続く",
          protectForests: "森を守るとき、私たちは明日を守ります。",
          cta: "今すぐ木を守る"
        }
      },
      resources: {
        title: "追加リソース",
        subtitle: "知識を深めるための資料",
        viewResource: "リソースを見る",
        guide: {
          title: "原生種ガイド",
          type: "PDF",
          description: "パタゴニアの原生樹の識別と特徴"
        },
        documentary: {
          title: "ドキュメンタリー：危機に瀕する森",
          type: "ビデオ",
          description: "パタゴニアの森の歴史と現在の課題"
        },
        map: {
          title: "プロジェクトインタラクティブマップ",
          type: "インタラクティブ",
          description: "植林エリアを探索し、進捗を監視"
        }
      },
      cta: {
        title: "行動する準備はできましたか？",
        description: "知識は行動に変わったときに意味を持ちます。養子縁組するすべての木が、このユニークな生態系の復元に貢献します。",
        adoptTree: "木を養子縁組する",
        exploreMap: "地図を探索"
      }
    },
    governance: {
      title: "私たちの統治方法",
      subtitle: "盲目的な信頼なし。不透明な仲介者なし。すべての決定が検証可能で、すべてのドルが追跡可能なシステム。",
      badge: "ガバナンス",
      principles: {
        title: "ガバナンス原則",
        subtitle: "すべての決定を導く柱",
        radicalTransparency: {
          title: "徹底的な透明性",
          description: "入ってくるすべてのドルと出ていくすべてのドルは公開されます。すべての決定は文書化されます。例外なし。"
        },
        communityParticipation: {
          title: "コミュニティ参加",
          description: "寄付者と地域コミュニティは、重要なプロジェクト決定に発言権を持っています。"
        },
        protectedFunds: {
          title: "保護された資金",
          description: "資金移動にはマルチ署名が必要です。個人単独で行動することはできません。"
        },
        accountability: {
          title: "説明責任",
          description: "定期的な監査、四半期ごとの公開レポート、独立した検証。"
        }
      },
      treasury: {
        title: "資金配分",
        subtitle: "寄付されたすべてのドルの配分方法",
        badge: "財務",
        viewPublicRecord: "公開支出記録を見る",
        directPlanting: {
          category: "直接植樹",
          percentage: 60,
          description: "苗木、労働力、道具"
        },
        maintenance: {
          category: "メンテナンス",
          percentage: 20,
          description: "灌漑、監視、交換"
        },
        operations: {
          category: "運営",
          percentage: 15,
          description: "技術、物流、コミュニケーション"
        },
        reserve: {
          category: "予備",
          percentage: 5,
          description: "緊急事態と不測の事態"
        }
      },
      multiSig: {
        title: "マルチ署名",
        subtitle: "一人で一方的に資金を動かすことはできません",
        badge: "セキュリティ",
        requirement: "資金移動の承認には最低2/3の署名が必要です。すべての取引は公開され検証可能です。",
        requiredLabel: "必須",
        foundation: {
          name: "エプジェン財団",
          role: "主任管理者",
          required: true
        },
        council: {
          name: "コミュニティ協議会",
          role: "地域代表",
          required: true
        },
        auditor: {
          name: "外部監査人",
          role: "独立検証者",
          required: false
        }
      },
      governanceRoadmap: {
        title: "ガバナンスロードマップ",
        subtitle: "ますます分散化されたガバナンスへ",
        badge: "進化",
        currentPhase: {
          phase: "現在のフェーズ",
          title: "設立",
          status: "active",
          items: [
            "資金の完全な透明性",
            "月次公開レポート",
            "GPSと写真による植樹検証",
            "すべての支出の公開記録"
          ]
        },
        v1Phase: {
          phase: "V1（近日公開）",
          title: "参加",
          status: "upcoming",
          items: [
            "寄付者向け投票システム",
            "コミュニティ提案",
            "植樹エリアの選択",
            "プロジェクトの優先順位付け"
          ]
        },
        v2Phase: {
          phase: "V2（将来）",
          title: "分散化",
          status: "future",
          items: [
            "財務のためのオンチェーンマルチ署名",
            "寄付者向けガバナンスNFT",
            "コミュニティDAO",
            "自動オンチェーン監査"
          ]
        }
      },
      cta: {
        title: "ガバナンスに参加する",
        description: "寄付者として、プロジェクトの決定に参加する権利があります。この森を作る上であなたの声は重要です。",
        adoptTree: "木を養子縁組する",
        viewTransparency: "透明性を見る"
      }
    },
    community: {
      title: "エプジェンの声",
      subtitle: "森の未来を築く人々に会う",
      badge: "私たちのコミュニティ",
      featuredVoices: {
        title: "注目の声",
        subtitle: "再生を可能にする人々の物語",
        person1: {
          name: "マリア・デル・カルメン",
          role: "地元の苗木栽培者",
          quote: "私が育てるすべての苗木には心の一部が込められています。世界の誰かがそれを養子縁組し、成長を追跡するとわかると、希望で満たされます。",
          location: "エプジェン、チュブト"
        },
        person2: {
          name: "ロベルト・ウエヌル",
          role: "コミュニティの森林管理者",
          quote: "祖父は森の読み方を教えてくれました。今日、私は他の人々に森を守る方法を教えています。この技術は、私たちが行っていることを世界に示すのに役立っています。",
          location: "ラゴ・プエロ"
        },
        person3: {
          name: "ラウラ・セプルベダ",
          role: "生物学者",
          quote: "科学とコミュニティが一緒になれば、どちらか単独では達成できないことを達成できます。このプロジェクトは、透明性が信頼を生むことを示しています。",
          location: "エル・ボルソン"
        },
        person4: {
          name: "マルティン・クルフインカ",
          role: "マプチェコミュニティ",
          quote: "土地は私たちのものではありません。私たちが土地のものです。それを大切にすることは、私たちの先祖から受け継いだ責任であり、今やグローバルな責任でもあります。",
          location: "クシャメン"
        },
        person5: {
          name: "ソフィア・マリナオ",
          role: "地方の教師",
          quote: "私の生徒たちは木を植えることで森について学んでいます。彼らの熱意を見ると、未来が良い手にあることを確信します。",
          location: "エプジェン"
        },
        person6: {
          name: "ディエゴ・フェルナンデス",
          role: "森林消防士",
          quote: "すべての火災は私の魂を砕きます。だから私は予防を支持しています：より多くの原生林、より少ない松、より少ないリスク。",
          location: "チョリラ"
        }
      },
      documentary: {
        title: "ドキュメンタリー：森の声",
        description: "パタゴニアの保護に人生を捧げる人々の物語を通じた視覚的な旅。",
        comingSoon: "近日公開",
        watchTrailer: "予告編を見る"
      },
      events: {
        title: "今後のイベント",
        subtitle: "コミュニティに参加する",
        event1: {
          title: "コミュニティ植樹",
          date: "2025年3月15日",
          location: "エプジェン苗圃",
          description: "ボランティアに開放された植樹日"
        },
        event2: {
          title: "モニタリングワークショップ",
          date: "2025年4月22日",
          location: "コミュニティセンター",
          description: "GPSで木をモニタリングする方法を学ぶ"
        },
        event3: {
          title: "年次総会",
          date: "2025年5月10日",
          location: "バーチャル＋対面",
          description: "達成事項のレビューと2025年の計画"
        }
      },
      shareStory: {
        title: "共有する物語がありますか？",
        description: "エプジェンコミュニティの一員であるか、木を養子縁組した場合は、あなたの話を聞かせてください。",
        cta: "私の話を共有"
      }
    },
    map: {
      title: "プロジェクトマップ",
      viewMap: "マップを見る",
      satellite: "衛星",
      terrain: "地図",
      trees: "木",
      legend: "凡例",
      planned: "計画済み",
      planted: "植樹済み",
      adopted: "養子縁組済み",
      controls: "コントロール",
      loading: "3Dマップを読み込み中..."
    },
    tree: {
      details: "木の詳細",
      species: "種",
      status: "状態",
      coordinates: "座標",
      planted: "植樹済み",
      adopted: "養子縁組済み",
      adoptedBy: "養子縁組者",
      plantingDate: "植樹日",
      photos: "写真",
      adoptThisTree: "この木を養子縁組",
      viewCertificate: "証明書を見る",
      statuses: {
        planned: "計画済み",
        planted: "植樹済み",
        maintained: "メンテナンス中",
        dead: "枯死",
        replaced: "交換済み"
      }
    },
    adopt: {
      title: "木を養子縁組する",
      subtitle: "あなたの寄付がパタゴニアの森の復元を助けます",
      selectPackage: "パッケージを選択",
      sapling: "苗木",
      youngTree: "若い木",
      matureTree: "成熟した木",
      donorName: "寄付者名",
      donorNamePlaceholder: "あなたの名前（オプション）",
      anonymous: "匿名",
      proceedToPayment: "支払いに進む",
      processing: "処理中...",
      successTitle: "ご寄付ありがとうございます！",
      successMessage: "あなたの木が割り当てられました。証明書を確認してください。",
      viewMyCertificate: "私の証明書を見る",
      securePayment: "Stripeによる安全な支払い"
    },
    myForest: {
      title: "私の森",
      subtitle: "あなたの養子縁組した木",
      noTrees: "まだ木を養子縁組していません。",
      adoptNow: "今すぐ養子縁組",
      totalTrees: "合計の木",
      certificate: "証明書"
    },
    transparency: {
      title: "透明性",
      subtitle: "すべてのドルがカウントされます。すべての支出は検証可能です。",
      summary: "概要",
      totalDonated: "寄付総額",
      totalSpent: "支出総額",
      balance: "残高",
      donations: "寄付",
      expenses: "支出",
      recentDonations: "最近の寄付",
      recentExpenses: "最近の支出",
      category: "カテゴリ",
      amount: "金額",
      date: "日付",
      receipt: "領収書",
      viewReceipt: "領収書を見る",
      categories: {
        seedlings: "苗木",
        labor: "労働",
        tools: "道具",
        transport: "輸送",
        admin: "管理"
      }
    },
    admin: {
      title: "管理ダッシュボード",
      stats: "統計",
      trees: "木",
      batches: "バッチ",
      importTrees: "木をインポート",
      createBatch: "バッチを作成",
      addExpense: "支出を追加",
      uploadPhoto: "写真をアップロード"
    },
    donate: {
      phasesAndMilestones: "フェーズとマイルストーン",
      equipmentAndInfrastructure: "設備とインフラ",
      totalEquipmentCost: "設備総費用",
      priority: "優先",
      phase: "フェーズ",
      ofGoal: "目標の",
      active: "進行中",
      pending: "保留中",
      future: "将来",
      complete: "完了"
    },
    common: {
      loading: "読み込み中...",
      error: "エラー",
      save: "保存",
      cancel: "キャンセル",
      delete: "削除",
      edit: "編集",
      view: "表示",
      close: "閉じる",
      back: "戻る",
      next: "次へ",
      search: "検索",
      filter: "フィルター",
      all: "すべて",
      available: "利用可能",
      unavailable: "利用不可",
      viewMore: "もっと見る",
      learnMore: "詳細を見る",
      targetArea: "目標面積",
      annualTarget: "年間目標",
      duration: "期間",
      operations: "運営",
      vesselLength: "船体長",
      pumpCapacity: "ポンプ容量",
      crew: "乗組員定員",
      propulsion: "推進システム",
      fullTimeWorkers: "フルタイム労働者",
      monthlyPerWorker: "労働者あたり月額",
      months: "ヶ月",
      totalSalaries: "給与総額",
      chainsaws: "チェーンソー",
      safetyEquipment: "安全装備",
      quantity: "数量",
      costPerUnit: "単価",
      units: "台",
      total: "合計",
      manualDepiningCost: "手動松除去コスト",
      totalManualProgram: "手動プログラム合計",
      socialEnvironmentalImpact: "社会・環境への影響",
      transparency: "透明性",
      thisPlanWill: "この計画は：",
      allWorkWillBe: "すべての作業は：",
      everyContributionSupports: "すべての寄付が支援します："
    },
    footer: {
      tagline: "パタゴニアを復元、一本の木ずつ。",
      copyright: "© {year} エプジェン・リナセル。全著作権所有。"
    }
  },
  // Portuguese (Brazilian)
  pt: {
    nav: {
      home: "Início",
      map: "Mapa",
      adopt: "Adotar",
      myForest: "Minha Floresta",
      transparency: "Transparência",
      admin: "Admin",
      login: "Entrar",
      logout: "Sair",
      more: "Mais",
      community: "Comunidade",
      education: "Educação",
      governance: "Transparência",
      vision: "Nossa Visão"
    },
    vision: {
      badge: "Nossa Visão",
      title: "Nossa Visão",
      opening: "Nossa visão é demonstrar ao mundo que é possível reconstruir um lugar que foi ecologicamente destruído — através de transparência, estrutura e ação coletiva.",
      whatWeAre: {
        title: "O que é Epuyén Renace",
        description: "Epuyén Renace existe para criar um modelo de regeneração pós-incêndio: um sistema onde a recuperação de terras, restauração ecológica e desenvolvimento comunitário são impulsionados por dados verificáveis em vez de confiança cega."
      },
      transparency: {
        title: "Transparência Blockchain",
        description: "Ao usar tecnologia blockchain como camada de transparência, cada contribuição, cada despesa e cada ação pode ser rastreada publicamente. Não para especular — mas para restaurar a confiança em como os esforços de recuperação são financiados e executados."
      },
      belief: {
        title: "O Que Acreditamos",
        description: "Acreditamos que quando a transparência substitui a corrupção e a estrutura substitui a improvisação, as comunidades podem se reerguer — mesmo após perda ambiental total."
      },
      goal: {
        title: "Nossa Meta",
        description: "Nosso objetivo não é apenas restaurar Epuyén, mas provar que um novo modelo econômico para recuperação ecológica é possível — um que pode ser replicado em regiões afetadas por incêndios em todo o mundo."
      },
      closing: {
        line1: "Das cinzas, um sistema pode ser reconstruído.",
        line2: "Da destruição, um futuro pode ser projetado."
      }
    },
    landing: {
      heroTitle: "Renasça com Epuyén",
      heroSubtitle: "Adote uma árvore. Restaure a Patagônia.",
      heroCta: "Adotar uma Árvore",
      heroExplore: "Explorar o Mapa",
      viewRoadmap: "Ver o Roteiro",
      missionTitle: "Nossa Missão",
      missionText: "Restaurar as florestas nativas da Patagônia Argentina através do reflorestamento comunitário e tecnologia de transparência radical.",
      restoringPatagonia: "Restaurando a",
      patagonia: "Patagônia",
      howItWorksTitle: "Como Funciona",
      simpleProcess: "Processo Simples",
      step1Title: "Explore o Mapa",
      step1Text: "Navegue pelo nosso mapa interativo e selecione uma árvore disponível para adotar.",
      step2Title: "Adote sua Árvore",
      step2Text: "Faça sua doação e receba um token único com as coordenadas GPS da sua árvore.",
      step3Title: "Acompanhe seu Crescimento",
      step3Text: "Receba atualizações com fotos e acompanhamento do progresso da sua árvore.",
      impactTitle: "Nosso Impacto",
      treesPlanted: "Árvores Plantadas",
      treesAdopted: "Árvores Adotadas",
      donorsCount: "Doadores",
      co2Offset: "Tons CO₂ Compensadas",
      transparencyTitle: "Transparência Total",
      transparencyText: "Cada doação e despesa é verificável publicamente. Sem segredos, apenas resultados.",
      viewTransparency: "Ver Registro Público",
      footerTagline: "Restaurando a Patagônia, uma árvore de cada vez.",
      whatHappened: {
        title: "O que Aconteceu com Epuyén?",
        year: "Em 2025 e 2026, Epuyén foi atingida pelos piores incêndios florestais de sua história.",
        hectares: "Mais de 9.000 hectares de floresta nativa andina foram destruídos.",
        ecosystems: "Ecossistemas inteiros queimaram.",
        homes: "Casas foram perdidas.",
        wildlife: "A vida selvagem desapareceu.",
        landExposed: "A terra ficou exposta, seca e vulnerável.",
        balanceBroken: "Os incêndios não apenas consumiram árvores — eles quebraram o equilíbrio natural que protege a água, o solo e o clima. Sem cobertura florestal, as chuvas diminuem, a erosão aumenta e o risco de futuros incêndios se torna ainda maior.",
        minimalEfforts: "Apesar da escala do desastre, os esforços de recuperação foram mínimos. Não houve plano abrangente de restauração ecológica, nem estratégia de prevenção a longo prazo, nem programa de reconstrução estrutural.",
        peopleStayed: "O povo de Epuyén ficou. Ficou para cuidar, resistir e recomeçar.",
        todayScars: "Hoje, a terra ainda carrega as cicatrizes — mas também a possibilidade de regeneração.",
        epuyenCreated: "Epuyén Renace foi criado para transformar a tragédia em estrutura: restaurar florestas nativas, reduzir o risco de incêndios, reconstruir o equilíbrio ecológico e garantir que isso nunca aconteça novamente.",
        fromAshes: "Das cinzas não surge o acaso: o futuro é construído com intenção, verdade e comunidade."
      },
      coreChallenges: {
        title: "Os Desafios Principais",
        mainChallenge: "O principal desafio em Epuyén é o despinamento — a remoção em grande escala de espécies de pinheiros invasores que tomaram conta da paisagem.",
        effectiveMethod: "Através de experiência de campo e testes, identificamos o método mais eficaz: triturar o pinheiro no local, permitindo que o material orgânico regenere o solo em vez de removê-lo ou queimá-lo.",
        processRestores: "Este processo restaura a umidade, melhora a estrutura do solo e cria condições imediatas para a recuperação da floresta nativa.",
        parallelReplanting: "Ao mesmo tempo, o replantio começa em paralelo. Remoção e regeneração devem acontecer juntas — não anos depois — para prevenir erosão e recolonização por espécies invasoras.",
        secondMission: "Nossa segunda missão principal é a prevenção de incêndios e redução de riscos futuros.",
        moreThanPlanting: "Isso requer mais do que plantar árvores. Exige capacidade operacional permanente, incluindo a aquisição de equipamentos especializados capazes de trabalhar em terrenos difíceis e responder rapidamente a ameaças de incêndio.",
        foundationInvest: "Para alcançar isso, a fundação deve investir em:",
        investList: {
          machinery: "Maquinário florestal e de trituração",
          equipment: "Equipamentos acessíveis ao terreno",
          tools: "Ferramentas para redução de carga de combustível e manutenção",
          infrastructure: "Infraestrutura de prevenção a longo prazo"
        },
        withoutEquipment: "Sem este equipamento, a regeneração permanece frágil e o ciclo de destruição se repete.",
        breakCycle: "Epuyén Renace existe para quebrar esse ciclo — restaurando a terra, reduzindo o risco de incêndios e construindo um sistema permanente de prevenção para o futuro."
      },
      donationCategories: {
        title: "Categorias de Doação",
        subtitle: "Escolha exatamente como você quer que sua contribuição seja usada",
        cta: {
          supportMission: "Apoie Esta Missão",
          ctaDescription: "Cada doação vai diretamente para a aquisição de equipamentos e conclusão destas fases. Todas as despesas são documentadas publicamente com fotos, recibos e dados GPS.",
          donateToCategory: "Doar para Esta Categoria",
          viewTransparency: "Ver Registros de Transparência"
        },
        category1: {
          icon: "🟫",
          title: "Despinamento e Prevenção de Incêndios",
          description: "Um programa de prevenção agressivo de cinco anos para remover espécies de pinheiros invasores, reduzir o risco extremo de incêndio e proteger a floresta nativa remanescente de Epuyén.",
          supports: "Sua contribuição apoia infraestrutura permanente de prevenção de incêndios, emprego local e estabilidade ecológica de longo prazo.",
          items: [
            "Remoção de pinheiro invasor",
            "Redução de carga de combustível",
            "Proteção da floresta nativa"
          ],
          method: "Estratégia integrada de despinamento mecânico e manual",
          impact: "Redução direta da intensidade de incêndios florestais e proteção de longo prazo do vale",
          fiveYearPlan: {
            title: "Plano Agressivo de Despinamento de Cinco Anos",
            objective: "Reduzir drasticamente o risco de incêndios florestais em todo o vale de Epuyén através de trabalho contínuo de prevenção.",
            targetArea: "Aproximadamente 4.500 hectares de pinheiro invasor (morto e vivo).",
            annualTarget: "Cerca de 900 hectares tratados por ano.",
            duration: "5 anos de operação contínua.",
            operations: "Operações de campo durante todo o ano combinando maquinário e equipes manuais.",
            phases: {
              year1: {
                title: "Estabilização de Emergência",
                description: "Intervenção imediata em zonas de alto risco perto de residências, rotas de acesso e infraestrutura crítica."
              },
              year2: {
                title: "Fase de Expansão",
                description: "Escalonamento de operações em áreas maiores dominadas por pinheiros e estabelecimento de corredores de prevenção permanentes."
              },
              year3: {
                title: "Intervenção no Interior do Vale",
                description: "Tratamento de zonas internas do vale e consolidação do despinamento manual em áreas de floresta mista."
              },
              year4: {
                title: "Manutenção e Controle de Recrescimento",
                description: "Intervenções de segunda passagem para prevenir recrescimento e reforçar a resistência ao fogo de longo prazo."
              },
              year5: {
                title: "Estabilização e Transição",
                description: "Redução final de risco, monitoramento ecológico e transição para manutenção de longo prazo."
              }
            },
            equipment: {
              title: "Equipamento Florestal Necessário",
              totalCost: "USD 3,0 – 5,8 milhões (investimento único)",
              highVolumeMulchers: "Trituradores florestais de alta capacidade para áreas de pinheiros densos.",
              accessMulchers: "Trituradores compactos para encostas e terrenos de acesso limitado.",
              excavators: "Escavadeiras florestais com garras e proteção.",
              dozer: "Trator para aceiros e manutenção de acessos.",
              loader: "Carregadeira para logística e manuseio de materiais.",
              transport: "Caminhões de transporte e veículos de serviço."
            },
            capex: {
              title: "Investimento de Capital (CAPEX)",
              total: "Maquinário e infraestrutura adquiridos uma vez para criar capacidade permanente de prevenção.",
              argentinaLanded: {
                title: "Custo Entregue na Argentina (Importação + Logística)",
                learnMore: "Saiba mais",
                learnLess: "Ocultar detalhes",
                intro: "O \"preço base\" internacional não é o custo real na Argentina. Máquinas florestais pesadas custam significativamente mais devido a impostos de importação, IVA, desembaraço aduaneiro, manuseio portuário, transporte terrestre até a Patagônia, atrasos e inflação de peças de reposição.",
                points: [
                  "Custos típicos de importação podem adicionar +40% a +90% dependendo do tipo de equipamento e via de importação.",
                  "Isenções para ONGs podem existir posteriormente, mas não são garantidas antes do registro legal. Tratamos como potencial benefício, não como pressuposto.",
                  "Transporte terrestre até a Patagônia e atrasos portuários adicionam custo significativo.",
                  "Peças de reposição são caras e lentas na Argentina — incluímos uma reserva de prontidão de 10-15% (crítico para tempo de atividade)."
                ],
                costBreakdown: {
                  title: "Resumo de Custos Realistas",
                  baseMachinery: "Maquinário base (preço internacional)",
                  baseRange: "~USD 3,0-5,8M",
                  importTaxes: "Importação/impostos/logística (Argentina)",
                  importRange: "+USD 2,4-2,8M",
                  spareParts: "Peças de reposição/reserva de prontidão (10-15%)",
                  spareRange: "+USD 0,7-1,0M",
                  totalLanded: "CAPEX real estimado entregue na Argentina",
                  totalRange: "USD 7,5-8,2M"
                },
                disclaimer: "Todos os orçamentos refletem custos reais entregues na Argentina (impostos, logística até a Patagônia, prontidão). Quaisquer isenções futuras reduzem custos e aumentam hectares tratados."
              }
            },
            soilComparison: {
              title: "Solo de Floresta Nativa vs Solo de Plantação de Pinheiros",
              subtitle: "Por que o fogo se espalha muito mais rápido em florestas de pinheiros",
              intro: "A diferença não é apenas a árvore. A diferença é todo o sistema do solo abaixo.",
              native: {
                title: "Solo de Floresta Nativa",
                species: "coihue, lenga, ñire, radal",
                description: "Florestas nativas da Patagônia criam:",
                characteristics: [
                  "Alta diversidade orgânica",
                  "Camada profunda de húmus",
                  "Redes de fungos (micorrizas)",
                  "Retenção constante de umidade",
                  "Estrutura esponjosa",
                  "Decomposição lenta",
                  "Alta atividade microbiana"
                ],
                moisture: "25-45%",
                moistureLabel: "Umidade típica do solo",
                moistureNote: "Mesmo no verão.",
                fireBehavior: {
                  title: "Comportamento do fogo:",
                  points: [
                    "Chamas permanecem baixas",
                    "Fogo se espalha lentamente",
                    "Frequentemente se auto-extingue",
                    "Queima em manchas, não contínuo",
                    "Difícil de atingir a copa"
                  ]
                },
                spreadSpeed: "0,1-0,5 metros por minuto",
                spreadNote: "Frequentemente para à noite."
              },
              pine: {
                title: "Solo de Plantação de Pinheiros",
                warning: "Pinheiros alteram radicalmente o solo.",
                characteristics: [
                  "Serrapilheira ácida (pH 3,5-4,5)",
                  "Agulhas saturadas de resina",
                  "Baixa diversidade microbiana",
                  "Quase nenhuma simbiose de fungos",
                  "Solo mineral compactado",
                  "Hidrofóbico (repele água)",
                  "Secagem rápida"
                ],
                moisture: "5-12%",
                moistureLabel: "Umidade típica do solo",
                moistureNote: "Mesmo perto de lagos.",
                fireBehavior: {
                  title: "Comportamento do fogo:",
                  points: [
                    "Ignita facilmente",
                    "Fogo viaja continuamente",
                    "Chamas sobem verticalmente",
                    "Calor radiante intenso",
                    "Copas ignizam rapidamente"
                  ]
                },
                spreadSpeed: "5-20 metros por minuto",
                spreadWind: "40-60 metros por minuto",
                spreadWindLabel: "Com vento:",
                spreadComparison: "100× mais rápido."
              },
              publicQuote: "Pinheiros não apenas queimam — eles redesenham o solo para queimar mais rápido.",
              quoteNote: "Isso não é exagero — isso é física.",
              whyWorks: {
                title: "Por que a remoção de pinheiros funciona",
                intro: "Remover pinheiros:",
                benefits: [
                  "Aumenta a umidade do solo",
                  "Restaura fungos",
                  "Quebra a continuidade do combustível",
                  "Reduz a altura das chamas",
                  "Retarda a propagação do fogo",
                  "Permite que espécies nativas retornem"
                ],
                conclusion: "É por isso que a prevenção funciona."
              }
            },
            strategic: {
              title: "Valor Estratégico",
              establishes: "Este investimento estabelece capacidade permanente de prevenção de incêndios para Epuyén.",
              items: [
                "Redução de carga de combustível de longo prazo",
                "Capacidade de prevenção de resposta rápida",
                "Redução de custos de combate a incêndios de emergência",
                "Resiliência territorial contra incêndios futuros"
              ],
              note: "Esta infraestrutura permanece disponível por décadas."
            },
            twoMethods: {
              intro: "O despinamento não pode ser alcançado através de um único método.",
              approach: "O plano integra duas abordagens complementares baseadas em condições ecológicas.",
              mechanical: {
                title: "Despinamento Mecânico",
                description: "Usado em áreas totalmente dominadas por pinheiro invasor.",
                items: [
                  "Redução de combustível em alta velocidade",
                  "Tratamento de grandes áreas",
                  "Preparação para restauração"
                ],
                note: "Aplicado apenas onde a floresta nativa está ausente."
              },
              manual: {
                title: "Despinamento Manual / Cirúrgico",
                description: "Remoção seletiva de pinheiro onde a floresta nativa permanece.",
                zones: [
                  "Floresta mista pinheiro-nativa",
                  "Zonas de regeneração",
                  "Cursos d'água",
                  "Áreas tampão residenciais"
                ],
                method: "Remoção árvore por árvore usando equipes treinadas e motosserras.",
                note: "Essencial para prevenir danos ecológicos."
              }
            },
            employment: {
              title: "Programa de Emprego Local",
              intro: "O despinamento manual cria emprego estável de longo prazo.",
              priority: "Contratação prioritária para residentes de Epuyén e comunidades vizinhas.",
              equipmentItems: [
                "Motosserras profissionais",
                "Equipamento de segurança",
                "Ferramentas de manutenção"
              ],
              manualCostCategories: [
                "Salários",
                "Ferramentas e equipamentos",
                "Segurança operacional"
              ]
            },
            conclusion: "Este plano de cinco anos transforma a prevenção de incêndios de reação de emergência em proteção territorial permanente.",
            costExplanation: {
              title: "Explicação de Custos",
              intro: "A prevenção eficaz requer investimento contínuo de longo prazo.",
              requirement: "Ações de curto prazo são insuficientes para quebrar o ciclo de incêndios.",
              integration: "O plano integra maquinário, mão de obra, manutenção e monitoramento.",
              mechanical: {
                title: "Custos de Despinamento Mecânico",
                description: "O maquinário pesado permite intervenção em grande escala.",
                capability: "Permite tratamento rápido de zonas de alto risco dominadas por pinheiros.",
                includes: "Cobre todas as operações relacionadas a maquinário.",
                items: [
                  "Trituradores florestais",
                  "Escavadeiras e tratores",
                  "Logística de transporte",
                  "Combustível",
                  "Manutenção",
                  "Peças de reposição",
                  "Operações de campo"
                ],
                oneTimeInvestment: "Investimento único",
                oneTimeRange: "USD 3,0 – 5,8 milhões",
                operationalCost: "Custo operacional (5 anos)",
                operationalRange: "USD 6,1 – 10,7 milhões",
                note: "Cria infraestrutura de prevenção permanente."
              },
              manual: {
                title: "Custos de Despinamento Manual",
                description: "Necessário onde o maquinário não pode ser usado com segurança.",
                limitation: "O maquinário pesado danificaria a floresta nativa.",
                requirement: "A intervenção humana seletiva é essencial.",
                whereApplied: "Aplicado em zonas ecológicas sensíveis.",
                zones: [
                  "Florestas mistas",
                  "Áreas ribeirinhas",
                  "Perto de residências",
                  "Zonas de regeneração",
                  "Áreas de alto valor ecológico"
                ],
                includes: "Cobre força de trabalho e equipamentos.",
                items: [
                  "50 trabalhadores em tempo integral",
                  "Motosserras profissionais",
                  "Equipamento de proteção",
                  "Ferramentas e manutenção",
                  "Segurança operacional"
                ],
                workers: "50 trabalhadores",
                salary: "USD 1.000 por mês",
                duration: "5 anos",
                totalCost: "Custo total",
                totalAmount: "USD 3,125 milhões"
              },
              totalCost: {
                title: "Custo Total de Prevenção de Cinco Anos",
                componentHeader: "Componente",
                costHeader: "Custo",
                components: [
                  { category: "Investimento em maquinário", cost: "USD 3,0 – 5,8 M" },
                  { category: "Operação de maquinário (5 anos)", cost: "USD 6,1 – 10,7 M" },
                  { category: "Despinamento manual (5 anos)", cost: "USD 3,125 M" }
                ],
                total: "Custo total do programa",
                totalRange: "USD 12,2 – 19,6 milhões"
              },
              delivers: {
                title: "O Que Este Plano Entrega",
                intro: "Ao longo de cinco anos, o programa fornece:",
                items: [
                  "Grande redução do risco de incêndios florestais",
                  "Eliminação de carga de combustível",
                  "Proteção da floresta nativa",
                  "Recuperação do solo e umidade",
                  "Corredores de prevenção permanentes",
                  "Estabilidade de emprego local",
                  "Redução de custos de emergência futuros",
                  "Resiliência ecológica de longo prazo"
                ],
                notEmergency: "Isto não é resposta de emergência.",
                structural: "É prevenção estrutural de incêndios florestais."
              },
              whyFiveYears: {
                title: "Por Que Cinco Anos?",
                intro: "Os ecossistemas não se estabilizam em meses.",
                allows: "Um horizonte de cinco anos permite:",
                items: [
                  "Remoção da massa principal de pinheiro invasor",
                  "Prevenção de recrescimento",
                  "Estabilização do solo",
                  "Suporte à regeneração natural",
                  "Redução de risco de longo prazo"
                ],
                conclusion: "Prazos mais curtos não podem quebrar o ciclo de incêndios."
              },
              transparency: {
                title: "Transparência",
                intro: "Todos os fundos serão publicamente rastreáveis.",
                items: [
                  "Zonas de trabalho geolocalizadas",
                  "Relatório de hectares tratados",
                  "Atualizações mensais",
                  "Documentação visual",
                  "Painel público de transparência"
                ],
                conclusion: "Cada contribuição é verificável."
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "Sistema de Barco de Combate a Incêndios para Lago Epuyén",
          description: "Esta categoria estabelece uma unidade permanente de combate a incêndios baseada em água, capaz de implantação rápida e bombeamento de alta capacidade.",
          supports: "Doações apoiam:",
          items: [
            "embarcação especializada de combate a incêndios",
            "sistema de bomba industrial de alta capacidade",
            "sistemas de mangueiras e bobinas",
            "propulsão elétrica/híbrida",
            "equipamentos de segurança e combate a incêndios"
          ],
          objective: "O objetivo é transformar o Lago Epuyén de um elemento passivo em um ativo de defesa contra incêndios.",
          impact: "Esta categoria protege vidas, florestas e infraestrutura com capacidade de resposta em minutos.",
          boatSystem: {
            title: "Sistema de Barco de Combate a Incêndios para Lago Epuyén",
            subtitle: "Unidade de Resposta Rápida a Incêndios Baseada em Água",
            objective: "Estabelecer uma unidade permanente de barco de combate a incêndios capaz de implantação rápida, bombeamento de água de alta capacidade e apoio a brigadas terrestres — transformando o Lago Epuyén de um elemento passivo em um ativo de defesa contra incêndios.",
            vesselLength: "9-12 metros",
            pumpCapacity: "4.000-8.000 L/min",
            crew: "6-10 bombeiros",
            propulsion: "Elétrico/Híbrido",
            challengesTitle: "Por que Resposta Baseada em Água?",
            challengesIntro: "A geografia de Epuyén cria três desafios principais:",
            challenges: [
              "Encostas florestais íngremes",
              "Acesso rodoviário limitado",
              "Ventos fortes no vale"
            ],
            solutionStatement: "A resposta baseada em água resolve todos os três.",
            capabilitiesTitle: "Um barco pode:",
            capabilities: [
              "Alcançar frentes de incêndio mais rápido que caminhões",
              "Bombear água ilimitada do lago",
              "Operar mesmo quando estradas estão bloqueadas",
              "Atacar incêndios de baixo da encosta",
              "Reduzir tempo de resposta em 60-80%"
            ],
            capex: {
              title: "Investimento Total (CAPEX)",
              total: "Investimento Total"
            },
            strategic: {
              title: "Valor Estratégico",
              establishes: "Este sistema cria:",
              items: [
                "Capacidade permanente de combate a incêndios baseada em água",
                "Capacidade de resposta rápida em minutos",
                "Custos de supressão mais baixos",
                "Redução da probabilidade de propagação de incêndios",
                "Proteção de casas, florestas e fontes de água"
              ],
              note: "Converte o Lago Epuyén de um elemento passivo em um ativo de defesa contra incêndios."
            },
            conclusion: "Um barco de combate a incêndios dedicado no Lago Epuyén representa um dos investimentos mais eficientes em prevenção e resposta a incêndios florestais. Transforma o lago em um sistema de defesa de linha de frente — protegendo o vale antes que os incêndios se tornem desastres."
          }
        },
        category3: {
          icon: "🌱",
          title: "Reflorestamento e Preservação Futura",
          description: "Esta categoria apoia a recuperação ecológica de longo prazo de Epuyén.",
          supports: "Doações são usadas para:",
          items: [
            "plantio de árvores nativas",
            "desenvolvimento de viveiros",
            "regeneração do solo",
            "manutenção a longo prazo",
            "restauração da biodiversidade",
            "monitoramento e proteção de áreas regeneradas"
          ],
          impact: "Isso garante que as florestas restauradas sobrevivam, amadureçam e permaneçam protegidas para as gerações futuras."
        },
        category4: {
          icon: "♻️",
          title: "Gestão de Resíduos e Contaminação",
          description: "Através de observação no terreno e diálogo comunitário, identificamos que Epuyén enfrenta um desafio significativo de resíduos a céu aberto e contaminação.",
          supports: "Atualmente focados em:",
          items: [
            "entender os fluxos de resíduos existentes",
            "identificar riscos de contaminação",
            "mapear zonas de despejo a céu aberto",
            "estudar impactos ambientais e de saúde",
            "revisar modelos viáveis de comunidades rurais semelhantes"
          ],
          objective: "O objetivo não é impor uma solução, mas construir uma que seja realista, sustentável e apropriada para a escala e geografia de Epuyén.",
          impact: "Abordar a contaminação é essencial para proteger fontes de água, restaurar ecossistemas e garantir um futuro saudável para a comunidade.",
          researchPhase: {
            title: "Gestão de Resíduos e Contaminação",
            currentPhase: "Fase de Pesquisa e Diagnóstico",
            context: "Através de observação no terreno e diálogo comunitário, identificamos que Epuyén enfrenta um desafio significativo de resíduos a céu aberto e contaminação, incluindo áreas de despejo informal que representam riscos de longo prazo para o solo, água e saúde pública.",
            statement: "Este problema não pode ser resolvido através de improvisação ou ações isoladas.",
            focusTitle: "Áreas de Foco Atuais:",
            focusAreas: [
              "Entender os fluxos de resíduos existentes",
              "Identificar riscos de contaminação",
              "Mapear zonas de despejo a céu aberto",
              "Estudar impactos ambientais e de saúde",
              "Revisar modelos viáveis usados em comunidades rurais e de montanha semelhantes"
            ],
            requirement: "A gestão de resíduos requer precisão técnica, coordenação regulatória e planejamento de longo prazo.",
            ethos: "Como parte do nosso ethos, nenhuma solução será anunciada sem pesquisa adequada.",
            commitment: "Uma vez concluída esta fase de avaliação, Epuyén Renace publicará uma proposta de gestão de resíduos clara, pública e transparente, aberta para revisão comunitária e diálogo institucional.",
            objective: "O objetivo não é impor uma solução, mas construir uma que seja realista, sustentável e apropriada para a escala e geografia de Epuyén.",
            importance: "Abordar a contaminação é essencial para proteger fontes de água, restaurar ecossistemas e garantir um futuro saudável para a comunidade."
          }
        },
        transparency: {
          title: "Transparência por Categoria",
          description: "Cada categoria de doação tem:",
          items: [
            "um orçamento dedicado",
            "acompanhamento público do progresso",
            "despesas documentadas",
            "fotos, dados GPS e relatórios",
            "registros de transparência baseados em blockchain"
          ],
          verify: "Os doadores podem escolher exatamente como sua contribuição é usada e verificar seu impacto em cada etapa."
        },
        oneSystem: {
          title: "Um Sistema, Cinco Missões",
          depining: "Despinamento reduz o risco.",
          firefighting: "Combate a incêndios protege em emergências.",
          reforestation: "Reflorestamento restaura a vida.",
          contamination: "Gestão de resíduos protege a água e a saúde.",
          biosphere: "O parque da biosfera constrói o futuro sustentável.",
          together: "Juntos, eles formam um modelo completo e permanente de recuperação pós-incêndio para Epuyén — provando que um lugar pode se reerguer quando há organização, tecnologia e compromisso real."
        }
      }
    },
    roadmap: {
      title: "Roteiro",
      subtitle: "Um sistema de longo prazo para regenerar a terra e dar futuro a Epuyén. Não é política nem caridade — é ação verificável.",
      thePlan: "O Plano",
      active: "Ativo",
      upcoming: "Próximo",
      comingSoon: "Em Breve",
      rAndD: "P&D",
      vision: "Visão",
      future: "Futuro",
      goal: "Meta",
      raised: "Arrecadado",
      totalGoal: "Meta Total",
      treesAdopted: "Árvores Adotadas",
      projectPhases: "Fases do Projeto",
      progress: "Progresso",
      everyContribution: "Cada contribuição nos aproxima da meta",
      phase0: {
        title: "Fundação + Transparência Digital",
        description: "Criar a Fundación Epuyén Renace, lançar site + roteiro público, configurar mapa digital com drone/LiDAR, definir zonas, KPIs, modelo de custos e sistema blockchain para rastrear doações e despesas.",
        tags: ["Site", "Mapa 3D", "Blockchain", "Fundação Legal"],
        status: "Configuração Inicial"
      },
      phase1: {
        title: "Sprint de Reflorestamento",
        description: "Plantar 10.000 árvores nativas. Cada árvore custa ~USD $25 e é rastreada com GPS, fotos, cronologia de status e registro público.",
        tags: ["10.000 Árvores", "Rastreamento GPS", "Fotos", "Registro Público"],
        treesAdopted: "árvores adotadas",
        available: "disponíveis"
      },
      phase2: {
        title: "Redução de Risco + Expansão",
        description: "Remover 5.000 pinheiros invasores, plantar 20.000 árvores nativas e adquirir 2 trituradoras para processar pinheiro em cobertura morta e reduzir a carga de combustível.",
        tags: ["5.000 Pinheiros Removidos", "20.000 Nativas", "2 Trituradoras"],
        proof: "Publicar provas: registros de remoção + lotes de plantio + recibos"
      },
      phase3: {
        title: "Inovação Anti-Incêndios Patagônia",
        description: "Projetar e construir um sistema híbrido proprietário de combate a incêndios: capacidade água/barco + drones + resposta terrestre. Meta: detecção precoce + contenção rápida em terreno remoto.",
        tags: ["Drones", "Veículo Híbrido", "Detecção Precoce", "P&D Aberto"],
        milestones: "Marcos claros, protótipos e relatórios públicos"
      },
      phase4: {
        title: "Parque Biosfera Público 33HA",
        description: "Comprar 33 hectares, propriedade da Fundación Epuyén Renace. Projetá-lo como parque biosfera público com: zonas de restauração de biodiversidade, educação sobre espécies invasoras, demonstração de produção regenerativa de alimentos, centro de processamento, cafeteria, restaurante à beira do lago + píeres e centro educacional.",
        tags: ["33 Hectares", "Centro Educacional", "Restaurante Lago", "Píeres", "Produção Local"],
        purpose: "Proteção permanente + empregos + educação + economia local sustentável"
      },
      phase5: {
        title: "Plataforma SaaS Completa",
        description: "Epuyén se torna um gêmeo digital. Mapa com levantamento drone/LiDAR: árvores contadas e registradas, 1 árvore = 1 token/certificado, mercado de adoção interativo, dashboards de transparência on-chain + off-chain, módulos de voluntários/comunidade, relatórios e ferramentas de auditoria.",
        tags: ["Gêmeo Digital", "LiDAR", "Tokens NFT", "On-Chain", "Auditoria"],
        scalable: "Modelo escalável para outros projetos de conservação"
      },
      summary: {
        foundation: "Fundação",
        trees10k: "10K Árvores",
        expansion: "Expansão",
        fireFighting: "Anti-Incêndios",
        park33ha: "Parque 33HA",
        platform: "Plataforma"
      }
    },
    education: {
      title: "Aprenda sobre a Floresta",
      subtitle: "Conhecimento é poder. Entender nosso ecossistema é o primeiro passo para protegê-lo. Aqui você encontrará tudo o que precisa saber sobre a floresta patagônica.",
      badge: "Educação Ambiental",
      nativeForest: {
        title: "A Floresta Nativa Patagônica",
        subtitle: "Conheça as espécies que estamos protegendo",
        lenga: {
          title: "Lenga (Nothofagus pumilio)",
          description: "Árvore decídua que pode atingir 30 metros. Suas folhas ficam vermelhas e douradas no outono, criando paisagens espetaculares. É fundamental para a biodiversidade da floresta andino-patagônica."
        },
        coihue: {
          title: "Coihue (Nothofagus dombeyi)",
          description: "Espécie perene que pode viver mais de 500 anos. Fornece abrigo e alimento para dezenas de espécies de aves e mamíferos. Sua madeira é valiosa, mas seu valor ecológico é incalculável."
        },
        cipres: {
          title: "Cipreste da Cordilheira",
          description: "Conífera nativa que pode ultrapassar 1000 anos de idade. Resistente e adaptada ao clima patagônico, é um símbolo de permanência e resiliência."
        }
      },
      invasiveSpecies: {
        title: "Espécies Invasoras",
        subtitle: "O problema do pinheiro e outras ameaças",
        pine: {
          title: "Pinheiro Invasor",
          description: "Introduzido para silvicultura comercial, o pinheiro se espalha agressivamente, deslocando a floresta nativa. Acidifica o solo, reduz a biodiversidade e aumenta dramaticamente o risco de incêndios.",
          impact: "Alto"
        },
        rosehip: {
          title: "Rosa Mosqueta",
          description: "Embora produza frutos comestíveis, esta espécie europeia se espalha rapidamente e compete com a vegetação nativa por recursos.",
          impact: "Médio"
        },
        broom: {
          title: "Giesta",
          description: "Arbusto altamente inflamável que coloniza áreas degradadas, dificultando a regeneração da floresta nativa.",
          impact: "Alto"
        }
      },
      fireRisk: {
        title: "Risco de Incêndios",
        subtitle: "Entendendo e prevenindo a ameaça",
        whyPinesDangerous: {
          title: "Por que os pinheiros são perigosos?",
          description: "Os pinheiros contêm resinas altamente inflamáveis. Uma floresta de pinheiros pode queimar 10 vezes mais rápido que uma floresta nativa. Além disso, suas copas densas facilitam a propagação do fogo de copa, o mais destrutivo."
        },
        nativeForestRole: {
          title: "O papel da floresta nativa",
          description: "Árvores nativas como a lenga têm maior teor de umidade e menos resinas. Uma floresta nativa saudável atua como um aceiro natural e se recupera melhor após um incêndio."
        },
        communityPrevention: {
          title: "Prevenção comunitária",
          description: "A remoção de pinheiros, a criação de aceiros e os sistemas de detecção precoce são fundamentais. Cada árvore nativa plantada contribui para reduzir o risco."
        }
      },
      biodiversity: {
        title: "Biodiversidade",
        subtitle: "A vida que depende da floresta",
        fauna: {
          title: "Fauna emblemática",
          description: "O huemul (cervo patagônico em perigo de extinção), o pudú (o menor cervo do mundo), o puma e dezenas de espécies de aves dependem da floresta nativa."
        },
        lifeNetwork: {
          title: "Rede de vida",
          description: "Cada árvore nativa sustenta uma rede de fungos, liquens, insetos, aves e mamíferos. Essa biodiversidade não existe em plantações de pinheiros."
        },
        corridors: {
          title: "Corredores biológicos",
          description: "Ao restaurar a floresta, criamos corredores que permitem aos animais se mover, encontrar parceiros e manter populações saudáveis."
        }
      },
      waterCycle: {
        mainTitle: "Como as Florestas Trazem Chuva e Protegem Nossa Água",
        howRainWorks: "Como a Chuva Funciona",
        whyForests: "e Por Que as Florestas São Como o Sistema de Água da Natureza",
        intro1: "Imagine que a terra é um corpo vivo.",
        intro2: "As florestas não são apenas árvores — são os órgãos que ajudam a água a se mover, descansar e retornar.",
        letsSeee: "Vamos ver como funciona 👇",
        whereRainComes: {
          title: "De onde vem a chuva?",
          content: "Quando o sol aquece a Terra:\n• Lagos e rios liberam água no ar\n• Árvores liberam água através de suas folhas\n\nEssa água se torna vapor invisível e sobe para o céu.\n\nQuando vapor suficiente se acumula, nascem as nuvens.\n\nQuando as nuvens ficam pesadas — 🌧️ a chuva cai.\n\n**As árvores ajudam a formar nuvens.**\n\nSem árvores, menos nuvens se formam."
        },
        treesBreathe: {
          title: "Árvores respiram água para o céu",
          content: "As árvores bebem água do solo com suas raízes.\n\nDepois liberam parte dessa água através de suas folhas.\n\nIsso se chama **evapotranspiração**, mas podemos pensar assim:\n\n*As árvores respiram água para o ar.*\n\nMilhões de árvores respirando juntas criam:\n• Umidade\n• Ar mais fresco\n• Mais chances de chuva\n\nÉ por isso que as florestas criam seu próprio clima."
        },
        whenRainFalls: {
          title: "O que acontece quando a chuva cai?",
          content: "Quando a chuva cai sobre uma floresta saudável:\n• As folhas freiam a chuva\n• As raízes abrem o solo\n• A água penetra suavemente no subsolo\n\nO solo se torna uma esponja.\n\nEssa água é armazenada e liberada lentamente por meses.\n\nEssa água alimenta:\n• Nascentes\n• Riachos\n• Lagos\n• Animais\n• Pessoas\n\nÉ por isso que as florestas são chamadas de **guardiãs da água**."
        },
        forestsGiveMemory: {
          title: "As florestas dão memória à água",
          content: "As florestas ajudam a água a ficar.\n\nElas não deixam toda a chuva escapar de uma vez.\n\n**Elas lembram da água.**\n\nIsso se chama *memória da água*.\n\nGraças às florestas:\n• Os lagos não secam rápido\n• Os rios fluem mesmo no verão\n• Os poços não desaparecem\n\nSem florestas, a água esquece."
        },
        whenForestsBurn: {
          title: "O que acontece quando as florestas queimam?",
          content: "Quando uma floresta queima:\n• O solo fica duro\n• A água não consegue entrar na terra\n• A chuva escapa rapidamente\n• Ocorrem inundações\n• Depois seguem longos períodos secos\n\nDepois dos incêndios frequentemente vemos:\n• Muita água de uma vez\n• Depois não há suficiente\n\n**Isso é muito perigoso para os lagos.**"
        },
        canValleyHelp: {
          title: "Um vale pode ajudar outro vale?",
          content: "Às vezes as florestas em vales próximos ajudam a trazer umidade e nuvens.\n\nIsso pode ajudar um pouco.\n\nMas a água não pode viajar longe no subsolo através das montanhas.\n\nIsso significa:\n\n**Cada vale deve proteger sua própria floresta.**\n\nPorque a chuva pode chegar do céu —\nmas a água deve ser guardada pela terra."
        },
        whyNativeSpecial: {
          title: "Por que as florestas nativas são especiais",
          content: "As florestas nativas:\n• Cresceram aqui naturalmente\n• Protegem o solo\n• Permitem que a água entre na terra\n• Resistem melhor ao fogo\n• Ajudam a vida a retornar após desastres\n\nElas trabalham junto com a terra.\n\n**Elas pertencem aqui.**"
        },
        forestsNotDecoration: {
          title: "As florestas não são decoração",
          content: "As florestas não são apenas bonitas.\n\nElas são:\n• **Criadoras de água**\n• **Guardiãs da água**\n• **Protetoras do clima**\n• **Sustentadoras da vida**\n\nSem florestas:\n• Os lagos enfraquecem\n• A chuva fica irregular\n• A terra seca\n• O risco de incêndio cresce"
        },
        simpleTruth: {
          title: "Uma Verdade Simples",
          noForest: "Sem floresta = sem futuro de água",
          withForests: "Mas com florestas:",
          rainReturns: "A chuva retorna",
          springsRecover: "As nascentes se recuperam",
          lakesSurvive: "Os lagos sobrevivem",
          lifeContinues: "A vida continua",
          protectForests: "Quando protegemos as florestas, protegemos o amanhã.",
          cta: "Proteger uma Árvore Agora"
        }
      },
      resources: {
        title: "Recursos Adicionais",
        subtitle: "Material para aprofundar seu conhecimento",
        viewResource: "Ver recurso",
        guide: {
          title: "Guia de Espécies Nativas",
          type: "PDF",
          description: "Identificação e características das árvores nativas da Patagônia"
        },
        documentary: {
          title: "Documentário: Florestas em Perigo",
          type: "Vídeo",
          description: "História da floresta patagônica e os desafios atuais"
        },
        map: {
          title: "Mapa Interativo do Projeto",
          type: "Interativo",
          description: "Explore as zonas de plantio e monitore o progresso"
        }
      },
      cta: {
        title: "Pronto para agir?",
        description: "O conhecimento faz sentido quando se transforma em ação. Cada árvore que você adota contribui para restaurar este ecossistema único."
      }
    },
    governance: {
      title: "Como Governamos",
      subtitle: "Sem confiança cega. Sem intermediários opacos. Um sistema onde cada decisão é verificável e cada real é rastreável.",
      badge: "Governança",
      principles: {
        title: "Princípios de Governança",
        subtitle: "Os pilares que guiam cada decisão",
        radicalTransparency: {
          title: "Transparência Radical",
          description: "Cada real que entra e sai é público. Todas as decisões são documentadas. Sem exceções."
        },
        communityParticipation: {
          title: "Participação Comunitária",
          description: "Os doadores e a comunidade local têm voz nas decisões importantes do projeto."
        },
        protectedFunds: {
          title: "Fundos Protegidos",
          description: "Multi-assinatura requerida para movimentação de fundos. Nenhum indivíduo pode agir sozinho."
        },
        accountability: {
          title: "Prestação de Contas",
          description: "Auditorias regulares, relatórios públicos trimestrais e verificação independente."
        }
      },
      treasury: {
        title: "Distribuição de Fundos",
        subtitle: "Como cada dólar doado é alocado",
        badge: "Tesouraria",
        directPlanting: {
          category: "Plantio Direto",
          percentage: 60,
          description: "Mudas, mão de obra, ferramentas"
        },
        maintenance: {
          category: "Manutenção",
          percentage: 20,
          description: "Irrigação, monitoramento, substituições"
        },
        operations: {
          category: "Operações",
          percentage: 15,
          description: "Tecnologia, logística, comunicação"
        },
        reserve: {
          category: "Reserva",
          percentage: 5,
          description: "Emergências e contingências"
        },
        viewPublicRecord: "Ver Registro Público de Despesas"
      },
      multiSig: {
        title: "Multi-Assinatura",
        subtitle: "Nenhuma pessoa pode movimentar fundos unilateralmente",
        badge: "Segurança",
        foundation: {
          name: "Fundación Epuyén",
          role: "Administrador Principal",
          required: true
        },
        council: {
          name: "Conselho Comunitário",
          role: "Representante Local",
          required: true
        },
        auditor: {
          name: "Auditor Externo",
          role: "Verificador Independente",
          required: false
        },
        requirement: "Mínimo de 2 de 3 assinaturas para aprovar qualquer movimentação de fundos. Todas as transações são públicas e verificáveis.",
        requiredLabel: "Obrigatório"
      },
      governanceRoadmap: {
        title: "Roteiro de Governança",
        subtitle: "Rumo a uma governança cada vez mais descentralizada",
        badge: "Evolução",
        currentPhase: {
          phase: "Fase Atual",
          title: "Fundação",
          status: "active",
          items: [
            "Transparência total de fundos",
            "Relatórios públicos mensais",
            "Verificação de plantios com GPS e fotos",
            "Registro público de todas as despesas"
          ]
        },
        v1Phase: {
          phase: "V1 (Em Breve)",
          title: "Participação",
          status: "upcoming",
          items: [
            "Sistema de votação para doadores",
            "Propostas comunitárias",
            "Seleção de zonas de plantio",
            "Priorização de projetos"
          ]
        },
        v2Phase: {
          phase: "V2 (Futuro)",
          title: "Descentralização",
          status: "future",
          items: [
            "Multi-assinatura on-chain para tesouraria",
            "NFTs de governança para doadores",
            "DAO comunitária",
            "Auditorias on-chain automatizadas"
          ]
        }
      },
      cta: {
        title: "Participe da Governança",
        description: "Como doador, você tem o direito de participar das decisões do projeto. Sua voz importa na construção desta floresta.",
        adoptTree: "Adotar uma Árvore",
        viewTransparency: "Ver Transparência"
      }
    },
    community: {
      title: "Vozes de Epuyén",
      subtitle: "Conheça as pessoas que estão construindo o futuro da floresta",
      badge: "Nossa Comunidade",
      featuredVoices: {
        title: "Vozes em Destaque",
        subtitle: "Histórias de quem torna a regeneração possível",
        person1: {
          name: "María del Carmen",
          role: "Viveirista Local",
          quote: "Cada muda que cultivo carrega um pedaço do meu coração. Saber que alguém no mundo vai adotá-la e acompanhar seu crescimento me enche de esperança.",
          location: "Epuyén, Chubut"
        },
        person2: {
          name: "Roberto Huenul",
          role: "Guarda Florestal Comunitário",
          quote: "Meu avô me ensinou a ler a floresta. Hoje ensino outros a protegê-la. Esta tecnologia nos ajuda a mostrar ao mundo o que fazemos.",
          location: "Lago Puelo"
        },
        person3: {
          name: "Laura Sepúlveda",
          role: "Bióloga",
          quote: "A ciência e a comunidade juntas podem alcançar o que nenhuma pode sozinha. Este projeto demonstra que a transparência gera confiança.",
          location: "El Bolsón"
        },
        person4: {
          name: "Martín Curruhuinca",
          role: "Comunidade Mapuche",
          quote: "A terra não é nossa, nós somos da terra. Cuidar dela é nossa responsabilidade ancestral e agora também global.",
          location: "Cushamen"
        },
        person5: {
          name: "Sofía Marinao",
          role: "Professora Rural",
          quote: "Meus alunos aprendem sobre a floresta plantando árvores. Ver o entusiasmo deles me confirma que o futuro está em boas mãos.",
          location: "Epuyén"
        },
        person6: {
          name: "Diego Fernández",
          role: "Brigadista Florestal",
          quote: "Cada incêndio me parte a alma. Por isso apoio a prevenção: mais floresta nativa, menos pinheiro, menos risco.",
          location: "Cholila"
        }
      },
      documentary: {
        title: "Documentário: Vozes da Floresta",
        description: "Uma jornada visual pelas histórias de quem dedica sua vida a proteger a Patagônia.",
        comingSoon: "Em Breve",
        watchTrailer: "Ver Trailer"
      },
      events: {
        title: "Próximos Eventos",
        subtitle: "Junte-se à nossa comunidade",
        event1: {
          title: "Plantio Comunitário",
          date: "15 Março 2025",
          location: "Viveiro Epuyén",
          description: "Jornada de plantio aberta a voluntários"
        },
        event2: {
          title: "Workshop de Monitoramento",
          date: "22 Abril 2025",
          location: "Centro Comunitário",
          description: "Aprenda a monitorar árvores com GPS"
        },
        event3: {
          title: "Assembleia Anual",
          date: "10 Maio 2025",
          location: "Virtual + Presencial",
          description: "Revisão de conquistas e planejamento 2025"
        }
      },
      shareStory: {
        title: "Tem uma História para Compartilhar?",
        description: "Se você faz parte da comunidade de Epuyén ou adotou uma árvore, adoraríamos conhecer sua história.",
        cta: "Compartilhar minha História"
      }
    },
    donate: {
      phasesAndMilestones: "Fases e Marcos",
      equipmentAndInfrastructure: "Equipamentos e Infraestrutura",
      totalEquipmentCost: "Custo Total do Equipamento",
      priority: "Prioridade",
      phase: "Fase",
      ofGoal: "de",
      active: "Ativo",
      pending: "Pendente",
      future: "Futuro",
      complete: "Completo"
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      confirm: "Confirmar",
      save: "Salvar",
      delete: "Excluir",
      edit: "Editar",
      view: "Ver",
      close: "Fechar",
      back: "Voltar",
      next: "Próximo",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todos",
      available: "Disponível",
      unavailable: "Indisponível",
      viewMore: "Ver mais",
      learnMore: "Saiba mais",
      targetArea: "Área Alvo",
      annualTarget: "Meta Anual",
      duration: "Duração",
      operations: "Operações",
      vesselLength: "Comprimento do Barco",
      pumpCapacity: "Capacidade da Bomba",
      crew: "Capacidade da Tripulação",
      propulsion: "Propulsão",
      fullTimeWorkers: "Trabalhadores em tempo integral",
      monthlyPerWorker: "Mensal por trabalhador",
      months: "meses",
      totalSalaries: "Total de Salários",
      chainsaws: "Motosserras",
      safetyEquipment: "Equipamento de Segurança",
      quantity: "Quantidade",
      costPerUnit: "Custo por Unidade",
      units: "unidades",
      total: "Total",
      manualDepiningCost: "Custo de Despinamento Manual",
      totalManualProgram: "Programa Manual Total",
      socialEnvironmentalImpact: "Impacto Social e Ambiental",
      transparency: "Transparência",
      thisPlanWill: "Este plano irá:",
      allWorkWillBe: "Todo trabalho será:",
      everyContributionSupports: "Cada contribuição apoia:"
    },
    footer: {
      tagline: "Restaurando a Patagônia, uma árvore de cada vez.",
      copyright: "© {year} Epuyén Renace. Todos os direitos reservados."
    }
  },
  ko: {
    // Navigation
    nav: {
      home: "홈",
      map: "지도",
      adopt: "입양하기",
      myForest: "내 숲",
      transparency: "투명성",
      admin: "관리자",
      login: "로그인",
      logout: "로그아웃",
      more: "더 보기",
      community: "커뮤니티",
      education: "교육",
      governance: "투명성",
      vision: "우리의 비전"
    },
    vision: {
      badge: "우리의 비전",
      title: "우리의 비전",
      opening: "우리의 비전은 생태학적으로 파괴된 장소를 투명성, 구조, 그리고 집단 행동을 통해 재건할 수 있다는 것을 세계에 보여주는 것입니다.",
      whatWeAre: {
        title: "Epuyén Renace란 무엇인가",
        description: "Epuyén Renace는 화재 후 재생 모델을 만들기 위해 존재합니다: 토지 복구, 생태 복원, 커뮤니티 개발이 맹목적인 신뢰가 아닌 검증 가능한 데이터에 의해 주도되는 시스템입니다."
      },
      transparency: {
        title: "블록체인 투명성",
        description: "블록체인 기술을 투명성 레이어로 사용함으로써 모든 기부, 모든 지출, 모든 행동을 공개적으로 추적할 수 있습니다. 투기를 위해서가 아니라 복구 노력이 어떻게 자금을 조달하고 실행되는지에 대한 신뢰를 회복하기 위해서입니다."
      },
      belief: {
        title: "우리가 믿는 것",
        description: "우리는 투명성이 부패를 대체하고 구조가 즉흥성을 대체할 때, 커뮤니티가 환경적 손실 이후에도 다시 일어설 수 있다고 믿습니다."
      },
      goal: {
        title: "우리의 목표",
        description: "우리의 목표는 Epuyén을 복원하는 것뿐만 아니라 생태 복구를 위한 새로운 경제 모델이 가능하다는 것을 증명하는 것입니다 — 전 세계 화재 피해 지역에서 복제할 수 있는 모델입니다."
      },
      closing: {
        line1: "재에서, 시스템은 재건될 수 있습니다.",
        line2: "파괴에서, 미래는 설계될 수 있습니다."
      }
    },
    // Landing Page
    landing: {
      heroTitle: "Epuyén과 함께 다시 태어나다",
      heroSubtitle: "나무를 입양하세요. 파타고니아를 복원하세요.",
      heroCta: "나무 입양하기",
      heroExplore: "지도 탐색하기",
      viewRoadmap: "로드맵 보기",
      missionTitle: "우리의 미션",
      missionText: "커뮤니티 재조림과 급진적 투명성 기술을 통해 아르헨티나 파타고니아의 토착 숲을 복원합니다.",
      restoringPatagonia: "복원하는",
      patagonia: "파타고니아",
      howItWorksTitle: "어떻게 작동하나요?",
      simpleProcess: "간단한 과정",
      step1Title: "지도 탐색",
      step1Text: "인터랙티브 지도를 탐색하고 입양할 수 있는 나무를 선택하세요.",
      step2Title: "나무 입양",
      step2Text: "기부하고 나무의 GPS 좌표가 포함된 고유한 토큰을 받으세요.",
      step3Title: "성장 추적",
      step3Text: "나무의 진행 상황에 대한 사진과 업데이트를 받으세요.",
      impactTitle: "우리의 영향",
      treesPlanted: "심은 나무",
      treesAdopted: "입양된 나무",
      donorsCount: "기부자",
      co2Offset: "CO₂ 상쇄량 (톤)",
      transparencyTitle: "완전한 투명성",
      transparencyText: "모든 기부와 지출은 공개적으로 검증 가능합니다. 비밀 없이, 오직 결과만.",
      viewTransparency: "공개 기록 보기",
      footerTagline: "파타고니아를 복원합니다, 한 그루씩.",
      whatHappened: {
        title: "Epuyén에 무슨 일이 있었나요?",
        year: "2025년과 2026년, Epuyén은 역사상 최악의 산불에 휩싸였습니다.",
        hectares: "9,000 헥타르 이상의 안데스 토착 숲이 파괴되었습니다.",
        ecosystems: "전체 생태계가 불탔습니다.",
        homes: "집들이 사라졌습니다.",
        wildlife: "야생동물이 사라졌습니다.",
        landExposed: "땅은 노출되고, 건조하고, 취약해졌습니다.",
        balanceBroken: "화재는 단순히 나무를 태운 것이 아닙니다 — 물, 토양, 기후를 보호하는 자연의 균형을 깨뜨렸습니다. 숲 덮개가 없으면 강우량이 감소하고, 침식이 증가하며, 미래 화재의 위험이 더욱 커집니다.",
        minimalEfforts: "재해의 규모에도 불구하고 복구 노력은 최소한이었습니다. 포괄적인 생태 복원 계획도, 장기적인 예방 전략도, 구조적 재건 프로그램도 없었습니다.",
        peopleStayed: "Epuyén 사람들은 남았습니다. 돌보고, 저항하고, 다시 시작하기 위해 남았습니다.",
        todayScars: "오늘날, 땅은 여전히 상처를 안고 있습니다 — 하지만 재생의 가능성도 함께.",
        epuyenCreated: "Epuyén Renace는 비극을 구조로 바꾸기 위해 만들어졌습니다: 토착 숲을 복원하고, 화재 위험을 줄이고, 생태적 균형을 재건하고, 이것이 다시는 일어나지 않도록 보장하기 위해.",
        fromAshes: "재에서 우연은 생기지 않는다: 미래는 의도, 진실, 그리고 공동체로 만들어진다."
      },
      coreChallenges: {
        title: "핵심 과제",
        mainChallenge: "Epuyén의 주요 과제는 소나무 제거입니다 — 경관을 점령한 침입 소나무 종의 대규모 제거입니다.",
        effectiveMethod: "현장 경험과 테스트를 통해 가장 효과적인 방법을 확인했습니다: 현장에서 소나무를 분쇄하여 유기물이 토양을 재생하도록 하는 것입니다. 제거하거나 태우는 대신.",
        processRestores: "이 과정은 습도를 복원하고, 토양 구조를 개선하며, 토착 숲 회복을 위한 즉각적인 조건을 만듭니다.",
        parallelReplanting: "동시에 재식재도 병행됩니다. 제거와 재생은 함께 이루어져야 합니다 — 몇 년 후가 아니라 — 침식과 침입종의 재정착을 방지하기 위해.",
        secondMission: "우리의 두 번째 주요 임무는 화재 예방과 미래 위험 감소입니다.",
        moreThanPlanting: "이것은 나무를 심는 것 이상을 필요로 합니다. 어려운 지형에서 작업하고 화재 위협에 신속하게 대응할 수 있는 전문 장비 획득을 포함한 영구적인 운영 능력이 요구됩니다.",
        foundationInvest: "이를 달성하기 위해 재단은 다음에 투자해야 합니다:",
        investList: {
          machinery: "임업 및 분쇄 기계",
          equipment: "지형 접근 가능 장비",
          tools: "연료 부하 감소 및 유지보수 도구",
          infrastructure: "장기 예방 인프라"
        },
        withoutEquipment: "이 장비 없이는 재생이 취약한 상태로 남고 파괴의 순환이 반복됩니다.",
        breakCycle: "Epuyén Renace는 그 순환을 끊기 위해 존재합니다 — 땅을 복원하고, 화재 위험을 줄이고, 미래를 위한 영구적인 예방 시스템을 구축함으로써."
      },
      donationCategories: {
        title: "기부 카테고리",
        subtitle: "기부금이 어떻게 사용될지 정확히 선택하세요",
        cta: {
          supportMission: "이 사명을 지원하세요",
          ctaDescription: "모든 기부금은 장비 구입과 이러한 단계 완료에 직접 사용됩니다. 모든 지출은 사진, 영수증, GPS 데이터와 함께 공개적으로 문서화됩니다.",
          donateToCategory: "이 카테고리에 기부",
          viewTransparency: "투명성 기록 보기"
        },
        category1: {
          icon: "🟫",
          title: "소나무 제거 및 산불 예방",
          description: "침입 소나무 종을 제거하고, 극심한 화재 위험을 줄이며, Epuyén의 남은 자생림을 보호하기 위한 5년간의 적극적인 예방 프로그램.",
          supports: "귀하의 기부는 영구적인 산불 예방 인프라, 지역 고용 및 장기적인 생태 안정성을 지원합니다.",
          items: [
            "침입 소나무 제거",
            "연료 부하 감소",
            "자생림 보호"
          ],
          method: "기계적 및 수동 소나무 제거 통합 전략",
          impact: "산불 강도의 직접적인 감소와 계곡의 장기적 보호",
          fiveYearPlan: {
            title: "5년 적극적 소나무 제거 계획",
            objective: "지속적인 예방 작업을 통해 Epuyén 계곡 전역의 산불 위험을 획기적으로 줄입니다.",
            targetArea: "약 4,500헥타르의 침입 소나무(죽은 것과 살아있는 것).",
            annualTarget: "연간 약 900헥타르 처리.",
            duration: "5년간 지속 운영.",
            operations: "기계와 수동 팀을 결합한 연중 현장 작업.",
            phases: {
              year1: {
                title: "긴급 안정화",
                description: "주택, 접근로 및 핵심 인프라 근처의 고위험 지역에 즉각 개입."
              },
              year2: {
                title: "확장 단계",
                description: "소나무가 우세한 더 넓은 지역으로 작업 확대 및 영구 예방 회랑 구축."
              },
              year3: {
                title: "계곡 깊숙한 곳 개입",
                description: "계곡 내부 지역 처리 및 혼합림 지역에서의 수동 소나무 제거 강화."
              },
              year4: {
                title: "유지보수 및 재성장 통제",
                description: "재성장 방지 및 장기적 내화성 강화를 위한 2차 개입."
              },
              year5: {
                title: "안정화 및 전환",
                description: "최종 위험 감소, 생태 모니터링, 장기 유지보수로의 전환."
              }
            },
            equipment: {
              title: "필요한 임업 장비",
              totalCost: "300만~580만 달러 (일회성 투자)",
              highVolumeMulchers: "밀집 소나무 지역용 대용량 임업 분쇄기.",
              accessMulchers: "경사면 및 접근 제한 지형용 소형 분쇄기.",
              excavators: "그래플과 보호 장치가 있는 임업용 굴삭기.",
              dozer: "방화대 및 접근로 유지보수용 도저.",
              loader: "물류 및 자재 취급용 휠 로더.",
              transport: "운송 트럭 및 서비스 차량."
            },
            capex: {
              title: "자본 투자 (CAPEX)",
              total: "영구적인 예방 능력을 창출하기 위해 한 번 구매하는 기계 및 인프라.",
              argentinaLanded: {
                title: "아르헨티나 도착 비용 (수입 + 물류)",
                learnMore: "자세히 보기",
                learnLess: "세부정보 숨기기",
                intro: "국제 \"기준 가격\"은 아르헨티나의 실제 비용이 아닙니다. 중장비 임업 기계는 수입세, 부가가치세, 통관, 항만 취급, 파타고니아까지의 내륙 운송, 지연 및 예비 부품 인플레이션으로 인해 상당히 더 비쌉니다.",
                points: [
                  "일반적인 수입 오버헤드는 장비 유형과 수입 경로에 따라 +40%에서 +90%를 추가할 수 있습니다.",
                  "NGO 면제는 나중에 존재할 수 있지만, 법적 등록 전에는 보장되지 않습니다. 잠재적 이점으로 취급하며, 가정하지 않습니다.",
                  "파타고니아까지의 내륙 운송과 항만 지연은 상당한 비용을 추가합니다.",
                  "아르헨티나에서 예비 부품은 비싸고 느립니다 — 10-15%의 준비 버퍼를 포함합니다 (가동 시간에 중요)."
                ],
                costBreakdown: {
                  title: "현실적인 비용 요약",
                  baseMachinery: "기본 기계 (국제 가격)",
                  baseRange: "~USD 300만-580만",
                  importTaxes: "수입/세금/물류 (아르헨티나)",
                  importRange: "+USD 240만-280만",
                  spareParts: "예비 부품/준비 버퍼 (10-15%)",
                  spareRange: "+USD 70만-100만",
                  totalLanded: "아르헨티나 예상 실제 도착 CAPEX",
                  totalRange: "USD 750만-820만"
                },
                disclaimer: "모든 예산은 아르헨티나의 현실적인 도착 비용 (세금, 파타고니아까지의 물류, 준비)을 반영합니다. 향후 면제는 비용을 줄이고 처리 헥타르를 늘립니다."
              }
            },
            soilComparison: {
              title: "원시림 토양 vs 소나무 조림지 토양",
              subtitle: "왜 화재는 소나무 숲에서 훨씬 빠르게 확산되는가",
              intro: "차이점은 나무뿐만이 아닙니다. 차이점은 그 아래의 전체 토양 시스템입니다.",
              native: {
                title: "원시림 토양",
                species: "코이우에, 렝가, 니레, 라달",
                description: "파타고니아 원시림은 다음을 만듭니다:",
                characteristics: [
                  "높은 유기적 다양성",
                  "깊은 부식질 층",
                  "균류 네트워크 (균근)",
                  "지속적인 수분 보유",
                  "스펀지 같은 구조",
                  "느린 분해",
                  "높은 미생물 활동"
                ],
                moisture: "25-45%",
                moistureLabel: "전형적인 토양 수분",
                moistureNote: "여름에도.",
                fireBehavior: {
                  title: "화재 행동:",
                  points: [
                    "불꽃이 낮게 유지됨",
                    "화재가 천천히 확산됨",
                    "자주 자연 소화됨",
                    "연속적이 아닌 패치로 연소",
                    "수관에 도달하기 어려움"
                  ]
                },
                spreadSpeed: "분당 0.1-0.5미터",
                spreadNote: "밤에 멈추는 경우가 많음."
              },
              pine: {
                title: "소나무 조림지 토양",
                warning: "소나무는 토양을 근본적으로 변화시킵니다.",
                characteristics: [
                  "산성 낙엽 (pH 3.5-4.5)",
                  "수지로 포화된 침엽",
                  "낮은 미생물 다양성",
                  "거의 균류 공생 없음",
                  "압축된 광물 토양",
                  "소수성 (물을 밀어냄)",
                  "빠른 건조"
                ],
                moisture: "5-12%",
                moistureLabel: "전형적인 토양 수분",
                moistureNote: "호수 근처에서도.",
                fireBehavior: {
                  title: "화재 행동:",
                  points: [
                    "쉽게 점화됨",
                    "화재가 연속적으로 이동",
                    "불꽃이 수직으로 상승",
                    "강렬한 복사열",
                    "수관이 빠르게 점화됨"
                  ]
                },
                spreadSpeed: "분당 5-20미터",
                spreadWind: "분당 40-60미터",
                spreadWindLabel: "바람이 있을 때:",
                spreadComparison: "100배 빠름."
              },
              publicQuote: "소나무는 단순히 불에 타는 것이 아니라 — 더 빨리 타도록 토양을 재설계합니다.",
              quoteNote: "이것은 과장이 아닙니다 — 이것은 물리학입니다.",
              whyWorks: {
                title: "소나무 제거가 효과적인 이유",
                intro: "소나무를 제거하면:",
                benefits: [
                  "토양 수분 상승",
                  "균류 복원",
                  "연료 연속성 차단",
                  "불꽃 높이 감소",
                  "화재 확산 속도 저하",
                  "자생 종이 돌아올 수 있음"
                ],
                conclusion: "그래서 예방이 효과가 있습니다."
              }
            },
            strategic: {
              title: "전략적 가치",
              establishes: "이 투자는 Epuyén에 영구적인 산불 예방 능력을 구축합니다.",
              items: [
                "장기적 연료 부하 감소",
                "신속 대응 예방 능력",
                "긴급 소방 비용 절감",
                "미래 화재에 대한 영토적 회복력"
              ],
              note: "이 인프라는 수십 년 동안 사용 가능합니다."
            },
            twoMethods: {
              intro: "소나무 제거는 단일 방법으로 달성할 수 없습니다.",
              approach: "계획은 생태 조건에 따라 두 가지 보완적 접근법을 통합합니다.",
              mechanical: {
                title: "기계적 소나무 제거",
                description: "침입 소나무가 완전히 지배하는 지역에서 사용.",
                items: [
                  "고속 연료 감소",
                  "대면적 처리",
                  "복원 준비"
                ],
                note: "자생림이 없는 곳에만 적용."
              },
              manual: {
                title: "수동/정밀 소나무 제거",
                description: "자생림이 남아 있는 곳에서 소나무를 선택적으로 제거.",
                zones: [
                  "소나무-자생림 혼합림",
                  "재생 지역",
                  "수로",
                  "주거 완충 지역"
                ],
                method: "훈련된 팀과 체인톱을 사용한 나무별 제거.",
                note: "생태적 피해 방지에 필수적."
              }
            },
            employment: {
              title: "지역 고용 프로그램",
              intro: "수동 소나무 제거는 안정적인 장기 고용을 창출합니다.",
              priority: "Epuyén 및 인근 커뮤니티 주민 우선 채용.",
              equipmentItems: [
                "전문 체인톱",
                "안전 장비",
                "유지보수 도구"
              ],
              manualCostCategories: [
                "급여",
                "도구 및 장비",
                "운영 안전"
              ]
            },
            conclusion: "이 5년 계획은 산불 예방을 긴급 대응에서 영구적인 영토 보호로 전환합니다.",
            costExplanation: {
              title: "비용 설명",
              intro: "효과적인 예방에는 지속적인 장기 투자가 필요합니다.",
              requirement: "단기 조치로는 화재 주기를 끊기에 불충분합니다.",
              integration: "계획은 기계, 인력, 유지보수 및 모니터링을 통합합니다.",
              mechanical: {
                title: "기계적 소나무 제거 비용",
                description: "중장비로 대규모 개입이 가능합니다.",
                capability: "소나무가 우세한 고위험 지역의 신속한 처리를 가능하게 합니다.",
                includes: "모든 기계 관련 작업을 포함합니다.",
                items: [
                  "임업 분쇄기",
                  "굴삭기 및 도저",
                  "운송 물류",
                  "연료",
                  "유지보수",
                  "예비 부품",
                  "현장 작업"
                ],
                oneTimeInvestment: "일회성 투자",
                oneTimeRange: "300만~580만 달러",
                operationalCost: "운영 비용 (5년)",
                operationalRange: "610만~1,070만 달러",
                note: "영구적인 예방 인프라 창출."
              },
              manual: {
                title: "수동 소나무 제거 비용",
                description: "기계를 안전하게 사용할 수 없는 곳에서 필요합니다.",
                limitation: "중장비는 자생림을 손상시킵니다.",
                requirement: "선택적 인적 개입이 필수적입니다.",
                whereApplied: "민감한 생태 지역에 적용됩니다.",
                zones: [
                  "혼합림",
                  "하천변 지역",
                  "주택 근처",
                  "재생 지역",
                  "높은 생태 가치 지역"
                ],
                includes: "인력 및 장비를 포함합니다.",
                items: [
                  "50명의 정규직 근로자",
                  "전문 체인톱",
                  "보호 장비",
                  "도구 및 유지보수",
                  "운영 안전"
                ],
                workers: "50명의 근로자",
                salary: "월 1,000달러",
                duration: "5년",
                totalCost: "총 비용",
                totalAmount: "312.5만 달러"
              },
              totalCost: {
                title: "5년 예방 총 비용",
                componentHeader: "구성 요소",
                costHeader: "비용",
                components: [
                  { category: "기계 투자", cost: "300만~580만 달러" },
                  { category: "기계 운영 (5년)", cost: "610만~1,070만 달러" },
                  { category: "수동 소나무 제거 (5년)", cost: "312.5만 달러" }
                ],
                total: "프로그램 총 비용",
                totalRange: "1,220만~1,960만 달러"
              },
              delivers: {
                title: "이 계획이 제공하는 것",
                intro: "5년에 걸쳐 프로그램은 다음을 제공합니다:",
                items: [
                  "산불 위험의 대폭적인 감소",
                  "연료 부하 제거",
                  "자생림 보호",
                  "토양 및 수분 회복",
                  "영구 예방 회랑",
                  "지역 고용 안정",
                  "미래 긴급 비용 절감",
                  "장기적 생태 회복력"
                ],
                notEmergency: "이것은 긴급 대응이 아닙니다.",
                structural: "이것은 구조적인 산불 예방입니다."
              },
              whyFiveYears: {
                title: "왜 5년인가?",
                intro: "생태계는 몇 달 만에 안정화되지 않습니다.",
                allows: "5년의 기간은 다음을 가능하게 합니다:",
                items: [
                  "주요 침입 소나무 제거",
                  "재성장 방지",
                  "토양 안정화",
                  "자연 재생 지원",
                  "장기적 위험 감소"
                ],
                conclusion: "더 짧은 기간은 화재 주기를 끊을 수 없습니다."
              },
              transparency: {
                title: "투명성",
                intro: "모든 자금은 공개적으로 추적 가능합니다.",
                items: [
                  "지리적으로 위치가 지정된 작업 구역",
                  "처리된 헥타르 보고",
                  "월간 업데이트",
                  "시각적 문서화",
                  "공개 투명성 대시보드"
                ],
                conclusion: "모든 기부는 검증 가능합니다."
              }
            }
          }
        },
        category2: {
          icon: "🚒",
          title: "Epuyén 호수 소방 보트 시스템",
          description: "이 카테고리는 신속한 배치와 대용량 펌핑이 가능한 영구적인 수상 소방 유닛을 구축합니다.",
          supports: "기부금은 다음을 지원합니다:",
          items: [
            "전문 소방 선박",
            "산업용 대용량 펌프 시스템",
            "호스 시스템 및 릴",
            "전기/하이브리드 추진",
            "안전 및 소방 장비"
          ],
          objective: "목표는 Epuyén 호수를 수동적 요소에서 능동적 화재 방어 자산으로 변환하는 것입니다.",
          impact: "이 카테고리는 몇 분 내에 대응 능력으로 생명, 숲, 인프라를 보호합니다.",
          boatSystem: {
            title: "Epuyén 호수 소방 보트 시스템",
            subtitle: "수상 신속 화재 대응 유닛",
            objective: "신속한 배치, 대용량 물 펌핑, 지상 부대 지원이 가능한 영구적 소방 보트 유닛을 구축하여 Epuyén 호수를 수동적 요소에서 능동적 화재 방어 자산으로 변환합니다.",
            vesselLength: "9-12 미터",
            pumpCapacity: "4,000-8,000 L/분",
            crew: "소방관 6-10명",
            propulsion: "전기/하이브리드",
            challengesTitle: "왜 수상 대응인가?",
            challengesIntro: "Epuyén의 지형은 세 가지 주요 도전을 만듭니다:",
            challenges: [
              "가파른 숲 경사면",
              "제한된 도로 접근",
              "강한 계곡 바람"
            ],
            solutionStatement: "수상 대응은 세 가지 모두를 해결합니다.",
            capabilitiesTitle: "보트는:",
            capabilities: [
              "트럭보다 빠르게 화재 전선에 도달",
              "호수에서 무제한 물 펌핑",
              "도로가 차단되어도 운영 가능",
              "경사면 아래에서 화재 공격",
              "대응 시간 60-80% 단축"
            ],
            capex: {
              title: "총 투자 (CAPEX)",
              total: "총 투자"
            },
            strategic: {
              title: "전략적 가치",
              establishes: "이 시스템은 다음을 창출합니다:",
              items: [
                "영구적인 수상 소방 능력",
                "몇 분 내 신속 대응 능력",
                "더 낮은 진화 비용",
                "화재 확산 확률 감소",
                "주택, 숲, 수원 보호"
              ],
              note: "Epuyén 호수를 수동적 요소에서 능동적 화재 방어 자산으로 변환합니다."
            },
            conclusion: "Epuyén 호수의 전용 소방 보트는 산불 예방 및 대응에서 가장 효율적인 투자 중 하나입니다. 호수를 최전선 방어 시스템으로 변환하여 화재가 재난이 되기 전에 계곡을 보호합니다."
          }
        },
        category3: {
          icon: "🌱",
          title: "재조림 및 미래 보존",
          description: "이 카테고리는 Epuyén의 장기적인 생태 복구를 지원합니다.",
          supports: "기부금은 다음에 사용됩니다:",
          items: [
            "토착 나무 식재",
            "묘목장 개발",
            "토양 재생",
            "장기 유지보수",
            "생물다양성 복원",
            "재생 지역 모니터링 및 보호"
          ],
          impact: "이것은 복원된 숲이 살아남고, 성숙하고, 미래 세대를 위해 보호되도록 보장합니다."
        },
        category4: {
          icon: "♻️",
          title: "폐기물 관리 및 오염",
          description: "현장 관찰과 커뮤니티 대화를 통해 Epuyén이 심각한 노천 폐기물과 오염 문제에 직면해 있음을 확인했습니다.",
          supports: "현재 집중 분야:",
          items: [
            "기존 폐기물 흐름 이해",
            "오염 위험 식별",
            "노천 투기 구역 매핑",
            "환경 및 건강 영향 연구",
            "유사한 농촌 커뮤니티의 실행 가능한 모델 검토"
          ],
          objective: "목표는 해결책을 강요하는 것이 아니라 Epuyén의 규모와 지리에 적합한 현실적이고 지속 가능한 해결책을 구축하는 것입니다.",
          impact: "오염 해결은 수원 보호, 생태계 복원, 커뮤니티의 건강한 미래 보장에 필수적입니다.",
          researchPhase: {
            title: "폐기물 관리 및 오염",
            currentPhase: "연구 및 진단 단계",
            context: "현장 관찰과 커뮤니티 대화를 통해 Epuyén이 토양, 물, 공중 보건에 장기적 위험을 초래하는 비공식 투기 구역을 포함한 심각한 노천 폐기물과 오염 문제에 직면해 있음을 확인했습니다.",
            statement: "이 문제는 즉흥적이거나 고립된 조치로는 해결할 수 없습니다.",
            focusTitle: "현재 집중 분야:",
            focusAreas: [
              "기존 폐기물 흐름 이해",
              "오염 위험 식별",
              "노천 투기 구역 매핑",
              "환경 및 건강 영향 연구",
              "유사한 농촌 및 산악 커뮤니티에서 사용된 실행 가능한 모델 검토"
            ],
            requirement: "폐기물 관리에는 기술적 정확성, 규제 조정, 장기 계획이 필요합니다.",
            ethos: "우리 원칙의 일환으로 적절한 연구 없이는 어떤 해결책도 발표하지 않습니다.",
            commitment: "이 평가 단계가 완료되면 Epuyén Renace는 커뮤니티 검토와 기관 대화에 열린 명확하고 공개적이며 투명한 폐기물 관리 제안을 발표할 것입니다.",
            objective: "목표는 해결책을 강요하는 것이 아니라 Epuyén의 규모와 지리에 적합한 현실적이고 지속 가능한 해결책을 구축하는 것입니다.",
            importance: "오염 해결은 수원 보호, 생태계 복원, 커뮤니티의 건강한 미래 보장에 필수적입니다."
          }
        },
        transparency: {
          title: "카테고리별 투명성",
          description: "각 기부 카테고리에는:",
          items: [
            "전용 예산",
            "공개 진행 상황 추적",
            "문서화된 지출",
            "사진, GPS 데이터 및 보고서",
            "블록체인 기반 투명성 기록"
          ],
          verify: "기부자는 기부금이 어떻게 사용되는지 정확히 선택하고 각 단계에서 그 영향을 확인할 수 있습니다."
        },
        oneSystem: {
          title: "하나의 시스템, 다섯 가지 미션",
          depining: "소나무 제거는 위험을 줄입니다.",
          firefighting: "소방은 비상시 보호합니다.",
          reforestation: "재조림은 생명을 복원합니다.",
          contamination: "폐기물 관리는 물과 건강을 보호합니다.",
          biosphere: "생물권 공원은 지속 가능한 미래를 구축합니다.",
          together: "함께, 그들은 Epuyén을 위한 완전하고 영구적인 화재 후 복구 모델을 형성합니다 — 조직, 기술, 진정한 헌신이 있을 때 장소가 다시 일어설 수 있음을 증명합니다."
        }
      }
    },
    roadmap: {
      title: "로드맵",
      subtitle: "땅을 재생하고 Epuyén에 미래를 주기 위한 장기 시스템. 정치도 자선도 아닌 — 검증 가능한 행동.",
      thePlan: "계획",
      active: "진행 중",
      upcoming: "예정",
      comingSoon: "곧 출시",
      rAndD: "R&D",
      vision: "비전",
      future: "미래",
      goal: "목표",
      raised: "모금액",
      totalGoal: "총 목표",
      treesAdopted: "입양된 나무",
      projectPhases: "프로젝트 단계",
      progress: "진행률",
      everyContribution: "모든 기부가 목표에 가까워지게 합니다",
      phase0: {
        title: "기반 + 디지털 투명성",
        description: "Epuyén Renace 재단 설립, 공개 웹사이트 + 로드맵 출시, 드론/LiDAR 디지털 맵 구성, 구역 정의, KPI, 비용 모델 및 기부/지출 추적을 위한 블록체인 시스템.",
        tags: ["웹", "3D 지도", "블록체인", "법적 재단"],
        status: "초기 설정"
      },
      phase1: {
        title: "재조림 스프린트",
        description: "토착 나무 10,000그루 식재. 각 나무 비용 ~USD $25, GPS, 사진, 상태 타임라인 및 공개 기록으로 추적.",
        tags: ["10,000 나무", "GPS 추적", "사진", "공개 기록"],
        treesAdopted: "나무 입양됨",
        available: "사용 가능"
      },
      phase2: {
        title: "위험 감소 + 확장",
        description: "침입 소나무 5,000그루 제거, 토착 나무 20,000그루 식재, 소나무를 멀치로 처리하고 연료 하중을 줄이기 위한 칩퍼 2대 구입.",
        tags: ["5,000 소나무 제거", "20,000 토착종", "칩퍼 2대"],
        proof: "증거 게시: 제거 기록 + 식재 배치 + 영수증"
      },
      phase3: {
        title: "파타고니아 화재 방지 혁신",
        description: "하이브리드 독점 화재 진압 시스템 설계 및 구축: 물/보트 용량 + 드론 + 지상 대응. 목표: 원격 지역에서 조기 탐지 + 신속한 억제.",
        tags: ["드론", "하이브리드 차량", "조기 탐지", "오픈 R&D"],
        milestones: "명확한 이정표, 프로토타입 및 공개 보고서"
      },
      phase4: {
        title: "33헥타르 공공 생물권 공원",
        description: "33헥타르 구매, Epuyén Renace 재단 소유. 생물다양성 복원 구역, 침입종 교육, 재생 식품 생산 시연, 가공 센터, 카페테리아, 호숫가 레스토랑 + 부두, 교육 센터를 갖춘 공공 생물권 공원으로 설계.",
        tags: ["33헥타르", "교육 센터", "호수 레스토랑", "부두", "지역 생산"],
        purpose: "영구 보호 + 일자리 + 교육 + 지속 가능한 지역 경제"
      },
      phase5: {
        title: "완전한 SaaS 플랫폼",
        description: "Epuyén이 디지털 트윈이 됩니다. 드론/LiDAR 측량 지도: 나무 계수 및 등록, 1 나무 = 1 토큰/인증서, 입양 인터랙티브 마켓플레이스, 온체인 + 오프체인 투명성 대시보드, 자원봉사자/커뮤니티 모듈, 보고 및 감사 도구.",
        tags: ["디지털 트윈", "LiDAR", "NFT 토큰", "온체인", "감사"],
        scalable: "다른 보전 프로젝트로 확장 가능한 모델"
      },
      summary: {
        foundation: "재단",
        trees10k: "10K 나무",
        expansion: "확장",
        fireFighting: "화재 방지",
        park33ha: "33헥타르 공원",
        platform: "플랫폼"
      }
    },
    governance: {
      title: "거버넌스",
      subtitle: "투명하고 민주적인 의사결정 구조",
      principles: {
        title: "우리의 원칙",
        radical: {
          title: "급진적 투명성",
          description: "모든 재정 결정과 지출은 공개적으로 검증 가능합니다."
        },
        community: {
          title: "커뮤니티 중심",
          description: "Epuyén 지역 주민들이 모든 주요 결정에 발언권을 가집니다."
        },
        verified: {
          title: "검증된 영향",
          description: "모든 주장은 데이터, 사진 및 GPS 좌표로 뒷받침됩니다."
        }
      },
      structure: {
        title: "거버넌스 구조",
        council: {
          title: "지역 위원회",
          description: "Epuyén 주민들로 구성된 5인 위원회가 프로젝트 결정을 감독합니다."
        },
        technical: {
          title: "기술 위원회",
          description: "생태학자, 임업 전문가, 블록체인 개발자로 구성된 자문 그룹."
        },
        donors: {
          title: "기부자 어셈블리",
          description: "나무 토큰 보유자가 분기별 업데이트에 참여하고 주요 이니셔티브에 투표할 수 있습니다."
        }
      },
      voting: {
        title: "투표 메커니즘",
        description: "주요 결정은 토큰 보유자 투표를 통해 이루어지며, 1 토큰 = 1 투표입니다."
      }
    },
    education: {
      title: "숲에 대해 배우기",
      subtitle: "지식은 힘입니다. 생태계를 이해하는 것이 보호의 첫 걸음입니다. 파타고니아 숲에 대해 알아야 할 모든 것을 여기서 찾을 수 있습니다.",
      badge: "환경 교육",
      nativeForest: {
        title: "파타고니아 토착 숲",
        subtitle: "우리가 보호하는 종들을 만나보세요",
        lenga: {
          title: "렝가 (Nothofagus pumilio)",
          description: "30미터까지 자랄 수 있는 낙엽수입니다. 가을에 잎이 빨갛고 금색으로 변하며 장관을 이룹니다. 안데스-파타고니아 숲의 생물다양성에 필수적입니다."
        },
        coihue: {
          title: "코이우에 (Nothofagus dombeyi)",
          description: "500년 이상 살 수 있는 상록수입니다. 수십 종의 새와 포유류에게 피난처와 먹이를 제공합니다. 목재는 귀중하지만 생태적 가치는 헤아릴 수 없습니다."
        },
        cipres: {
          title: "산악 사이프러스",
          description: "1000년 이상 살 수 있는 토착 침엽수입니다. 파타고니아 기후에 적응한 강인한 나무로, 영속성과 회복력의 상징입니다."
        }
      },
      invasiveSpecies: {
        title: "침입종",
        subtitle: "소나무와 기타 위협의 문제",
        pine: {
          title: "침입 소나무",
          description: "상업적 조림을 위해 도입된 소나무는 공격적으로 퍼져 토착 숲을 대체합니다. 토양을 산성화하고, 생물다양성을 줄이며, 화재 위험을 극적으로 증가시킵니다.",
          impact: "높음"
        },
        rosehip: {
          title: "로즈힙",
          description: "식용 열매를 생산하지만, 이 유럽 종은 빠르게 퍼져 토착 식생과 자원을 두고 경쟁합니다.",
          impact: "중간"
        },
        broom: {
          title: "레타모",
          description: "매우 인화성이 높은 관목으로 황폐화된 지역에 정착하여 토착 숲의 재생을 어렵게 합니다.",
          impact: "높음"
        }
      },
      fireRisk: {
        title: "화재 위험",
        subtitle: "위협을 이해하고 예방하기",
        whyPinesDangerous: {
          title: "왜 소나무가 위험한가요?",
          description: "소나무는 매우 인화성이 높은 수지를 함유합니다. 소나무 숲은 토착 숲보다 10배 빠르게 탈 수 있습니다. 또한 밀집된 수관은 가장 파괴적인 수관화의 확산을 촉진합니다."
        },
        nativeForestRole: {
          title: "토착 숲의 역할",
          description: "렝가와 같은 토착 나무는 수분 함량이 높고 수지가 적습니다. 건강한 토착 숲은 자연 방화대 역할을 하며 화재 후 더 잘 회복됩니다."
        },
        communityPrevention: {
          title: "커뮤니티 예방",
          description: "소나무 제거, 방화대 조성, 조기 감지 시스템이 필수적입니다. 심은 모든 토착 나무가 위험 감소에 기여합니다."
        }
      },
      biodiversity: {
        title: "생물다양성",
        subtitle: "숲에 의존하는 생명",
        fauna: {
          title: "상징적인 동물군",
          description: "후에물(멸종위기 파타고니아 사슴), 푸두(세계에서 가장 작은 사슴), 퓨마, 그리고 수십 종의 새가 토착 숲에 의존합니다."
        },
        lifeNetwork: {
          title: "생명의 네트워크",
          description: "각 토착 나무는 균류, 이끼, 곤충, 새, 포유류의 네트워크를 지탱합니다. 이 생물다양성은 소나무 농장에는 존재하지 않습니다."
        },
        corridors: {
          title: "생물 회랑",
          description: "숲을 복원함으로써 동물들이 이동하고, 짝을 찾고, 건강한 개체군을 유지할 수 있는 회랑을 만듭니다."
        }
      },
      waterCycle: {
        mainTitle: "숲이 비를 가져오고 물을 보호하는 방법",
        howRainWorks: "비가 작동하는 방식",
        whyForests: "그리고 숲이 자연의 물 시스템인 이유",
        intro1: "지구가 살아있는 몸이라고 상상해보세요.",
        intro2: "숲은 단순히 나무가 아닙니다 — 물이 움직이고, 쉬고, 돌아오도록 돕는 기관입니다.",
        letsSeee: "어떻게 작동하는지 봅시다 👇",
        whereRainComes: {
          title: "비는 어디서 오나요?",
          content: "태양이 지구를 데울 때:\n• 호수와 강이 공기 중으로 물을 방출합니다\n• 나무가 잎을 통해 물을 방출합니다\n\n이 물은 보이지 않는 수증기가 되어 하늘로 올라갑니다.\n\n충분한 수증기가 모이면 구름이 생깁니다.\n\n구름이 무거워지면 — 🌧️ 비가 내립니다.\n\n**나무는 구름 형성을 돕습니다.**\n\n나무가 없으면 구름이 덜 형성됩니다."
        },
        treesBreathe: {
          title: "나무는 물을 하늘로 내뿜습니다",
          content: "나무는 뿌리로 땅의 물을 마십니다.\n\n그런 다음 잎을 통해 그 물의 일부를 방출합니다.\n\n이것을 **증발산**이라고 하지만, 이렇게 생각할 수 있습니다:\n\n*나무가 공기 중으로 물을 내쉽니다.*\n\n수백만 그루의 나무가 함께 숨쉬면:\n• 습도\n• 더 시원한 공기\n• 더 많은 비 가능성이 생깁니다\n\n그래서 숲은 자체 기후를 만듭니다."
        },
        whenRainFalls: {
          title: "비가 내리면 어떻게 되나요?",
          content: "비가 건강한 숲에 내릴 때:\n• 잎이 비를 늦춥니다\n• 뿌리가 토양을 엽니다\n• 물이 부드럽게 땅속으로 침투합니다\n\n토양은 스펀지가 됩니다.\n\n이 물은 저장되어 몇 달에 걸쳐 천천히 방출됩니다.\n\n이 물은 다음을 먹여살립니다:\n• 샘\n• 시내\n• 호수\n• 동물\n• 사람\n\n그래서 숲은 **물의 수호자**라고 불립니다."
        },
        forestsGiveMemory: {
          title: "숲은 물에 기억을 줍니다",
          content: "숲은 물이 머무르도록 돕습니다.\n\n모든 비가 한꺼번에 빠져나가지 않게 합니다.\n\n**그들은 물을 기억합니다.**\n\n이것을 *물의 기억*이라고 합니다.\n\n숲 덕분에:\n• 호수가 빨리 마르지 않습니다\n• 여름에도 강이 흐릅니다\n• 우물이 사라지지 않습니다\n\n숲이 없으면 물은 잊습니다."
        },
        whenForestsBurn: {
          title: "숲이 불타면 어떻게 되나요?",
          content: "숲이 불타면:\n• 토양이 딱딱해집니다\n• 물이 땅속으로 들어갈 수 없습니다\n• 비가 빠르게 흘러갑니다\n• 홍수가 발생합니다\n• 그 다음 긴 건조 기간이 옵니다\n\n화재 후 우리는 종종 봅니다:\n• 한꺼번에 너무 많은 물\n• 그 다음에는 충분하지 않은 물\n\n**이것은 호수에 매우 위험합니다.**"
        },
        canValleyHelp: {
          title: "한 계곡이 다른 계곡을 도울 수 있나요?",
          content: "때때로 근처 계곡의 숲이 습기와 구름을 가져오는 데 도움이 됩니다.\n\n이것은 조금 도움이 될 수 있습니다.\n\n하지만 물은 산을 통해 땅속으로 멀리 이동할 수 없습니다.\n\n그것은 의미합니다:\n\n**각 계곡은 자체 숲을 보호해야 합니다.**\n\n비는 하늘에서 올 수 있지만 —\n물은 땅에 의해 지켜져야 합니다."
        },
        whyNativeSpecial: {
          title: "토착 숲이 특별한 이유",
          content: "토착 숲은:\n• 자연적으로 여기서 자랐습니다\n• 토양을 보호합니다\n• 물이 땅속으로 들어가게 합니다\n• 화재에 더 잘 견딥니다\n• 재해 후 생명이 돌아오도록 돕습니다\n\n그들은 땅과 함께 일합니다.\n\n**그들은 여기에 속합니다.**"
        },
        forestsNotDecoration: {
          title: "숲은 장식이 아닙니다",
          content: "숲은 단순히 아름답지 않습니다.\n\n그들은:\n• **물 창조자**\n• **물 수호자**\n• **기후 보호자**\n• **생명 유지자**입니다\n\n숲이 없으면:\n• 호수가 약해집니다\n• 비가 불규칙해집니다\n• 땅이 마릅니다\n• 화재 위험이 커집니다"
        },
        simpleTruth: {
          title: "단순한 진실",
          noForest: "숲 없음 = 물의 미래 없음",
          withForests: "하지만 숲과 함께:",
          rainReturns: "비가 돌아옵니다",
          springsRecover: "샘이 회복됩니다",
          lakesSurvive: "호수가 살아남습니다",
          lifeContinues: "생명이 계속됩니다",
          whenWeProtect: "숲을 보호할 때, 내일을 보호합니다.",
          protectNow: "지금 나무 보호하기"
        }
      },
      resources: {
        title: "추가 자료",
        subtitle: "지식을 깊게 하기 위한 자료",
        guide: {
          title: "토착 종 가이드",
          type: "PDF",
          description: "파타고니아 토착 나무의 식별과 특성"
        },
        documentary: {
          title: "다큐멘터리: 위험에 처한 숲",
          type: "비디오",
          description: "파타고니아 숲의 역사와 현재의 도전"
        },
        interactiveMap: {
          title: "프로젝트 인터랙티브 맵",
          type: "인터랙티브",
          description: "식재 및 복원 지역 탐색"
        }
      }
    },
    community: {
      title: "커뮤니티",
      subtitle: "Epuyén을 재건하는 사람들",
      voices: {
        title: "Epuyén의 목소리",
        subtitle: "지역 주민들이 전하는 이야기",
        testimonials: {
          testimonial1: {
            name: "마리아 후아이킬렌",
            role: "지역 주민, 68세",
            quote: "불이 올 때, 나는 도망가지 않았다. 이곳은 내 땅이고, 부모님이 묻힌 곳이야. 그래서 우리는 다시 심어. 산은 우리에게 모든 것을 주었거든. 이제 우리가 갚을 차례야."
          },
          testimonial2: {
            name: "루이스 나후엘판",
            role: "목축업자, 52세",
            quote: "많은 것을 잃었지만, 지역사회의 반응이 놀라웠어. 함께 새로운 것을 건설하고 있고, 도움을 주는 모든 사람들에게 감사해."
          },
          testimonial3: {
            name: "소피아 쿠란카",
            role: "교사, 35세",
            quote: "숲의 회복 뒤에는 가족, 아이들, 수십 년의 기억이 있어. 재조림은 토지와 역사의 회복이야."
          }
        }
      },
      partners: {
        title: "파트너 및 협력자",
        subtitle: "함께 변화를 만들어가는 조직들"
      },
      joinUs: {
        title: "함께하기",
        volunteer: {
          title: "자원봉사",
          description: "식재 행사와 모니터링 활동에 참여하세요."
        },
        donate: {
          title: "기부하기",
          description: "나무를 입양하거나 일반 기부로 프로젝트를 지원하세요."
        },
        spread: {
          title: "소문내기",
          description: "소셜 미디어에서 우리의 미션을 공유하세요."
        }
      },
      documentary: {
        title: "다큐멘터리: 숲의 목소리",
        description: "파타고니아를 보호하는 데 삶을 바친 사람들의 이야기를 담은 시각적 여정.",
        comingSoon: "곧 출시",
        watchTrailer: "트레일러 보기"
      },
      events: {
        title: "예정된 이벤트",
        subtitle: "커뮤니티에 참여하세요",
        event1: {
          title: "커뮤니티 식재",
          date: "2025년 3월 15일",
          location: "Epuyén 묘목장",
          description: "자원봉사자를 위한 식재 행사"
        },
        event2: {
          title: "모니터링 워크숍",
          date: "2025년 4월 22일",
          location: "커뮤니티 센터",
          description: "GPS로 나무를 모니터링하는 방법을 배우세요"
        },
        event3: {
          title: "연례 총회",
          date: "2025년 5월 10일",
          location: "온라인 + 오프라인",
          description: "성과 검토 및 2025 계획"
        }
      },
      shareStory: {
        title: "공유할 이야기가 있으신가요?",
        description: "Epuyén 커뮤니티의 일원이거나 나무를 입양하셨다면, 당신의 이야기를 듣고 싶습니다.",
        cta: "내 이야기 공유하기"
      }
    },
    donate: {
      phasesAndMilestones: "단계 및 이정표",
      equipmentAndInfrastructure: "장비 및 인프라",
      totalEquipmentCost: "총 장비 비용",
      priority: "우선순위",
      phase: "단계",
      ofGoal: "목표의",
      active: "진행 중",
      pending: "대기 중",
      future: "미래",
      complete: "완료"
    },
    common: {
      loading: "로딩 중...",
      error: "오류",
      success: "성공",
      cancel: "취소",
      confirm: "확인",
      save: "저장",
      delete: "삭제",
      edit: "편집",
      view: "보기",
      close: "닫기",
      back: "뒤로",
      next: "다음",
      search: "검색",
      filter: "필터",
      all: "전체",
      available: "가능",
      unavailable: "불가능",
      viewMore: "더 보기",
      learnMore: "자세히 보기",
      targetArea: "목표 면적",
      annualTarget: "연간 목표",
      duration: "기간",
      operations: "운영",
      vesselLength: "선체 길이",
      pumpCapacity: "펌프 용량",
      crew: "승무원 정원",
      propulsion: "추진 시스템",
      fullTimeWorkers: "정규직 근로자",
      monthlyPerWorker: "근로자당 월급",
      months: "개월",
      totalSalaries: "총 급여",
      chainsaws: "체인톱",
      safetyEquipment: "안전 장비",
      quantity: "수량",
      costPerUnit: "단가",
      units: "대",
      total: "합계",
      manualDepiningCost: "수동 소나무 제거 비용",
      totalManualProgram: "수동 프로그램 합계",
      socialEnvironmentalImpact: "사회적 및 환경적 영향",
      transparency: "투명성",
      thisPlanWill: "이 계획은:",
      allWorkWillBe: "모든 작업은:",
      everyContributionSupports: "모든 기부는 다음을 지원합니다:"
    },
    footer: {
      tagline: "파타고니아를 복원합니다, 한 그루씩.",
      copyright: "© {year} Epuyén Renace. 모든 권리 보유."
    }
  }
};
export default translations;
